// Operator-facing text (R7.17: localised; instance text is translatable configuration).
// Swedish is the site language; English is kept for development and other sites. GS1 data
// titles are deliberately not translated: they are what is printed on the label.

export type Lang = "sv" | "en";

const sv = {
  "app.name": "trail",
  "menu.area.receiving": "Mottagning",
  "menu.area.receiving.desc": "Inleverans, inlagring",
  "menu.area.receiving.waiting": "{n} att lagra in",
  "menu.area.receiving.deliveries": "{n} leveranser väntar",
  "menu.pallet.deliveries": "{n} öppna inköpsordrar att ta emot",
  "menu.count.rounds": "{n} runda öppen",
  "menu.scanHint": "Skanna vad som helst här för att slå upp det.",
  "menu.release": "Frisläpp plockade ordrar",
  "menu.release.desc": "Plockade ordrar som väntar på frisläppning",
  "menu.ship": "Lastning",
  "menu.ship.desc": "Plockade ordrar som står på golvet · läs ut när bilen går",
  "ship.title": "Lastning",
  "ship.listTitle": "Plockade ordrar på golvet",
  "ship.listSub": "Skanna pallens SSCC eller ordernumret, eller välj i listan. Lastad = godset har lämnat byggnaden.",
  "ship.waiting": "{n} väntar",
  "ship.none": "Inga plockade ordrar väntar på lastning.",
  "ship.row": "plockad {at} av {by} · {pallets} pall · {carrier}",
  "ship.notFound": "Ingen plockad order väntar med {code}.",
  "ship.confirmTitle": "Lastad?",
  "ship.confirmSub": "Plockad {at} av {by} · {pallets} pall",
  "ship.hint": "Pallen och kollina lämnar lagret i Trail. Affärssystemet rörs inte; fakturan styrs därifrån.",
  "ship.do": "Lastad",
  "ship.done": "Lastad",
  "ship.unreported": "Ej rapporterad",
  "ship.reportPending": "Rapport på väg",
  "ship.blocked": "Kan inte lastas",
  "ship.doneMsg": "{n} order har lämnat byggnaden.",
  "ship.partly": "Delvis",
  "ship.partlyMsg": "{ok} av {n} ordrar lastade; resten står kvar i listan.",
  "ship.all": "Lasta alla {carrier} ({n})",
  "ship.allConfirm": "Lasta alla {n} ordrar till {carrier}?",
  "release.title": "Frisläpp",
  "release.listTitle": "Plockade ordrar",
  "release.listSub": "Skanna pallens SSCC eller ordernumret, eller välj i listan. Frisläppt = saldot lämnar affärssystemet.",
  "release.scan": "skanna pall eller order …",
  "release.waiting": "{n} väntar",
  "release.none": "Inga plockade ordrar väntar på frisläppning.",
  "release.row": "plockad {at} av {by} · {pallets} pall · {carrier}",
  "release.pickup": "hämtas",
  "release.notFound": "Ingen plockad order väntar med {code}.",
  "release.confirmTitle": "Frisläpp ordern?",
  "release.confirmSub": "Plockad {at} av {by} · {pallets} pall",
  "release.line": "Rad {n}",
  "release.hint": "Saldot lämnar affärssystemet och ordern kan faktureras. Följesedeln kan skrivas ut redan nu.",
  "release.do": "Frisläpp",
  "release.done": "Frisläppt",
  "release.doneMsg": "{n} order frisläppt.",
  "release.partly": "Delvis",
  "release.partlyMsg": "{ok} av {n} frisläppta; resten ligger kvar i listan.",
  "release.all": "Frisläpp alla för {carrier}",
  "release.allConfirm": "Frisläpp {n} ordrar för {carrier}?",
  "pick.manual": "Utan skanning",
  "pick.takeHere": "Plocka här",
  "pick.manualTitle": "Vilken batch tog du? · {product}",
  "pick.manualSub": "Alla artikelns kollin i lager, först-utgången först. Sök på batch eller plats. Kommentaren krävs.",
  "pick.tooShort": "Hållbarheten räcker inte för kunden: bäst före {date}, kunden kräver minst {days} dagar.",
  "pick.manualTooShort": "för kort hållbarhet för kunden",
  "pick.manualNone": "Inga kollin av artikeln i lager.",
  "pick.manualSearch": "sök batchnummer",
  "pick.manualWhy": "Varför utan skanning?",
  "pick.manualNeedsWhy": "Skriv varför kollit inte skannades först.",
  "pick.manualReason": "manuellt: {note}",
  "common.required": "krävs",
  "recv.manual": "Utan skanning",
  "recv.manualWhich": "Vilket kolli?",
  "recv.manualWhichSub": "Orderns rader först. Ett kolli som inte finns på ordern söks fram nedan.",
  "recv.line": "rad {n}",
  "recv.manualNoGtin": "artikeln saknar GTIN i registret – lägg till en under Artiklar",
  "recv.manualOther": "annan artikel: sök namn eller artikelnummer",
  "recv.manualFacts": "Uppgifter från etiketten · {name}",
  "recv.manualLot": "Batch",
  "recv.manualBestBefore": "Bäst före (ÅÅÅÅ-MM-DD)",
  "recv.manualQty": "Mängd ({uom})",
  "recv.manualWhy": "Varför utan skanning?",
  "recv.manualHint": "Kollit får identiteten GTIN + batch och behandlas som ett skannat, märkt manuellt med din kommentar. Etiketten skrivs enligt automationerna.",
  "recv.manualAdd": "Lägg på pallen",
  "recv.manualBadQty": "Mängden måste vara ett tal större än noll.",
  "recv.manualDone": "Batch {lot} registrerad utan skanning.",
  "recv.manualDoneBulk": "{q} registrerat utan skanning.",
  "recv.manualBulkHint": "Mängdartikel: antalet räcker, inget batchnummer. Raden märks manuell med din kommentar.",
  "menu.receiving": "Inleverans",
  "menu.pallet": "Till pall",
  "menu.pallet.desc": "Skanna kolli på en pall, mot inköpsorder",
  "menu.toBin": "Direkt till lagerplats",
  "menu.toBin.desc": "Skanna kolli, sedan platsen de läggs på",
  "menu.supplierPallet": "Leverantörspall",
  "menu.supplierPallet.desc": "Ta emot pallen på dess egen SSCC, innehåll från avisering",
  "menu.notEnabled": "ej aktiverad",
  "menu.soon": "kommer",
  "menu.stock": "Lager",
  "menu.outbound": "Utleverans",
  "menu.lookup": "Slå upp",
  "menu.lookup.desc": "Skanna en plats, ett kolli eller en pall och se vad som gäller",
  "lookup.title": "Slå upp",
  "lookup.sub": "Skanna en lagerplats för att se vad som står där, ett kolli eller en pall för att se var det står, eller skriv ett artikelnummer för att se var artikeln finns.",
  "lookup.scan": "Skanna plats, kolli eller pall, eller skriv artikelnummer",
  "lookup.inStock": "I lager",
  "lookup.places": "Platser",
  "lookup.noStock": "Inget saldo enligt Trail.",
  "lookup.here": "{pallets} pallar · {kolli} lösa kolli",
  "lookup.empty": "Inget står här enligt Trail.",
  "lookup.where": "Står på",
  "lookup.picked": "plockad",
  "lookup.outbound": "utleverans",
  "menu.pick": "Plocka",
  "menu.pick.desc": "Kundorder från affärssystemet, skanna varje kolli till pall",
  "menu.pick.queue": "{n} ordrar att plocka",
  "pick.step1": "Steg 1 av 3",
  "pick.title1": "Välj order",
  "pick.sub1": "eller skanna ordernumret",
  "pick.scanOrder": "Skanna ordernummer…",
  "pick.none": "Inga ordrar att plocka.",
  "pick.orderLine": "{customer} · {date} · {n} rader",
  "pick.today": "i dag",
  "pick.carrier": "{carrier} {time}",
  "pick.step2": "Steg 2 av 3 · pall",
  "pick.title2": "Skanna utleveranspallen",
  "pick.sub2": "Ny pall? Skapa en och fäst etiketten.",
  "pick.noPallet": "Ingen pall påbörjad för {ref}. Ordern: {lines} rader.",
  "pick.newPallet": "Ny pall",
  "pick.step3": "Rad {n} av {total} · pall {p}",
  "pick.goTo": "Gå till",
  "goto.replay": "Spela upp igen",
  "pick.scanItem": "Skanna kolli",
  "pick.scanOrType": "Skanna streckkod eller skriv artikelnummer",
  "pick.skuNeedsLabel": "{sku} är batchhanterad: skanna kollits etikett.",
  "pick.skuInactive": "{sku} är inaktiv i artikelregistret (utgången eller inaktiv i affärssystemet) och kan inte plockas.",
  "pick.scanPallet": "Skanna pallens SSCC",
  "pick.wholePallet": "hel pall · {n} kolli",
  "pick.palletWhole": "Hel pall {sscc}: {n} kolli plockade till ordern. Lägg till fler kollin eller tryck Pall klar.",
  "pick.palletForeign": "Pall {sscc} bär {n} kolli som inte hör till ordern ({what}). Plocka kollin från den i stället, eller utfärda en ny pall.",
  "pick.isOrderPallet": "Det är orderpallen",
  "pick.isOrderPallet.msg": "Skanna kollin som ska på den, eller tryck Pall klar.",
  "pick.palletOver": "Pall {sscc} bär mer än ordern behöver: {n} kolli {what} à {have} mot {need} kvar på raden. Plocka kollin från den i stället; det sista kollit delas.",
  "pick.kolli": "kolli",
  "pick.batch": "batch",
  "pick.bestBefore": "bäst före {date}",
  "pick.onLocation": "På platsen",
  "pick.order": "Hela ordern",
  "pick.chooseLine": "Välj rad",
  "pick.suggested": "Föreslagen ordning: platsordning.",
  "pick.continueLine": "Fortsätt rad {n}",
  "pick.palletDone": "Pall klar",
  "pick.nextLine": "Nästa rad",
  "pick.notOnOrder": "Kollit hör inte till ordern.",
  "pick.lineFull": "Raden är redan fullplockad.",
  "pick.alreadyPicked": "Kollit är redan plockat.",
  "pick.otherLot": "Annan batch",
  "pick.otherLotMsg": "{lot} är inte den föreslagna batchen ({proposed}). Ta den föreslagna, eller plocka ändå med orsak.",
  "pick.takeProposed": "Ta föreslagen",
  "pick.pickAnyway": "Plocka ändå",
  "pick.splitTitle": "Hur mycket tas ut?",
  "pick.splitSub": "Kollit har {have} {uom}. Raden behöver {need} {uom} till.",
  "pick.splitTake": "{n} {uom} (raden)",
  "pick.splitWhole": "Hela kollit",
  "pick.splitDo": "Dela",
  "pick.splitNote": "Biten får batch {lot}. Kollit kvar: {remaining} {uom}.",
  "pick.bulk": "mängd",
  "pick.bulkTitle": "Hur mycket tas?",
  "pick.bulkSub": "{have} {uom} på {code}. Raden behöver {need} {uom} till. Skriv hur mycket du tar.",
  "pick.bulkWhole": "Allt på platsen",
  "pick.bulkPlaceholder": "Antal",
  "pick.manualBulkSub": "Skriv varför utan skanning. Sedan väljer du plats och skriver antalet.",
  "pick.continue": "Fortsätt",
  "pick.bulkNoStock": "Inget saldo att plocka för {what}.",
  "pick.bulkNoStockAt": "Inget saldo av {what} på {code}.",
  "pick.bulkWhere": "Var tar du {product}?",
  "pick.bulkWhereSub": "Artikeln står på flera platser. Välj platsen du tar från, eller skanna platsens etikett.",
  "pick.bulkTooMuch": "Bara {have} {uom} finns på platsen.",
  "pick.bulkNote": "{q} {uom} tas från {code}. Kvar där: {remaining} {uom}.",
  "pick.palletSaved": "Pall klar",
  "pick.palletSavedMsg": "{n} kolli på pall {sscc}.",
  "pick.palletQueued": "Pall klar · i kö",
  "pick.done": "Order plockad",
  "pick.reportWaiting": "Rapporterar till affärssystemet …",
  "pick.reportWaitingMsg": "Plocket skickas inom några sekunder. Vänta kvar så ser du svaret.",
  "pick.reportSent": "Rapporterad till affärssystemet",
  "pick.reportShadow": "Rapporten visad för kontoret (skuggläge)",
  "pick.reportSentMsg": "Affärssystemet tog emot plocket.",
  "pick.reportRefused": "Affärssystemet avvisade plocket",
  "pick.refusedTitle": "Ordern kunde inte avslutas",
  "pick.refusedMsg": "{msg} Ordern ligger kvar som plock med allt du tagit. Rätta i affärssystemet och tryck Försök igen. Inget har skrivits ut.",
  "pick.retryReport": "Försök igen",
  "pick.reportLocked": "Ordern är öppen i affärssystemet",
  "pick.reportLockedMsg": "Rapporten för {refs} väntar tills ordern stängs där. Trail försöker igen varje minut.",
  "pick.reportLate": "Rapporten har inte gått än",
  "pick.reportLateMsg": "Agenten svarade inte inom en minut. Svaret syns under Drift → Affärssystem.",
  "pick.doneMsg": "{pallets} pallar, {kolli} kolli.",
  "pick.toOutbound": "Till utleverans",
  "pick.short": "saknas {n}",
  "pick.shortStep": "Brister",
  "pick.shortTitle": "{n} rader har brist",
  "pick.shortTitleOne": "1 rad har brist",
  "pick.shortSub": "Ange orsak per rad, sedan rapporteras ordern plockad med bristerna.",
  "pick.report": "Rapportera",
  "pick.doneShort": "Order plockad med brist",
  "pick.doneShortMsg": "{n} rader saknar.",
  "pick.doneShortMsgOne": "1 rad saknar.",
  "pick.nextOrder": "Nästa order",
  "pick.picked": "{picked} / {total}",
  "pick.issueFailed": "Kunde inte skapa pall: {err}",
  "pick.reportFailed": "Ordern är plockad lokalt men kunde inte rapporteras: {err}",
  "pick.otherReason": "Annat",
  "pick.left": "Kvar att plocka",
  "pick.allPicked": "Allt plockat",
  "pick.allPickedMsg": "Alla rader är plockade. Pall klar avslutar ordern.",
  "pick.palletDoneFinish": "Pall klar · avsluta ordern",
  "pick.noOrders": "Inga ordrar att plocka.",
  "pick.noCarrier": "Utan transportör",
  "pick.pickupAt": "hämtas {time}",
  "pick.abandonConfirm": "Avbryta plocket? Skanningarna på den öppna pallen sparas inte.",
  "menu.count": "Inventera",
  "menu.count.desc": "räkna en plats eller en omgång",
  "count.step1": "Steg 1 av 3",
  "count.step2": "Steg 2 av 3",
  "count.step3": "Steg 3 av 3",
  "count.pickRound": "Välj omgång eller plats",
  "count.pickLocation": "Välj plats",
  "count.sub1": "eller skanna platsen framför dig",
  "count.sub1.roundOnly": "skanna en plats som ingår i omgången",
  "count.scanLocation": "Skanna lagerplats…",
  "count.noRounds": "Ingen omgång är igång. Skanna en plats för att räkna den.",
  "count.roundDesc": "{done} av {total} platser klara · {counting} pågår",
  "count.roundAllCounted": "Alla platser i omgången är räknade.",
  "count.locBusy": "räknas av {who}",
  "count.locPending": "inte räknad",
  "count.allRounds": "Alla omgångar",
  "count.locked": "Platsen är upptagen",
  "count.lockedBy": "{who} räknar den just nu.",
  "count.notLocation": "{code} är ingen lagerplats.",
  "count.noAdHoc": "Här räknas bara platser som ingår i en omgång.",
  "count.scanAll": "Skanna allt som står här",
  "count.scanContainer": "Skanna kolli eller pall…",
  "count.expected": "{n} kolli enligt Trail",
  "count.nothingExpected": "Trail har inget på den här platsen. Står något här, skanna det.",
  "count.progress": "{done} av {total} skannade",
  "count.notContainer": "Det var varken ett kolli eller en pall.",
  "count.already": "Redan skannad",
  "pick.zeroTitle": "Är {code} tom nu?",
  "pick.zeroMsg": "Det sista kollit Trail kände till lämnade platsen. Står något kvar?",
  "pick.zeroYes": "Ja, tom",
  "pick.zeroNo": "Nej, något står kvar",
  "pick.zeroDone": "{code} noterad som tom.",
  "pick.zeroQueued": "{code} noteras som tom när telefonen är online igen.",
  "pick.zeroNoDone": "{code} ligger nu i rundan {name}. Räkna den när pallen är klar.",
  "count.reportUnknown": "Rapportera till kontoret",
  "count.skipUnknown": "Hoppa över",
  "count.reported": "Rapporterat till kontoret: {key}",
  "count.unknownReason": "Inventering av {code}",
  "dev.unknownContainer": "Okänt kolli vid inventering",
  "adm.cnt.last": "räknad {at}",
  "adm.cnt.never": "aldrig räknad",
  "adm.cnt.neverN": "{n} aldrig räknade",
  "adm.cnt.oldest": "äldst {at}",
  "count.unknown": "Okänt kolli",
  "count.unknownMsg": "Finns inte i lagret: {key}.",
  "count.foundHere": "Hittad här",
  "count.foundHereMsg": "{what} står enligt Trail på {where}. Flytta hit, eller lämna den där du hittade den?",
  "count.moveHere": "Flytta hit",
  "count.leaveThere": "Står kvar där",
  "count.wrongItem": "Fel vara, lägg undan",
  "count.wrongItemMsg": "Noterat. Kollit räknas inte här.",
  "count.movedHere": "Flyttad hit",
  "count.leftThere": "Lämnad",
  "count.movedReason": "inventering",
  "count.qtyTitle": "Hur mycket finns kvar?",
  "count.qtyNow": "Trail: {q}",
  "count.qtySkip": "Hoppa över",
  "count.locationDone": "Platsen klar",
  "count.missingOne": "Ett kolli saknas",
  "count.missingN": "{n} kolli saknas",
  "count.missingSub": "De stod på {code} enligt Trail men skannades inte.",
  "count.missingTag": "saknas",
  "count.missingHint": "Saknade går till granskning innan lagersaldot ändras.",
  "count.forgotScan": "Glömde skanna, tillbaka",
  "count.reportMissing": "Saknas, rapportera",
  "count.doneTitle": "Platsen räknad",
  "count.doneMsg": "{present} kolli bekräftade, {found} flyttade hit, {missing} saknas.",
  "count.doneReview": "Saknade går till granskning innan lagersaldot ändras.",
  "count.queued": "Sparad på enheten, skickas när nätet är tillbaka.",
  "count.nextLocation": "Nästa plats",
  "count.destinationLocked": "{code} räknas just nu av {who}. Vänta tills platsen är klar.",
  "menu.putaway": "Inlagring",
  "menu.returns": "Returer",
  "menu.returns.desc": "Kundreturer mot returorder i affärssystemet",
  "ret.title": "Välj retur",
  "ret.sub": "Returordrar från affärssystemet som väntar på gods, eller skriv ordernumret",
  "ret.warehouse": "lager {n}",
  "entry.warehouseTitle": "Vilket lager får raden?",
  "entry.warehouseSub": "Artikeln finns inte på returordern. Orderns förslag är lager {wh}. Följande kollin av samma artikel följer med.",
  "entry.warehouse": "Lager {n}",
  "entry.continue": "Fortsätt",
  "msg.lineNeeded": "{what} finns inte på returordern. Välj lager så skapar Trail raden.",
  "msg.lineCreated": "Rad skapad",
  "msg.lineCreatedMsg": "{what} fick en rad på returordern, lager {wh}.",
  "close.returnDiff": "retur: skillnaden står kvar öppen i affärssystemet",
  "menu.move": "Flytta",
  "menu.move.desc": "Skanna pall eller kolli, sedan den nya platsen",
  "move.title2": "Skanna den nya platsen",
  "move.newPlace": "ny plats",
  "move.printLabel": "Skriv etikett",
  "move.printCustomerLabel": "Skriv kundetikett",
  "move.printed": "Etikett skickad",
  "move.printedMsg": "Skrivs på {printer}.",
  "move.noPrinter": "Ingen aktiv etikettskrivare med rollen Mottagning. Kontrollera under Skrivare.",
  "move.hint": "Skanna det som står fel, eller det som ska få en ny plats.",
  "move.onPallet": "Kollit står på pall {sscc}",
  "move.onPallet.msg": "Flyttar du bara kollit tas det av pallen. Tryck Hela pallen för att flytta allt.",
  "move.wholePallet": "Hela pallen",
  "move.oneOf": "kolli · 1 av {n} på pallen",
  "move.samePlace": "Står redan på {code}.",
  "move.notAllowed": "{code} är ingen lagerplats, yta eller godsmottagning.",
  "move.whatMoves": "Vad flyttas?",
  "move.hereSub": "{code} · {cartons} kolli, {loose} löst. Skanna kollit, eller välj löst gods i listan.",
  "move.hereEmpty": "{code} · inget står här enligt Trail.",
  "move.qty": "Mängd som flyttas",
  "move.qtyHint": "Allt på platsen är förvalt. Mindre lämnar resten kvar.",
  "move.toPlace": "Till plats",
  "move.qtyBad": "Ange en mängd mellan 0 och {have}.",
  "move.looseOf": "löst · {qty} av {have} {uom}",
  "move.looseAll": "löst · hela mängden",
  "move.done": "Flyttad",
  "move.merged": "Slogs ihop med {q} som redan stod på {code}.",
  "move.doneQueued": "Flytt sparad på enheten",
  "move.detached": "Togs av pall {sscc} ({n} kolli kvar).",
  "move.onto.title": "Vart på {code}?",
  "move.onto.palletsOnly": "{code} tar bara pallar. Kollit måste läggas på en pall.",
  "move.onto.hasPallets": "Här står redan {n} pall(ar). Lägg kollit på en av dem, bygg en ny pall, eller ställ det löst.",
  "move.onto.current": "kollits egen pall",
  "move.onto.samePallet": "Står redan på pall {sscc}.",
  "move.onto.loose": "Löst på platsen",
  "move.newPallet": "Ny pall",
  "move.newPalletHere": "Ny pall här",
  "move.onto": "pall {sscc} på {code}",
  "move.ontoNew": "ny pall {sscc} på {code}",
  "move.noPalletsHere": "{code} tar inga pallar, bara löst gods och kolli.",
  "move.issueFailed": "Kunde inte skapa pallen: {err}",
  "move.palletRetired": "Pall {sscc} är tom och avslutad i Trail. Utfärda en ny pall (ny etikett) om den ska användas igen.",
  "move.retireEmpty": "Avsluta tom pall",
  "move.retired": "Pallen avslutad",
  "putaway.ontoPallet": "Lagd på pall {sscc} · {code}",
  "move.full": "{code} är full: {n} pall(ar) står där och platsen tar {cap}.",
  "move.onto.room": "Plats för {cap} pall(ar), {n} står där.",
  "putaway.needsPallet": "{code} tar bara pallar. Lägg kollit på en pall först, via Flytta → Ny pall.",
  "move.palletOnPallet": "En pall kan inte läggas på en pall. Skanna en lagerplats.",
  "move.palletUnknown": "Pall {sscc} finns inte i Trail. Skanna en lagerplats, eller en pall som finns.",
  "move.destUnknown": "Koden {raw} är varken en lagerplats eller en pall som Trail känner till.",
  "adm.set.moveRoles": "Flytta visas för",
  "adm.set.printPlaces": "Utskriftsplatser",
  "adm.set.printPlaces.hint": "Var skrivare står. En skrivare får en eller flera platser; automationer och knappar väljer skrivare efter plats. De tre inbyggda kan döpas om men inte tas bort, eftersom flödena pekar på dem.",
  "adm.set.printPlaces.add": "Ny plats…",
  "adm.set.printPlaces.builtin": "inbyggd",
  "adm.set.manualRoles": "Registrering utan skanning visas för",
  "adm.set.manualRoles.hint": "Gäller läget Med kommentar. Bara arbetsledare gäller oavsett listan.",
  "adm.set.manual.receive": "Inleverans utan skanning",
  "adm.set.manual.pick": "Plock utan skanning",
  "adm.set.manual.hint": "Den normala vägen är alltid streckkoder. Utan skanning kräver alltid en kommentar, och varje sådan registrering blir en avvikelse för arbetsledaren med kommentaren bredvid händelsen.",
  "adm.set.manual.off": "Av",
  "adm.set.manual.comment": "Med kommentar",
  "adm.set.manual.lead": "Bara arbetsledare",
  "dev.manualEntry": "Registrering utan skanning: {what}",
  "menu.putaway.desc": "Skanna pall, gå till föreslagen plats, skanna platsen",
  "menu.settings": "Inställningar",
  "menu.settings.desc": "Enhet, tema, språk, skanningstest",
  "menu.needSettings": "Fyll i API-nyckel, tenant och ditt namn under Inställningar innan du börjar.",
  "strip.online": "Online",
  "strip.offline": "Offline",
  "strip.queue": "{n} i kö",
  "strip.queueStuck": "{n} avvisad av servern",
  "common.back": "Tillbaka",
  "common.menu": "Meny",
  "common.cancel": "Avbryt",
  "common.save": "Spara",
  "common.close": "Stäng",
  "common.confirm": "Bekräfta",
  "common.loading": "Laddar…",
  "common.more": "Mer…",
  "pick.step": "Steg 1 av 3",
  "pick.title": "Välj inköpsorder",
  "pick.sub": "eller skanna följesedelns ordernummer",
  "pick.scan": "Skanna ordernummer…",
  "pick.lines": "{n} rader",
  "pick.line": "1 rad",
  "pick.expected": "väntas {date}",
  "pick.unmapped": "{n} utan artikel",
  "pick.proposed": "föreslagen",
  "pick.noMatch": "Ingen öppen inköpsorder med nummer {ref}. Välj ordern i listan eller skanna ordernumret på följesedeln.",
  "pick.notOrder.item": "Det här är en produktetikett ({what}). Välj först inköpsordern i listan, sedan pallen, och skanna kollina i steg 3.",
  "pick.notOrder.pallet": "Det här är en pall. Välj först inköpsordern i listan.",
  "pick.notOrder.location": "Det här är lagerplatsen {code}. Välj först inköpsordern i listan.",
  "pick.location": "Mottagning",
  "pick.chooseLocation": "Välj mottagningsplats",
  "pick.noLocation": "Ingen plats har rollen mottagning. Importera en (typ staging eller virtual, roll receiving) innan inleverans.",
  "pick.registryOld": "Registret från {date} används (uppdatering misslyckades: {err})",
  "pick.registryMissing": "Kunde inte läsa registret: {err}",
  "pallet.step": "Steg 2 av 3 · Pall",
  "pallet.title": "Skanna pallens SSCC",
  "pallet.sub": "Saknar pallen etikett? Skapa en ny.",
  "pallet.none": "Ingen pall påbörjad.",
  "pallet.new": "Ny pall",
  "pallet.issuing": "Skapar…",
  "pallet.issued": "Ny pall {sscc}",
  "many.step": "Steg 3 av 3 · Kolli",
  "many.title": "Skanna nästa kolli",
  "many.onPallet": "kolli på pallen",
  "many.onPalletOne": "kolli på pallen",
  "many.end": "Avsluta pall",
  "many.saving": "Sparar pallen…",
  "scan.ready": "Redo att skanna",
  "scan.type": "Skanna eller skriv…",
  "banner.accepted": "Mottaget",
  "banner.acceptedDeviation": "Mottaget med avvikelse",
  "banner.rejected": "Avvisad",
  "banner.rejectedDuplicate": "Avvisad · redan skannad",
  "banner.collision": "Avvisad · finns redan i lagret",
  "banner.collisionHold": "Finns redan i lagret",
  "msg.collisionHold": "{what} står redan i lagret{at}.",
  "msg.collisionOtherDay": "{what} togs emot {date}{at}. Samma identitet får bara tas emot igen samma dag.",
  "msg.serialTaken": "Serienummer {serial} finns redan i lagret.",
  "banner.bestBeforeMissing": "Bäst före saknas på etiketten",
  "banner.quantityMissing": "Antal saknas i streckkoden",
  "banner.bulkQty": "Ange antal",
  "msg.bulkQty": "{what} hanteras som en mängd utan kollinummer. Skriv hur mycket som tas emot.",
  "msg.quantityMissingStd": "Artikelregistret föreslår {q} {uom}. Bekräfta antalet, eller skriv ett annat.",
  "msg.quantityMissing": "Skriv antalet. Inget tas emot förrän du bekräftar.",
  "banner.quantityConfirmed": "Mottaget · antal bekräftat",
  "msg.quantityStd": "{q} {uom} från artikelregistret, bekräftat.",
  "msg.quantityEntered": "{q} {uom} angivet för hand (standard {std}). Noteras på händelsen.",
  "entry.qtyTitle": "Hur mycket är det?",
  "entry.qtySub": "Streckkoden säger inget antal. Skriv det.",
  "entry.qtySubStd": "Streckkoden säger inget antal. Förslaget kommer från artikelregistret.",
  "entry.qtySubBulk": "Artikeln hanteras som en mängd utan kollinummer. Skriv hur mycket det är.",
  "entry.receiveQty": "Ta emot {q} {uom}",
  "msg.bestBeforeMissing": "Profilen {profile} kräver bäst före. Läs datumet på förpackningen eller följesedeln.",
  "banner.enteredDate": "Mottaget · datum angivet för hand",
  "msg.enteredDate": "Bäst före {date} från {source}. Noteras för kontoret.",
  "banner.enteredSerial": "Mottaget · serienummer angivet",
  "msg.enteredSerial": "{what} · serienummer {serial}. Noteras för kontoret.",
  "entry.serialTitle": "Ange serienummer",
  "entry.serialSub": "Skanna eller skriv det nummer som skiljer det här kollit från det som redan finns.",
  "entry.serialPlaceholder": "Serienummer",
  "entry.dateTitle": "Ange bäst före",
  "entry.dateSub": "ÅÅÅÅ-MM-DD",
  "entry.dateFrom": "Datumet läst från",
  "entry.rejectItem": "Avvisa kollit",
  "entry.cancel": "Avbryt",
  "entry.cancelled": "Inte mottaget",
  "entry.cancelledMsg": "{what} lades inte till. Skanna igen när du vill ta emot det.",
  "entry.withoutDate": "Ta emot utan datum",
  "entry.receive": "Ta emot",
  "label.manual": "manuell",
  "label.this": "det här kollit",
  "msg.collision": "{what} finns redan i lagret{at}. Trolig dubbel mottagning – kontakta arbetsledaren.",
  "msg.collisionAt": " ({code})",
  "banner.waitingLot": "Väntar på lot",
  "banner.saved": "Pall sparad",
  "banner.savedQueued": "Pall sparad på enheten",
  "banner.tally": "Antalet stämmer inte",
  "banner.newPallet": "Ny pall",
  "msg.saved": "{n} kolli på pall {sscc}",
  "msg.directStored": "ställd direkt på {code}",
  "recv.notDock": "Avsluta pallen med mottagningsytan, eller en lagerplats om anläggningen tillåter inlagring direkt. {code} går inte.",
  "msg.savedQueued": "{n} kolli · laddas upp när servern nås",
  "msg.duplicate": "{what} finns redan på pallen. Skanna nästa kolli.",
  "msg.wrongKind.location": "Det här är en lagerplats ({code}), inte ett kolli.",
  "msg.wrongKind.pallet": "Det här är en pall, inte ett kolli.",
  "msg.wrongKind.item": "Det här är ett kolli ({what}). Skanna pallens SSCC-etikett först, eller tryck Ny pall för att skriva ut en.",
  "msg.unknownCode": "Koden {raw} är varken en lagerplats, en pall eller en produktetikett som Trail känner till.",
  "msg.parseError": "Kunde inte läsa koden: {err}",
  "msg.emptyPallet": "Inget kolli skannat ännu på den här pallen.",
  "msg.notRunning": "Flödet är inte igång.",
  "msg.waitingLot": "GTIN {gtin} lästes utan batchnummer. Skanna etikettens andra kod – eller ta emot utan lot.",
  "msg.tally": "{scanned} av {expected} skannade. Skanna de som saknas, eller bekräfta skillnaden med en orsak.",
  "dev.unknownProduct": "okänd artikel – GTIN saknas i registret",
  "dev.missingLot": "utan batchnummer",
  "dev.missingBestBefore": "bäst före saknas",
  "msg.partialRejected": "Koden saknar batchnummer och profilen tillåter inte mottagning utan det.",
  "dev.quantityUnknown": "innehåll saknas på etiketten",
  "dev.counted": "Räknas; avvikelsen går till kontoret.",
  "label.last": "senaste kolli",
  "label.pallet": "pall",
  "label.unknownProduct": "Okänd artikel",
  "label.held": "Koden hålls några sekunder i väntan på resten av etiketten.",
  "label.missing": "saknas",
  "unit.kolli": "Kolli",
  "settings.health": "Sidan har varit öppen {min} min · {n} stopp över 2 s senaste timmen, längsta {worst} s · minne {mem}. Blir appen seg: läs av här innan du startar om.",
  "unit.loose": "Löst",
  "unit.case": "Kartong",
  "unit.inner": "Innerförpackning",
  "unit.each": "Styck",
  "unit.pallet": "Pall",
  "rows.ordered": "beställt",
  "rows.received": "mottaget hittills",
  "rows.left": "{q} kvar",
  "rows.lineDone": "klart",
  "rows.notOnOrder": "ej på ordern",
  "rows.more": "… {n} till",
  "rows.kolli": "{n} kolli",
  "side.onPallet": "På pallen",
  "side.order": "Inköpsorder {ref}",
  "side.lastPallets": "Senaste pallar",
  "more.title": "Mer",
  "more.camera": "Kamera",
  "more.acceptWithoutLot": "Ta emot utan lot",
  "more.orderStatus": "Orderstatus",
  "more.closeDelivery": "Avsluta leverans",
  "more.abandon": "Avbryt pallen",
  "more.abandonConfirm": "Pallens {n} skanningar sparas inte. Avbryta?",
  "more.abandonYes": "Ja, avbryt pallen",
  "many.back": "Tillbaka till pallsteget",
  "many.backConfirm": "Pallens {n} skanningar sparas inte. Tillbaka till pallsteget?",
  "many.backYes": "Ja, tillbaka",
  "tally.keep": "Fortsätt skanna",
  "tally.confirm": "Bekräfta med orsak",
  "close.title": "{n} avvikelser behöver en orsak",
  "close.titleOne": "1 avvikelse behöver en orsak",
  "close.sub": "Leveransavslut · {pallets} pallar · {containers} kolli",
  "close.none": "Allt beställt är mottaget, inget extra.",
  "close.ordered": "beställt {q}",
  "close.received": "mottaget {q}",
  "close.notOnOrder": "{q} mottaget, ej på ordern",
  "close.note": "Anteckning (valfri)",
  "close.notePlaceholder": "Följesedelsnummer, transportör, övrigt",
  "close.submit": "Stäng leveransen",
  "close.closing": "Stänger…",
  "close.waitingUpload": "Väntar på att {n} pallar laddas upp innan leveransen kan stängas.",
  "close.closed": "Leverans stängd",
  "close.alreadyClosed": "Leveransen var redan stängd",
  "close.progressFailed": "Orderstatus kunde inte hämtas: {err}",
  "close.other": "Annan…",
  "close.otherPlaceholder": "Orsak",
  "reason.backorder": "Restnoterat",
  "reason.shortNoted": "Saknas enl. fraktsedel",
  "reason.damaged": "Skadad – nekad",
  "reason.wrongItem": "Fel artikel",
  "reason.substitute": "Ersättningsvara",
  "reason.over": "Överleverans",
  "done.next": "Nästa pall",
  "done.closeDelivery": "Avsluta leverans",
  "done.receipts": "Inköpsorder",
  "done.pallets": "{n} pallar",
  "done.containers": "{n} kolli",
  "settings.title": "Inställningar",
  "settings.token": "API-nyckel",
  "settings.tenant": "Tenant-id",
  "settings.actor": "Ditt namn eller bricka",
  "settings.device": "Enhet {id}",
  "settings.layout": "Skärm {layout}",
  "settings.sound": "Ljud vid skanning",
  "settings.sound.hint": "godkänd, avvisad och uppmärksamhet låter olika; iPhonens ljudlösa läge tystar även detta",
  "settings.sound.off": "Av",
  "settings.sound.normal": "Normal",
  "settings.sound.loud": "Hög",
  "camera.done": "Klar",
  "camera.accepted": "{n} godkända",
  "camera.zoom2": "Zoom 2×",
  "camera.zoom1": "Zoom 1×",
  "camera.torchOn": "Lampa på",
  "camera.torchOff": "Lampa av",
  "settings.theme": "Tema",
  "settings.theme.dark": "Mörkt",
  "settings.theme.light": "Ljust",
  "settings.theme.auto": "Följ enheten",
  "settings.theme.device": "Som enheten",
  "settings.mine": "Mina inställningar",
  "settings.onAccount": "sparas på ditt konto",
  "settings.mounted": "Monterad enhet (större text och knappar)",
  "settings.keyboard": "Öppna tangentbordet i skanningsfältet automatiskt (annars via knappen)",
  "scan.keyboard": "Tangentbord",
  "settings.gsSubs": "Skannerns ersättning för GS-tecknet",
  "settings.gsSubs.hint": "de tecken skannern skickar i stället för GS (ASCII 29); # är säkrast, ~ och | fungerar med amerikansk layout",
  "scanner.waiting": "Skanner: väntar på skalet",
  "scanner.noKey": "Skannerkopplingen saknar nyckel – skalet är byggt utan Socket Mobile-nyckel",
  "scanner.error": "Skannerfel: {e}",
  "scanner.none": "Ingen skanner ansluten",
  "scanner.connected": "{name} ansluten",
  "scanner.connectedBattery": "{name} ansluten · batteri {battery} %",
  "settings.autoNext": "Gå direkt till nästa pall när en pall avslutas",
  "settings.lang": "Språk",
  "settings.diag": "Diagnostiknyckel (fältfas)",
  "settings.scantest": "Skanningstest",
  "settings.save": "Spara",
  "putaway.step1": "Steg 1 av 2",
  "putaway.title1": "Skanna pall eller kolli",
  "putaway.waiting": "Väntar i godsmottagningen: {n}",
  "putaway.contents": "På pallen · {n} kolli",
  "putaway.waitingNone": "Inget väntar i godsmottagningen.",
  "putaway.step2": "Steg 2 av 2",
  "putaway.title2": "Skanna lagerplatsen",
  "putaway.proposed": "Föreslagen plats",
  "putaway.reason.nearest": "närmast ledig lagerplats",
  "putaway.reason.class": "närmast ledig plats i rätt lagerklass",
  "putaway.reason.sameProduct": "ledig plats närmast samma artikel",
  "putaway.reason.fixed": "artikelns fasta plats",
  "adm.set.putAway": "Inlagring föreslår",
  "adm.set.putAway.nearest": "Närmaste lediga plats",
  "adm.set.putAway.sameProduct": "Närmast samma artikel",
  "adm.set.putAway.fixed": "Fast plats, annars närmast samma artikel",
  "putaway.noProposal": "Ingen ledig lagerplats hittades – välj själv.",
  "putaway.notFound": "Ingen pall eller kolli med den identiteten finns i lagret.",
  "putaway.several": "Flera kolli delar den identiteten ({n}). Skanna pallen i stället.",
  "putaway.notStorage": "{code} är ingen lagerplats.",
  "putaway.moved": "Flyttad till {code}",
  "putaway.movedQueued": "Flytt sparad på enheten · {code}",
  "putaway.override": "Annan plats än föreslagen ({proposed}) – registreras.",
  "putaway.overrideAsk": "Annan plats: {code}",
  "putaway.overrideWhy": "Föreslagen plats var {proposed}. Varför en annan?",
  "putaway.overrideConfirm": "Flytta hit",
  "adm.set.putAwayEnforcement": "Annan plats än föreslagen",
  "adm.set.enf.free": "Registreras",
  "adm.set.enf.reason": "Kräver orsak",
  "adm.set.reasons.override": "Orsaker till annan plats",
  "putaway.lookupFailed": "Kunde inte slå upp kollit: {err}",
  "putaway.other": "Annan plats",
  "menu.putaway.waiting": "{n} väntar i godsmottagningen",
  "login.title": "Logga in",
  "login.email": "E-post",
  "login.continue": "Fortsätt",
  "login.password": "Lösenord",
  "login.code": "Engångskod",
  "login.codeHint": "Koden från din autentiseringsapp",
  "login.microsoft": "Logga in med Microsoft",
  "login.withPassword": "Logga in med lösenord i stället",
  "login.or": "eller",
  "login.footDesk": "Vilken metod som gäller bestäms per användare av administratören: Microsoft Entra ID eller lösenord i Trail. På en registrerad handdator loggar man in med kod eller bricka.",
  "login.passwordOnly": "Ditt konto loggar in med lösenord. Be administratören byta till Microsoft om du vill använda det.",
  "login.unknown": "Ingen användare med den e-posten.",
  "login.chooseTenant": "Vilket bolag?",
  "login.chooseTenantSub": "Du kan byta bolag senare från menyn.",
  "login.tenant": "Bolag",
  "login.switching": "Byter bolag …",
  "login.failed": "Fel e-post eller lösenord.",
  "login.badCode": "Fel kod. Försök igen.",
  "login.entraFailed": "Inloggningen med Microsoft misslyckades.",
  "login.devSettings": "Registrera enheten · inställningar",
  "shift.title": "Starta pass",
  "shift.sub": "{device} · ange din kod eller skanna din bricka",
  "shift.code": "Kod",
  "shift.start": "Starta",
  "shift.failed": "Okänd kod eller bricka.",
  "shift.end": "Avsluta pass",
  "shift.loggedIn": "Inloggad: {name}",
  "enrol.title": "Registrera enhet",
  "enrol.scan": "Skanna registreringskod",
  "enrol.qrHint": "Rikta kameran mot QR-koden på datorskärmen",
  "enrol.code": "Eller skriv registreringskoden",
  "enrol.codePlaceholder": "koden från Enheter & användare",
  "enrol.enter": "Registrera",
  "adm.du.codeText": "Eller skriv in koden på telefonen under Inställningar:",
  "enrol.done": "Enheten är registrerad som {name}.",
  "enrol.failed": "Koden är ogiltig eller har gått ut.",
  "enrol.device": "Enhet: {name} ({role})",
  "enrol.none": "Enheten är inte registrerad. Be administratören om en registreringskod.",
  "settings.advanced": "Utvecklarinställningar (API-nyckel)",
  "adm.ops": "Drift",
  "adm.registry": "Register",
  "adm.system": "System",
  "adm.overview": "Översikt",
  "adm.deviations": "Avvikelser",
  "adm.deliveries": "Leveranser",
  "adm.outbound": "Utleverans",
  "adm.out.sub": "kundorder att plocka, i plockköordning, och de plockade",
  "adm.out.open": "Att plocka",
  "adm.out.picked": "Plockade",
  "adm.out.order": "Order",
  "adm.out.customer": "Kund",
  "adm.out.delivery": "Leverans",
  "adm.out.carrier": "Transportör",
  "adm.out.none": "Inga ordrar.",
  "adm.out.status.open": "Att plocka",
  "adm.out.status.picking": "Plockas",
  "adm.out.status.picked": "Plockad",
  "adm.out.status.shipped": "Skickad",
  "adm.out.status.cancelled": "Makulerad",
  "adm.out.pickedBy": "plockad {at} av {by}",
  "adm.out.shelfLife": "kunden kräver minst {days} dagars hållbarhet",
  "adm.out.pickedQty": "Plockat",
  "adm.out.lots": "Batcher",
  "adm.out.short": "saknas {n}",
  "adm.out.palletsSub": "{n} st",
  "adm.set.erpReport.twoStep": "Plock till kund",
  "adm.set.erpReport.twoStep.one": "Samtidigt",
  "adm.set.erpReport.twoStep.two": "Två steg",
  "adm.set.erpReport.twoStep.off.hint": "Ordern frisläpps i samma stund som den rapporteras plockad: affärssystemet får plocket och avslutet direkt efter varandra. Så arbetar ni i dag. Gäller bara kundordrar.",
  "adm.set.erpReport.twoStep.on.hint": "Plocket reserverar godset i affärssystemet. Frisläppningen är ett eget steg på telefonen eller under Utleverans, och först då lämnar saldot och fakturan kan skapas.",
  "adm.set.erpReport.kind.sales-order.released": "Order frisläppt",
  "adm.out.release": "Frisläpp",
  "adm.out.releaseConfirm": "Frisläpp order {ref}? Saldot lämnar affärssystemet och ordern kan faktureras.",
  "adm.out.released": "frisläppt {at} av {by}",
  "adm.out.unreported": "Plockad, ej rapporterad",
  "adm.out.reportPending": "Rapport på väg",
  "adm.out.unpick": "Backa plocket",
  "adm.out.unpickWhy": "Backa plocket av order {ref}? Kollina blir lager igen där de står, pallen ska plockas isär, ordern öppnas för plock igen. Ange orsak:",
  "adm.out.erp": "Affärssystemet",
  "adm.out.erp.sub": "läst {at} · plock, frisläppning och realisering per batch",
  "adm.out.erp.line": "Rad",
  "adm.out.erp.batch": "Batch · Visma-nr",
  "adm.out.erp.lineTotal": "radens summa",
  "adm.out.erp.picked": "Plockat",
  "adm.out.erp.finished": "Frisläppt",
  "adm.out.erp.realised": "Realiserat",
  "adm.out.erp.none": "Inget läst från affärssystemet ännu.",
  "adm.out.realised": "Fakturerad · låst",
  "adm.out.realised.hint": "Reservationen är realiserad i affärssystemet. Plock och frisläppning kan inte längre ångras, varken där eller här.",
  "adm.out.notYet": "Inte plockad ännu.",
  "adm.products": "Artiklar",
  "adm.locations": "Lagerplatser",
  "adm.devicesUsers": "Enheter & användare",
  "adm.stock": "Saldo per plats",
  "adm.gtins": "GTIN-register",
  "adm.suppliers": "Leverantörer",
  "adm.automations": "Automationer",
  "adm.auto.sub": "{n} aktiva · körs på servern efter händelsen",
  "adm.auto.new": "Ny automation",
  "adm.auto.saved": "Sparade {name}",
  "adm.auto.removeConfirm": "Ta bort automationen {name}? Körloggen för den försvinner också.",
  "adm.auto.guardBad": "Villkoret går inte att läsa",
  "adm.auto.name": "Namn",
  "adm.auto.namePh": "t.ex. Följesedel när ordern är plockad",
  "adm.auto.where": "Var",
  "adm.auto.when": "När",
  "adm.auto.if": "Om",
  "adm.auto.ifShort": "om",
  "adm.auto.do": "Gör",
  "adm.auto.allFlows": "Alla flöden",
  "adm.auto.allCustomers": "Alla kunder",
  "adm.auto.flow.receiving": "Inleverans",
  "adm.auto.flow.picking": "Plock",
  "adm.auto.flow.move": "Flytt",
  "adm.auto.oneCustomer": "en kund",
  "adm.auto.everywhere": "överallt",
  "adm.auto.whereHint": "Kunden hämtas från ordern. Zon, varuägare och profil kommer som fler avgränsningar.",
  "adm.auto.trig.pallet.started": "Pall påbörjad",
  "adm.auto.trig.pallet.closed": "Pall klar",
  "adm.auto.trig.piece.split": "Kolli delat",
  "adm.auto.trig.order.picked": "Order plockad",
  "adm.auto.trig.order.released": "Order frisläppt",
  "adm.auto.trig.carton.picked": "Kolli plockat (kund med egen etikett)",
  "adm.auto.trigHint.carton.picked": "När ett kolli bekräftas i plocket för en artikel där kunden vill ha egen kartongetikett (Upplysning från affärssystemet).",
  "pick.customerLabel": "kundetikett skrivs",
  "adm.auto.trigHint.pallet.started": "När telefonen ger pallen ett nytt SSCC (”Ny pall”). Bara SSCC är känt då.",
  "adm.auto.trigHint.pallet.closed": "När pallen är sparad med sitt innehåll (”Pall klar”).",
  "adm.auto.trigHint.piece.split": "När ett kolli delas vid plock och delen får eget batchnummer.",
  "adm.auto.trigHint.order.picked": "När plockaren rapporterar ordern plockad. Följesedeln kan då skapas.",
  "adm.auto.trigHint.order.released": "När ordern frisläpps: i samma stund som plocket när bolaget rapporterar i ett steg, annars när någon frisläpper på telefonen eller under Utleverans.",
  "adm.auto.guardPh": "frivilligt, t.ex. short == false",
  "adm.auto.guardHint": "Frivilligt villkor i Trails uttrycksspråk över händelsens data: flow, reference, pallets, short, sscc, reused (pallen fanns redan) …",
  "adm.auto.print": "Skriv ut",
  "adm.auto.on": "på",
  "adm.auto.role": "plats {role}",
  "adm.auto.copies": "ex",
  "adm.auto.pdfLater": "Följesedeln skrivs ut via platsagenten när skrivaren för den är vald. Tills dess syns körningen som misslyckad i loggen.",
  "adm.auto.mailTo": "E-post till",
  "adm.auto.subjectPh": "Ämne, t.ex. Order {reference} är plockad",
  "adm.auto.bodyPh": "Text. {reference}, {pallets} och andra fält i händelsen fylls i.",
  "adm.auto.attachNote": "Bifoga följesedeln som PDF",
  "adm.auto.webhook": "Webhook",
  "adm.auto.secretPh": "hemlighet för signatur",
  "adm.auto.webhookHint": "Bara https till en extern adress. Med en hemlighet signeras anropet (x-trail-signature, HMAC-SHA256).",
  "adm.auto.removeAction": "Ta bort",
  "adm.auto.addAction": "+ åtgärd:",
  "adm.auto.email": "E-post",
  "adm.auto.mailHidden": "E-post visas när en e-posttjänst är inställd och testad nedan.",
  "adm.auto.active": "På",
  "adm.auto.activeHint": "Automationen körs",
  "adm.auto.save": "Spara",
  "adm.auto.rehearse": "Provkör mot senaste veckan",
  "adm.auto.rehearsal": "Provkörning",
  "adm.auto.rehearsal.sub": "{fires} av {total} händelser den senaste veckan hade utlöst regeln · inget har gjorts",
  "adm.auto.rehearsal.when": "När",
  "adm.auto.rehearsal.what": "Vad",
  "adm.auto.rehearsal.fires": "Utlöst",
  "adm.auto.rehearsal.actions": "Hade gjort",
  "adm.auto.rehearsal.none": "Inga händelser av den här typen den senaste veckan.",
  "adm.auto.rehearsal.outOfScope": "utanför Var",
  "adm.auto.rehearsal.guardNo": "Om = nej",
  "adm.auto.cancel": "Avbryt",
  "adm.auto.col.name": "Automation",
  "adm.auto.col.last": "Senast",
  "adm.auto.col.at": "Tid",
  "adm.auto.col.event": "Händelse",
  "adm.auto.col.result": "Resultat",
  "adm.auto.none": "Inga automationer ännu.",
  "adm.auto.seeded": "från dagens inställningar",
  "adm.auto.on.yes": "På",
  "adm.auto.on.no": "Av",
  "adm.auto.meta": "version {v} · ändrad av {by} {at}",
  "adm.auto.log": "Körlogg",
  "adm.auto.logSub": "varje automation och händelse, med vad som hände",
  "adm.auto.noRuns": "Inga körningar ännu.",
  "adm.auto.true": "sant",
  "adm.auto.false": "falskt",
  "adm.auto.st.ok": "klar",
  "adm.auto.st.failed": "misslyckades",
  "adm.auto.st.skipped": "hoppades över",
  "adm.auto.order": "order {ref}",
  "adm.auto.do.print": "Skriv ut {doc} · {on} · {n} ex",
  "adm.auto.do.email": "E-post till {to}",
  "adm.auto.do.webhook": "Webhook till {host}",
  "adm.auto.doc.sscc-label": "SSCC-etikett",
  "adm.auto.doc.pallet-label": "Palletikett",
  "adm.auto.doc.piece-label": "Deletikett",
  "adm.auto.doc.customer-label": "Kundetikett",
  "adm.auto.doc.delivery-note": "Följesedel",
  "adm.mail.title": "E-posttjänst",
  "adm.mail.verified": "testad {at}",
  "adm.mail.notVerified": "inte testad · e-post kan inte väljas i automationer",
  "adm.mail.kind": "Skicka via",
  "adm.mail.none": "Ingen",
  "adm.mail.from": "Avsändare",
  "adm.mail.host": "SMTP-server",
  "adm.mail.port": "Port",
  "adm.mail.user": "Användare",
  "adm.mail.password": "Lösenord",
  "adm.mail.passwordSet": "sparat · skriv ett nytt för att byta",
  "adm.mail.passwordHint": "Lagras krypterat på servern och visas aldrig igen. TLS krävs.",
  "adm.mail.graphHint": "Skickar som avsändaren via Trails Entra-app (behörigheten Mail.Send). Begränsa appen till den här brevlådan i Exchange.",
  "adm.mail.graphMissing": "Servern saknar Entra-appens uppgifter. Microsoft 365 kan inte användas förrän de är inlagda.",
  "adm.mail.save": "Spara",
  "adm.mail.saved": "Sparat. Skicka ett testmeddelande för att kunna använda e-post.",
  "adm.mail.testTo": "testa till adress",
  "adm.mail.test": "Skicka test",
  "adm.mail.sent": "Testmeddelandet gick iväg till {to}.",
  "adm.mail.changeHint": "Ändras avsändare, server, port eller användare måste ett nytt test gå igenom innan automationerna skickar igen.",
  "adm.printers": "Skrivare",
  "adm.templates": "Etiketter & dokument",
  "adm.set.labelsInTemplates": "Utformas under Etiketter & dokument",
  "adm.prn.col.dpi": "Upplösning",
  "adm.prn.col.kind": "Typ",
  "adm.prn.kind.label": "Etikettskrivare (ZPL)",
  "adm.prn.kind.document": "Dokumentskrivare (PDF)",
  "adm.prn.sub": "via platsagenten",
  "adm.prn.agentUp": "agent ansluten",
  "adm.prn.agentDown": "ingen agent sedd de senaste 5 min",
  "adm.prn.add": "Lägg till skrivare",
  "adm.prn.edit": "Redigera skrivare",
  "adm.prn.editBtn": "Redigera",
  "adm.prn.remove": "Ta bort",
  "adm.prn.removeConfirm": "Ta bort {name}? Skrivarens {n} utskriftsjobb försvinner också.",
  "adm.prn.removed": "{name} borttagen",
  "adm.prn.col.name": "Skrivare",
  "adm.prn.col.model": "Modell",
  "adm.prn.col.path": "Sökväg",
  "adm.prn.col.roles": "Plats",
  "adm.prn.roles.hint": "Var skrivaren står. Vad den skriver bestäms av typen ovan: en etikettskrivare får etiketterna (pall, kolli, kund, lagerplats), en dokumentskrivare får följesedlar, plocklistor och inventeringslistor. Automationer och knappar väljer skrivare efter plats.",
  "adm.prn.col.lastJob": "Senaste jobb",
  "adm.prn.role.receiving": "Mottagning",
  "adm.prn.role.packing": "Packbord",
  "adm.prn.role.office": "Kontor",
  "adm.prn.none": "Inga skrivare ännu. Välj bland dem platsagenten hittat nedan, eller lägg till manuellt.",
  "adm.prn.test": "Testetikett",
  "adm.prn.sample": "Prov palletikett",
  "adm.prn.sampleQueued": "Prov palletikett köad till {name}",
  "adm.prn.testQueued": "Testetikett köad till {name}",
  "adm.prn.saved": "Sparat",
  "adm.prn.connected": "ansluten · {at}",
  "adm.prn.lastSeen": "senast sedd {at}",
  "adm.prn.neverSeen": "aldrig sedd",
  "adm.prn.inactive": "Inaktiv",
  "adm.prn.jobs": "Utskriftsjobb",
  "adm.prn.jobs.sub": "klicka för ZPL",
  "adm.prn.state.queued": "Köad",
  "adm.prn.state.printing": "Skrivs",
  "adm.prn.state.done": "Skriven",
  "adm.prn.state.failed": "Misslyckad",
  "adm.prn.pathHint": "printer:namn skriver via Windows skrivarnamn på agentens dator, ingen delning behövs. \\\\dator\\delning för en delad skrivare, eller värd:9100 för en nätverksskrivare med etiketter. Dokumentskrivare (PDF) går alltid via Windows: printer:namn eller delning, och SumatraPDF måste finnas på agentens dator.",
  "adm.prn.addManual": "Lägg till manuellt",
  "adm.prn.col.host": "Agentdator",
  "adm.prn.ipWarn": "Sökvägen är en IP-adress som kan ändras. Ge skrivaren en fast adress eller en DHCP-reservation, eller ett DNS-namn så att agenten kan använda det i stället.",
  "adm.agents": "Platsagenter",
  "adm.sites": "Anläggningar",
  "adm.sites.sub": "Den valda anläggningen styr Anläggningsinställningarna och vad telefonerna får som standard.",
  "adm.sites.new": "Ny anläggning",
  "adm.sites.col.site": "Anläggning",
  "adm.sites.col.gln": "GLN",
  "adm.sites.col.locations": "Platser",
  "adm.sites.col.printers": "Skrivare · agenter",
  "adm.sites.col.people": "Arbetar här",
  "adm.sites.own": "eget lager",
  "adm.sites.external": "externt",
  "adm.sites.selected": "vald",
  "adm.sites.select": "Välj",
  "adm.sites.showInactive": "Visa avaktiverade",
  "adm.sites.inactive": "avaktiverad",
  "adm.sites.name": "Namn",
  "adm.sites.kind": "Typ",
  "adm.sites.kind.own": "Eget lager",
  "adm.sites.kind.external": "Externt",
  "adm.sites.street": "Gatuadress",
  "adm.sites.postcode": "Postnummer",
  "adm.sites.city": "Ort",
  "adm.sites.country": "Land",
  "adm.sites.status": "Status",
  "adm.sites.status.active": "Aktiv",
  "adm.sites.status.inactive": "Avaktiverad",
  "adm.sites.hint": "Ett eget lager får sina platser från platslistan eller lagerlayouten; ett externt lager håller saldo utan platser tills någon ritar det. En anläggning avaktiveras, raderas aldrig.",
  "adm.sites.lastActive": "Den sista aktiva anläggningen kan inte avaktiveras.",
  "adm.sites.toSettings": "Inställningar för anläggningen →",
  "adm.sites.devices": "telefoner",
  "adm.du.homeSite": "Hemanläggning",
  "adm.du.queues": "Arbetsköer",
  "adm.du.queuesHint": "Inga valda = ser alla ordrar.",
  "adm.set.queues": "Arbetsköer",
  "adm.set.queues.lead": "Vem plockar vad på anläggningen: en regel per kö över orderns fält, första träff gäller, standardkön tar resten. Användare och telefoner prenumererar under Enheter & användare.",
  "adm.set.queues.name": "Kö",
  "adm.set.queues.rule": "Regel",
  "adm.set.queues.default": "Standard",
  "adm.set.queues.add": "Ny kö",
  "adm.set.queues.fields": "Fält: source, reference, carrier, deliveryDate, customer.key, customer.name, lineCount, lines.sku, external.<källa>.<fält> — Visma: external.visma.transGroup2 (Trans.grupp 2), transGroup1/3/4, orderType, warehouseNo. T.ex. external.visma.transGroup2 == 13 (e-handeln), external.visma.transGroup2 in [11, 12] för flera värden, eller source == \"webshop\". Standardkön tar resten.",
  "adm.set.queues.requeued": "Reglerna kördes om: {n} ordrar bytte kö.",
  "adm.out.queue": "Kö",
  "adm.out.noQueue": "ingen kö",
  "adm.out.byUser": "satt för hand",
  "pick.allQueues": "Alla köer",
  "pick.myQueues": "Mina köer",
  "adm.du.noHomeSite": "Ingen vald",
  "adm.nav.site": "Anläggning",
  "adm.agents.sub": "anläggningens arm in på nätet: skrivare, hämtningar, affärssystemet",
  "adm.agents.noneLive": "ingen agent rapporterar just nu",
  "adm.prn.agents": "Platsagenter",
  "adm.col.time": "Tid",
  "adm.prn.fetch": "Hämta från nätet",
  "adm.prn.fetch.sub": "Agenten hämtar adressen från sin dator på ert nät och lämnar innehållet här – för tjänstebeskrivningar som bara syns inifrån, t.ex. Visma Business Services (…?wsdl).",
  "adm.prn.fetch.url": "http://server:port/…",
  "adm.prn.fetch.go": "Hämta",
  "adm.prn.fetch.anyHost": "valfri agent",
  "adm.prn.fetch.waiting": "väntar på agenten",
  "adm.prn.fetch.failed": "misslyckades",
  "adm.prn.fetch.show": "Visa",
  "adm.prn.fetch.download": "Ladda ner",
  "adm.prn.agents.sub": "en per dator på anläggningens nät · rapporterar varje minut · uppdaterar sig själv med signerade paket",
  "adm.prn.agents.none": "Ingen agent har rapporterat ännu. Installera den enligt deploy/site-agent/README.md.",
  "adm.prn.agent.enrol": "Registrera agent",
  "adm.prn.agent.newCode": "Ny kod",
  "adm.prn.agent.hostPlaceholder": "Datorns namn, t.ex. WSW10-PL",
  "adm.prn.agent.makeCode": "Skapa kod",
  "adm.prn.agent.code": "Kod för {host} i bolaget {tenant}, gäller till {until}. Kör på datorn:",
  "adm.prn.agent.codeReenrol": "Ny kod för {host} i bolaget {tenant}, gäller till {until}; den gamla inloggningen för det här bolaget slutar gälla. Kör på datorn:",
  "adm.prn.col.login": "Inloggning",
  "adm.prn.login.own": "Egen, för det här bolaget",
  "adm.prn.login.serverKey": "Serverns nyckel",
  "adm.prn.col.agentHost": "Dator",
  "adm.prn.col.version": "Version",
  "adm.prn.col.lastSeen": "Senast sedd",
  "adm.prn.col.lastError": "Senaste fel",
  "adm.prn.agentOk": "ansluten",
  "adm.prn.agentGone": "ej sedd sedan {at}",
  "adm.prn.showLog": "Visa logg",
  "adm.prn.hideLog": "Dölj logg",
  "adm.prn.noErrors": "inga fel",
  "adm.prn.showVirtual": "Visa {n} virtuella skrivare (PDF, fax, OneNote …)",
  "adm.prn.hideVirtual": "Dölj virtuella skrivare",
  "adm.prn.anyHost": "Valfri agent",
  "adm.prn.hostHint": "Välj datorn vars agent når skrivaren. Valfri agent passar delningar och nätverksskrivare.",
  "adm.prn.found": "Hittade på {host}",
  "adm.prn.found.sub": "Windows skrivarlista, uppdaterad {at} · välj de Trail ska skriva på",
  "adm.prn.found.none": "Agenten på {host} har inte rapporterat några skrivare ännu.",
  "adm.prn.col.winName": "Windows-namn",
  "adm.prn.col.driver": "Drivrutin",
  "adm.prn.col.port": "Port",
  "adm.prn.addFound": "Lägg till",
  "adm.prn.addedAs": "tillagd som {name}",
  "adm.prn.agentHost": "{host} ansluten · {at}",
  "adm.prn.offline": "offline",
  "adm.prn.ready": "klar",
  "common.yes": "Ja",
  "common.no": "Nej",
  "adm.set.pickPalletLabel": "Utleveranspallens etikett",
  "adm.set.pickQueue": "Plocklistan",
  "adm.set.pickQueue.flat": "En lista i plockordning",
  "adm.set.pickQueue.carrier": "Grupperad per transportör",
  "adm.set.carriers": "Transportörer",
  "adm.set.carriers.name": "Namn som på ordern",
  "adm.set.carriers.add": "Lägg till transportör",
  "adm.set.carriers.hint": "normal hämtningstid; den som hämtar tidigast plockas först. Namnet ska vara det affärssystemet sätter på ordern.",
  "common.remove": "Ta bort",
  "adm.set.splitIdentity": "Delad kartong märks med",
  "adm.set.splitIdentity.lotSuffix": "Batch med ändelse (-1, -2 …)",
  "adm.set.splitIdentity.serial": "Serienummer",
  "adm.set.afterOrder": "Efter avslutad order",
  "adm.set.afterOrder.menu": "Till utleveransmenyn",
  "adm.set.afterOrder.next": "Nästa order",
  "adm.set.afterOrder.hint": "Vad plockaren kommer till när ordern är klar. Båda knapparna finns kvar; inställningen väljer den stora.",
  "adm.set.combinedPallets": "Flera ordrar på samma utleveranspall",
  "adm.set.bottomFirst": "Plockas först (underst på pallen)",
  "adm.set.bottomFirst.placeholder": "t.ex. Kryddor, Nät",
  "adm.set.bottomFirst.hint": "kategorier, hanteringsprofiler eller ord i artikelnamnet, kommaseparerade; orderrader med sådana artiklar visas först",
  "adm.set.palletLabel": "Palletikett skrivs",
  "adm.set.labelsInAutomations": "Ställs in under Automationer →",
  "adm.set.palletLabel.none": "Aldrig",
  "adm.set.palletLabel.end": "När pallen avslutas",
  "adm.set.palletLabel.start": "Vid ny pall (bara SSCC)",
  "adm.set.palletLabel.both": "Båda",
  "adm.set.palletLabelTemplate": "Palletikettens format",
  "adm.set.tpl.landscape": "Liggande 102 × 220 mm (pallens fot)",
  "adm.set.tpl.portrait": "Stående 102 × 152 mm (GS1 logistiketikett)",
  "adm.loc.printed": "köad",
  "adm.ev.reprint": "Skriv ut palletikett",
  "msg.labelQueued": "etikett skrivs ut",
  "msg.labelNotPrinted": "ingen etikett (skrivare saknas)",
  "adm.me.title": "Min profil",
  "adm.me.email": "E-post",
  "adm.me.appearance": "Utseende och språk",
  "adm.me.appearance.sub": "följer dig till varje enhet",
  "adm.me.now.user": "Just nu: {theme} överallt där du loggar in.",
  "adm.me.now.device": "Just nu: {here} här på datorn, {phone} på lagertelefonerna (enhetens eller platsens standard). Väljer du ett tema gäller det överallt du loggar in.",
  "adm.me.langNote": "Streckkodsfält (GTIN, Batch/Lot, Best before) står alltid på engelska enligt GS1.",
  "adm.me.login": "Inloggning",
  "adm.me.login.sub": "ditt lösenord, din kortkod och din engångskodsapp",
  "adm.me.login.note": "Vilken metod du loggar in med på datorn, lösenord eller Microsoft, bestäms av administratören. Kortkoden används på en registrerad handdator.",
  "adm.me.onDesktop": "På dator",
  "adm.me.onDevice": "På handdator",
  "adm.me.codeSet": "Kortkod satt",
  "adm.me.codeUnset": "Ingen kortkod",
  "adm.me.codeSaved": "Kortkoden sparad",
  "adm.me.codeCleared": "Kortkoden borttagen",
  "adm.me.codeClear": "Ta bort",
  "adm.me.pwCurrent": "Nuvarande lösenord",
  "adm.me.pwNew": "Nytt lösenord",
  "adm.me.pwHint": "minst 10 tecken",
  "adm.me.pwAgain": "Upprepa",
  "adm.me.pwChange": "Byt lösenord",
  "adm.me.pwChanged": "Lösenordet är bytt",
  "adm.me.pwWrong": "Fel nuvarande lösenord",
  "adm.me.mfa": "Engångskod",
  "adm.me.mfaOn": "Aktiverad",
  "adm.me.mfaOff": "Inte aktiverad",
  "adm.me.mfaPair": "Koppla app",
  "adm.me.mfaRepair": "Koppla ny app",
  "adm.me.mfaConfirm": "Koppla en ny engångskodsapp? Den gamla slutar fungera direkt.",
  "adm.me.saved": "Sparat",
  "adm.sup.sub": "{n} leverantörer · {linked} med kopplade artiklar",
  "adm.sup.search": "Namn eller leverantörsnr",
  "adm.sup.nArticles": "{n} artiklar",
  "adm.sup.noGln": "GLN saknas",
  "adm.sup.col.name": "Leverantör",
  "adm.sup.col.key": "Lev.nr",
  "adm.sup.col.country": "Land",
  "adm.sup.col.articles": "Artiklar",
  "adm.sup.facts": "Etiketter från denna leverantör",
  "adm.sup.facts.sub": "gäller alla deras artiklar om inget annat anges",
  "adm.sup.barcode": "Streckkod",
  "adm.sup.barcode.ph": "GS1-128 · två koder per etikett",
  "adm.sup.contentFrom": "Innehåll från",
  "adm.sup.contentLevel": "förpackningsnivå",
  "adm.sup.lotGrammar": "Batchnummer",
  "adm.sup.lotGrammar.ph": "K49O8610 → vecka 49, linje O, löpnr 8610",
  "adm.sup.prefixes": "Kända prefix",
  "adm.sup.attr.bestBefore": "Bäst före",
  "adm.sup.attr.lot": "Batchnummer",
  "adm.sup.attr.expiry": "Utgångsdatum",
  "adm.sup.attr.serial": "Serienummer",
  "adm.sup.attr.netContent": "Innehåll",
  "adm.sup.req.inherit": "som profilen",
  "adm.sup.req.required": "krävs",
  "adm.sup.req.optional": "valfritt",
  "adm.sup.req.forbidden": "finns aldrig",
  "adm.sup.articles": "Artiklar från {name}",
  "adm.sup.articles.sub": "leverantörens kod → vår artikel · avvikelser från profilen",
  "adm.sup.col.article": "Lev.art.nr",
  "adm.sup.col.gtin": "GTIN (leverantörens)",
  "adm.sup.col.deviates": "Avviker från profilen",
  "adm.sup.fromSupplier": "(leverantör)",
  "adm.sup.fromLink": "(denna artikel)",
  "adm.sup.resolve": "Så löses en regel",
  "adm.sup.resolve.sub": "exempel: bäst före på {sku}",
  "adm.sup.level": "Nivå",
  "adm.sup.says": "Säger",
  "adm.sup.lvl.site": "Plats",
  "adm.sup.lvl.profile": "Profil",
  "adm.sup.lvl.supplier": "Leverantör",
  "adm.sup.isDefault": "standard",
  "adm.sup.replacesSite": "ersätter platsens",
  "adm.sup.replacesProfile": "ersätter profilens",
  "adm.sup.noDeviation": "ingen avvikelse",
  "adm.sup.result": "Resultat",
  "adm.sup.result.mustEnter": "saknas det stoppas kollit tills datumet anges med källa",
  "adm.sup.result.allowWithout": "saknas det får kollit tas emot utan datum, med avvikelse",
  "adm.sup.saved": "Sparat",
  "adm.loc.sub": "{site} · {n} platser",
  "adm.loc.tree": "Träd",
  "adm.loc.search": "Platskod",
  "adm.loc.contents": "Innehåll",
  "adm.loc.empty": "Inget står här.",
  "adm.loc.history": "Historik",
  "adm.loc.role": "Roll",
  "adm.loc.kind": "Typ",
  "adm.loc.storageClass": "Lagringsklass",
  "adm.loc.erpWarehouse": "Lager i affärssystemet",
  "adm.loc.erpWarehouse.none": "inget",
  "adm.loc.ed.erpWarehouseHint": "Vilket lager i affärssystemet godset i den här zonen tillhör. Allt under ärver. Bara lager som någon zon pekar på speglas och plockas i Trail.",
  "adm.set.erpWarehouses": "Lager i affärssystemet",
  "adm.set.erpWarehouses.sub": "fylls av adaptern varje körning · zonerna pekas ut under Lagerplatser",
  "adm.set.erpWarehouses.no": "Nr",
  "adm.set.erpWarehouses.name": "Namn",
  "adm.set.erpWarehouses.zones": "Zoner i Trail",
  "adm.set.erpWarehouses.handled": "hanteras i Trail",
  "adm.set.erpWarehouses.unbound": "ingen zon · speglas inte",
  "adm.set.erpWarehouses.none": "Inga lager inlästa ännu. De kommer med speglingens nästa körning.",
  "adm.set.erpWarehouses.hint": "Ett lager i affärssystemet är en saldobehållare, en anläggning i Trail en plats. Flera lager kan höra till en anläggning: peka ut lagret på en zon under Lagerplatser, så följer spegling, plock och inleverans av det. Lager utan zon, till exempel ert gods hos leverantörer, rörs inte av Trail.",
  "adm.loc.inherited": "ärvd",
  "adm.loc.label": "Etikett",
  "adm.loc.labelText": "Code 128 · {code}",
  "adm.loc.print": "Skriv ut igen",
  "adm.loc.labelsAll": "Skriv ut alla",
  "adm.loc.labelsAllText": "{n} platser under {code}",
  "adm.loc.labelsAllConfirm": "Skriv ut etiketter för alla {n} platser under {code}, i platsordning?",
  "adm.loc.labelsQueued": "{n} etiketter köade till kontorets skrivare",
  "adm.loc.printSoon": "utskrift kommer med skrivarstödet",
  "adm.loc.dynamic": "Dynamisk · tar vilken artikel som helst",
  "adm.loc.fixed": "Fast · en artikel",
  "adm.loc.kind.zone": "zon",
  "adm.loc.kind.aisle": "gång",
  "adm.loc.kind.rack": "ställ",
  "adm.loc.kind.level": "hyllplan",
  "adm.loc.kind.bin": "plats",
  "adm.loc.kind.staging": "yta",
  "adm.loc.kind.workstation": "arbetsstation",
  "adm.loc.kind.mobile": "mobil",
  "adm.loc.kind.virtual": "virtuell",
  "adm.loc.inboundHere": "mottaget här",
  "adm.loc.bay": "Ställningen från gången",
  "adm.loc.rack": "Hela ställaget från gången",
  "adm.loc.rack.sub": "sektioner från vänster, hyllplan uppifrån · klicka på ett fack för att se vad som står där",
  "adm.loc.bay.sub": "hyllplan uppifrån, platser från vänster",
  "adm.loc.map": "Karta",
  "adm.loc.map.sub": "{zone} · raderna i bokstavsordning tills en planritning finns · klicka en plats",
  "adm.loc.movedHere": "flyttad hit",
  "adm.loc.movedAway": "flyttad härifrån",
  "adm.gt.sub": "GS1-företagsprefix {prefix} · {n} artikelreferenser, gemensamma för GTIN-13 och alla GTIN-14-indikatorer",
  "adm.gt.indicator": "Indikatorsiffra",
  "adm.gt.indicator.0": "0 · fast mått, GTIN-13",
  "adm.gt.indicator.9": "9 · variabelt mått",
  "adm.gt.indicator.n": "{n} · förpackningsnivå",
  "adm.gt.noPrefix": "Inget GS1-företagsprefix är satt för godsägaren. Prefixet står på GS1-licensen (4–12 siffror) och styr vilka GTIN och SSCC Trail får bilda.",
  "adm.gt.prefix": "GS1-företagsprefix",
  "adm.gt.prefix.save": "Spara prefix",
  "adm.gt.prefix.change": "Ändra prefix",
  "adm.gt.prefix.saved": "Prefixet {prefix} är satt.",
  "adm.gt.prefix.warn": "Ett byte av prefix ändrar inte redan tilldelade nummer; nya nummer bildas under det nya prefixet.",
  "adm.gt.capacity": "Artikelreferenser",
  "adm.gt.capacity.d": "under prefixet",
  "adm.gt.assigned": "Tilldelade",
  "adm.gt.assigned.d": "varav {n} på inaktiva artiklar",
  "adm.gt.assigned.d2": "referenser · {codes} koder, {n} på inaktiva artiklar",
  "adm.gt.reserved": "Reserverade",
  "adm.gt.reserved.d": "i bruk utanför Trails artikelregister",
  "adm.gt.reservedOne": "Reserverad",
  "adm.gt.list": "Nummer i bruk · {n}",
  "adm.gt.free": "Lediga",
  "adm.gt.free.d": "nästa referens: {ref}",
  "adm.gt.allocate": "Tilldela nästa",
  "adm.gt.allocateTo": "Tilldela nästa nummer",
  "adm.gt.product": "Artikel",
  "adm.gt.level": "Förpackningsnivå",
  "adm.gt.gtin": "GTIN",
  "adm.gt.check": "Kontrollsiffra",
  "adm.gt.computed": "beräknad",
  "adm.gt.do": "Tilldela",
  "adm.gt.done": "{gtin} tilldelad {sku}",
  "adm.gt.ref": "Referens",
  "adm.gt.source": "Källa",
  "adm.gt.inUse": "I bruk",
  "adm.gt.inactive": "Artikel inaktiv",
  "adm.gt.search": "Sök artikel…",
  "adm.gt.noReuse": "Ett nummer får inte återanvändas förrän fyra år efter att artikeln slutat säljas (GS1). Trail tilldelar därför bara nummer som aldrig använts.",
  "adm.stock.waiting": "att lagra in",
  "adm.events": "Händelser",
  "adm.dev.open": "Öppna",
  "adm.dev.handled": "Hanterade",
  "adm.dev.all": "Alla",
  "adm.dev.handle": "Hanterad",
  "adm.dev.handleNote": "Anteckning (valfri)",
  "adm.dev.handledBy": "hanterad av {by} {at}",
  "adm.dev.none": "Inga avvikelser.",
  "adm.col.where": "Var",
  "adm.col.handled": "Hanterad",
  "adm.del.open": "Öppna",
  "adm.del.closed": "Stängda",
  "adm.del.order": "Order",
  "adm.del.supplier": "Leverantör",
  "adm.del.expected": "Väntas",
  "adm.del.lines": "Rader",
  "adm.del.received": "Mottaget",
  "adm.del.ordered": "Beställt",
  "adm.del.diff": "Diff",
  "adm.del.pallets": "Pallar",
  "adm.del.closing": "Leveransavslut",
  "adm.del.closingNone": "Inte stängd ännu.",
  "adm.del.closedBy": "stängd {at} av {by}",
  "adm.del.reason": "Orsak",
  "adm.del.note": "Anteckning",
  "adm.del.noDiff": "Inga avvikelser mot ordern.",
  "adm.del.status.open": "Öppen",
  "adm.del.status.proposed": "Föreslagen",
  "adm.del.status.closed": "Stängd",
  "adm.del.status.cancelled": "Makulerad",
  "adm.ev.title": "Händelser",
  "adm.ev.sub": "liggaren · {n} händelser · integritet {status}",
  "adm.ev.ok": "OK",
  "adm.ev.bad": "BRUTEN",
  "adm.ev.search": "SSCC, GTIN, batch eller container-id",
  "adm.ev.trace": "Spår",
  "adm.ev.contents": "Innehåll",
  "adm.ev.history": "Historik",
  "adm.ev.noHit": "Ingen container hittades.",
  "adm.ev.export": "Exportera JSON",
  "adm.ev.exportEpcis": "Exportera EPCIS",
  "adm.ev.col.seq": "#",
  "adm.ev.col.type": "Händelse",
  "adm.ev.col.subject": "Avser",
  "adm.ev.col.by": "Av",
  "adm.ev.col.flow": "Flöde",
  "adm.st.title": "Saldo per plats",
  "adm.st.sub": "projektion av liggaren",
  "adm.st.byLocation": "Per plats",
  "adm.st.byProduct": "Per artikel",
  "adm.st.location": "Plats",
  "adm.st.unit": "Enhet",
  "adm.st.product": "Artikel",
  "adm.st.lot": "Batch",
  "adm.st.count": "Kollin",
  "adm.st.content": "Innehåll",
  "adm.st.bestBefore": "Bäst före",
  "adm.st.unplaced": "Ej inlagrad",
  "adm.st.stored": "Lagrad",
  "adm.st.search": "Artikel, batch, plats…",
  "adm.st.rows": "{n} rader",
  "adm.pr.title": "Artiklar",
  "adm.pr.sub": "{total} lagerförda · {active} aktiva · {gtins} med GTIN",
  "adm.pr.search": "Artikelnr, benämning, GTIN",
  "adm.pr.col.sku": "Artikelnr",
  "adm.pr.col.name": "Benämning",
  "adm.pr.col.category": "Kategori",
  "adm.pr.col.unit": "Enhet",
  "adm.pr.col.gtin": "GTIN",
  "adm.pr.col.storage": "Lager",
  "adm.pr.baseUom": "Grundenhet",
  "adm.pr.storageClass": "Lagerklass",
  "adm.pr.counted": "Räknad enhet",
  "adm.pr.profile": "Hanteringsprofil",
  "adm.pr.profileFrom.company": "bolagets standard",
  "adm.pr.profileFrom.site": "anläggningens standard",
  "adm.pr.profileFrom.dimension": "via indelningen",
  "adm.pr.profileFrom.article": "artikelns egen",
  "adm.pr.articleProfile": "Profil på artikeln",
  "adm.pr.articleProfile.none": "Ingen egen · följer nivåerna ovanför",
  "adm.pr.articleProfile.hint": "Gäller när nivåerna ovanför tillåter avvikelse.",
  "adm.pr.profileSaved": "Sparat.",
  "adm.pr.lockedBy.company": "låst av bolaget",
  "adm.pr.lockedBy.site": "låst av anläggningen",
  "adm.pr.lockedBy.dimension": "låst av indelningen",
  "adm.pr.codes": "Koder",
  "adm.pr.codes.sub": "varje kod pekar på en artikel",
  "adm.pr.level": "Nivå",
  "adm.pr.source": "Källa",
  "adm.pr.supplier": "Leverantör",
  "adm.pr.contentFrom": "innehåll från AI {ai}",
  "adm.pr.more": "… {n} till · sök för att hitta",
  "adm.pr.inactive": "Inaktiv",
  "adm.toTaskClient": "Till lagerklienten",
  "adm.toAdmin": "Administration",
  "adm.toAdmin.desc": "Översikt, enheter, användare, inställningar",
  "adm.logout": "Logga ut",
  "adm.role.operator": "Operatör",
  "adm.role.lead": "Lagerledare",
  "adm.role.quality": "Kvalitet",
  "adm.role.administrator": "Administratör",
  "adm.role.readonly": "Läsbehörighet",
  "adm.role.integrator": "Integratör",
  "adm.tile.deviations": "Avvikelser 30 dagar",
  "adm.tile.deviations.d": "registrerade från telefonerna",
  "adm.tile.putaway": "Väntar på inlagring",
  "adm.tile.putaway.d": "pallar i {code}",
  "adm.tile.putaway.none": "inget väntar",
  "adm.tile.deliveries": "Öppna leveranser",
  "adm.tile.deliveries.none": "inga öppna",
  "adm.tile.currency": "Senaste händelse",
  "adm.tile.currency.d": "{n} händelser i liggaren · {devices} enheter registrerade",
  "adm.deviations.title": "Avvikelser att hantera",
  "adm.deviations.none": "Inga avvikelser registrerade.",
  "adm.latestFirst": "senaste först",
  "adm.col.when": "När",
  "adm.col.what": "Vad",
  "adm.col.who": "Vem",
  "adm.col.disposition": "Disposition",
  "adm.col.status": "Status",
  "adm.today": "Idag",
  "adm.today.received": "Kolli mottagna",
  "adm.today.aggregated": "Pallar avslutade",
  "adm.today.moved": "Flyttar",
  "adm.today.inspected": "Avvikelser",
  "adm.today.devices": "Enheter",
  "adm.du.counts": "{devices} enheter · {users} användare",
  "adm.du.newUser": "Ny användare",
  "adm.du.enrolDevice": "Registrera enhet",
  "adm.du.devices": "Enheter",
  "adm.du.users": "Användare",
  "adm.du.keys": "Integrationsnycklar",
  "adm.du.keys.sub": "en nyckel per integration eller skript, med roller · visas en gång",
  "adm.du.keys.none": "Inga nycklar. Adaptern och skript bör ha egna nycklar i stället för serverns integratörsnyckel.",
  "adm.du.key.new": "Ny nyckel",
  "adm.du.key.namePlaceholder": "Namn, t.ex. visma-adapter",
  "adm.du.key.create": "Skapa",
  "adm.du.device.noSite": "Ingen anläggning – välj",
  "adm.du.key.validDays": "Giltig i dagar",
  "adm.du.key.expires": "går ut {at}",
  "adm.du.key.expired": "gick ut {at}",
  "adm.du.key.noExpiry": "går aldrig ut",
  "adm.me.logoutAll": "Logga ut överallt",
  "adm.me.logoutAllConfirm": "Logga ut från alla datorer och telefoner där du är inloggad, den här också?",
  "adm.set.security.idle": "Lås efter inaktivitet",
  "adm.set.security.idle.hint": "Minuter utan tangenttryck eller klick innan administrationen loggar ut. 0 = aldrig. Handdatorernas skiftpass är 10 timmar oavsett.",
  "adm.du.key.issued": "Nyckeln {name} skapad. Kopiera nu, den visas inte igen:",
  "adm.du.key.lastUsed": "Senast använd",
  "adm.du.key.created": "skapad av {by} · {at}",
  "adm.du.key.active": "Aktiv",
  "adm.du.key.revoked": "Återkallad",
  "adm.du.key.revoke": "Återkalla",
  "adm.du.key.revokeConfirm": "Återkalla nyckeln {name}? Det som använder den slutar fungera direkt.",
  "adm.du.device": "Enhet",
  "adm.du.role": "Roll",
  "adm.du.lastSeen": "Senast sedd",
  "adm.du.noDevices": "Inga enheter registrerade ännu.",
  "adm.du.enrolled": "Registrerad",
  "adm.du.pending": "Väntar på registrering",
  "adm.du.expired": "Koden gick ut",
  "adm.du.newCode": "Ny kod",
  "adm.du.reenrol": "Registrera om",
  "adm.du.reenrolConfirm": "Registrera om {name}? Telefonens nuvarande registrering slutar gälla direkt och en ny kod visas. Gör detta när telefonen är återställd eller appen ominstallerad.",
  "adm.du.remove": "Ta bort",
  "adm.du.deactivate": "Inaktivera",
  "adm.du.removeConfirm": "Ta bort {name}? Enheten är inte registrerad.",
  "adm.du.deactivateConfirm": "Inaktivera {name}? Enheten loggas ut och kan inte användas förrän den registreras igen.",
  "adm.du.role.handheld": "Handdator",
  "adm.du.role.mounted": "Monterad",
  "adm.du.role.workstation": "Arbetsstation",
  "adm.du.name": "Namn",
  "adm.du.roles": "Roller",
  "adm.du.login": "Inloggning",
  "adm.du.lm.password": "Lösenord i Trail",
  "adm.du.lm.entra": "Microsoft Entra ID",
  "adm.du.lm.hint": "Hur användaren loggar in på datorn. Med Microsoft används organisationens konto med samma e-post; inget lösenord i Trail.",
  "adm.du.m.password": "Lösenord",
  "adm.du.m.passwordMfa": "Lösenord + engångskod",
  "adm.du.m.shortCode": "Kod på enhet",
  "adm.du.m.badge": "Bricka",
  "adm.du.active": "Aktiv",
  "adm.du.inactive": "Inaktiv",
  "adm.du.enrolMfa": "Aktivera engångskod",
  "adm.du.issueCode": "Skapa registreringskod",
  "adm.du.codeValid": "giltig till {until}",
  "adm.du.howToEnrol": "På enheten: Inställningar → Skanna registreringskod, eller öppna länken i koden. Koden är engångs.",
  "adm.du.mfaTitle": "Engångskod aktiverad",
  "adm.du.mfaHow": "Skanna med en autentiseringsapp (Microsoft Authenticator, Google Authenticator). Vid nästa inloggning krävs koden.",
  "adm.du.password": "Lösenord",
  "adm.du.keep": "(oförändrat)",
  "adm.du.min10": "minst 10 tecken",
  "adm.du.shortCode": "Kod på enhet",
  "adm.du.badge": "Bricka",
  "adm.du.badgeHint": "brickans streckkod",
  "adm.set.logged": "ändringar loggas med vem och när",
  "adm.set.saved": "Sparat · version {v}",
  "adm.set.rulesSaved": "Regler sparade",
  "adm.set.published": "{name} publicerad som ny version",
  "adm.set.enabledFlows": "Aktiverade flöden",
  "adm.set.afterPallet": "Efter avslutad pall",
  "adm.set.nextPallet": "Nästa pall direkt",
  "adm.set.summary": "Visa sammanställning",
  "adm.set.blind": "Utan inköpsorder",
  "adm.set.allowed": "Tillåtet",
  "adm.set.notAllowed": "Ej tillåtet",
  "adm.set.scope.company": "Bolag",
  "adm.set.scope.site": "Anläggning",
  "adm.set.companyScope": "gäller alla anläggningar i bolaget",
  "adm.set.search": "Sök inställning …",
  "adm.set.sec.general": "Allmänt",
  "adm.set.sec.identity": "Identitet och batch",
  "adm.set.sec.receiving": "Inleverans",
  "adm.set.sec.putaway": "Inlagring och flytt",
  "adm.set.sec.picking": "Plock och utleverans",
  "adm.layout": "Lagerlayout",
  "adm.loc.map.layout": "ur publicerad layout version {v} · färgen är fyllnadsgrad · klicka på en rad",
  "adm.lay.sub": "{file} · version {v} ({status}) · publicerad version {pub} används av kartorna",
  "adm.lay.sub.none": "ingen layout ännu — läs in ritningen",
  "adm.lay.draft": "utkast",
  "adm.lay.publishedWord": "publicerad",
  "adm.lay.tool.select": "Markera",
  "adm.lay.tool.rack": "Ställage",
  "adm.lay.tool.area": "Yta",
  "adm.lay.tool.gate": "Port",
  "adm.lay.load": "Läs in ritning (SVG)",
  "adm.lay.save": "Spara utkast",
  "adm.lay.preview": "Förhandsgranska publicering",
  "adm.lay.publish": "Publicera",
  "adm.lay.badSvg": "Filen är ingen SVG.",
  "adm.lay.loaded": "{name} inläst: {w} × {h} m, {n} streckade rektanglar hittade → {racks} ställage (dubbelrader delade i två).",
  "adm.lay.importOffer": "Ritningen har {n} streckade rektanglar. Ta in dem som ställagekomponenter?",
  "adm.lay.importYes": "Ta in som ställage",
  "adm.lay.importNo": "Nej, jag ritar själv",
  "adm.lay.saved": "Utkast version {v} sparat.",
  "adm.lay.publishConfirm": "Publicera layouten och skapa {created} nya lagerplatser i trädet?",
  "adm.lay.published": "Publicerad. {created} lagerplatser skapade.",
  "adm.lay.report.title": "Förhandsgranskning:",
  "adm.lay.report": "{racks} ställage ({unbound} obundna) · {created} nya platser · {existing} finns redan",
  "adm.lay.report.missing": "Gångar som saknas i trädet: {codes}",
  "adm.out.deliveryNote": "Följesedel (PDF)",
  "adm.out.sharedWith": "samlastad med {refs}",
  "adm.out.docDeliveryNote": "Följesedel",
  "adm.out.docPickList": "Plocklista",
  "adm.out.viewPdf": "Visa kopia (PDF)",
  "adm.out.print": "Skriv ut",
  "pick.combineTitle": "Samlasta med?",
  "pick.combineSub": "Fler ordrar till {customer} går med {carrier}. Plocka dem tillsammans på samma pallar?",
  "pick.combineOnly": "Bara {ref}",
  "pick.combinePick": "Plocka {n} ordrar",
  "pick.combineSummary": "Tillsammans: {lines} rader",
  "pick.combineOtherDate": "annan leveransdag",
  "pick.sameCustomer": "+{n} till samma kund",
  "pick.doneOrders": "{refs} rapporterade.",
  "pick.orderTag": "order {ref}",
  "adm.out.printDeliveryNote": "Skriv ut följesedel",
  "adm.out.printPickList": "Skriv ut plocklista",
  "adm.ev.printContent": "Skriv ut pallinnehåll",
  "adm.ev.printCustomerLabel": "Skriv ut kundetikett",
  "adm.ev.printSscc": "Skriv ut SSCC-etikett",
  "adm.cnt.printSheet": "Skriv ut inventeringsblad",
  "adm.print.viaAgent": "Skrivs ut via platsagenten på den skrivare som har rollen",
  "adm.print.queued": "Skickat till {printer}: {title}.",
  "adm.print.noDocPrinter": "Ingen aktiv dokumentskrivare. Lägg till en under Skrivare med typen Dokumentskrivare (PDF).",
  "adm.print.noLabelPrinter": "Ingen aktiv etikettskrivare med den rollen. Kontrollera under Skrivare.",
  "adm.out.deliveryNoteDraft": "Förhandsvisa",
  "adm.out.notPickedYet": "Följesedeln skrivs när ordern är plockad",
  "adm.set.company": "Företagsuppgifter",
  "adm.set.company.sub": "som de står på följesedlar och andra dokument",
  "adm.set.company.name": "Företagsnamn",
  "adm.set.company.street": "Gatuadress",
  "adm.set.company.city": "Postnummer och ort",
  "adm.set.company.orgNo": "Organisationsnummer",
  "adm.set.company.phone": "Telefon",
  "adm.set.company.email": "E-post",
  "adm.set.company.seat": "Styrelsens säte",
  "adm.set.company.fTax": "Innehar F-skattebevis",
  "adm.set.company.logo": "Logotyp",
  "adm.set.company.logo.hint": "PNG eller JPEG, högst 280 kB; skrivs uppe till vänster.",
  "adm.set.company.logo.choose": "Välj bild",
  "adm.set.company.logo.big": "Bilden är för stor (högst 280 kB).",
  "adm.set.dn.number": "Följesedelsnummer",
  "adm.set.dn.number.hint": "Prefix och nästa nummer. Trail fortsätter från det högsta av detta och senast använda; sätt det efter det gamla systemets sista nummer.",
  "adm.set.dn.prefix": "prefix",
  "adm.pr.storage": "Lagringskrav",
  "adm.pr.storage.none": "Inget krav",
  "adm.pr.storage.hint": "Platsens lagringsklass jämförs med detta vid inlagring och flytt. Ett värde satt här skrivs inte över av importen.",
  "adm.pr.storageSaved": "Lagringskravet sparat.",
  "adm.pr.stock": "Lager",
  "adm.pr.stock.sub": "{units} kolli · {places} platser",
  "adm.pr.stock.none": "Inget i lager.",
  "adm.pr.stock.picked": "plockad",
  "adm.pr.stock.unplaced": "ej inställd",
  "adm.pr.stock.loose": "löst",
  "storage.wrong": "Fel temperatur",
  "storage.wrongMsg": "Artikeln kräver {need}, {code} är {has}.",
  "adm.loc.ed.title": "Redigera",
  "adm.loc.ed.open": "Ändra inställningar",
  "adm.loc.ed.sub": "ändringar gäller direkt; importer skriver inte över en plats som ändrats här",
  "adm.loc.ed.code": "Kod",
  "adm.loc.ed.role.storage": "Lager",
  "adm.loc.ed.role.receiving": "Mottagning",
  "adm.loc.ed.role.pick_face": "Plockplats",
  "adm.loc.ed.role.pack": "Pack",
  "adm.loc.ed.role.ship": "Utlastning",
  "adm.loc.ed.inherit": "Ärvs uppifrån",
  "adm.loc.ed.inheritsFrom": "Ärver {cls}. Välj en klass för att sätta den här och för allt under.",
  "adm.loc.ed.classHint": "Gäller den här platsen och allt under den, om inget under sätter en egen.",
  "adm.loc.ed.seq": "Gångordning",
  "adm.loc.ed.seqHint": "Lägre först i plock och inlagring.",
  "adm.loc.ed.parent": "Ligger under",
  "adm.loc.ed.parentHint": "Flyttas platsen följer allt under med.",
  "adm.loc.ed.noParent": "Högsta nivån",
  "adm.loc.ed.save": "Spara",
  "adm.loc.ed.saved": "Sparat.",
  "adm.loc.ed.savedMoved": "Sparat. {n} platser under följde med.",
  "adm.loc.ed.deactivate": "Avaktivera",
  "adm.loc.ed.deactivateConfirm": "Avaktivera {code}? Den försvinner ur trädet och tar inte emot något, men historiken finns kvar och den kan aktiveras igen.",
  "adm.loc.ed.addUnder": "Lägg till under {code}",
  "adm.loc.ed.add": "Lägg till",
  "adm.loc.ed.added": "{code} tillagd.",
  "adm.loc.holds": "Tar emot",
  "adm.loc.holds.any": "Pallar och löst gods",
  "adm.loc.holds.pallets": "Bara pallar",
  "adm.loc.holds.loose": "Bara löst gods och kolli",
  "adm.loc.ed.holdsHint": "Pallställage har bara balkar: där måste kolli ligga på en pall. Gäller platsen och allt under den.",
  "adm.loc.ed.holdsInherits": "Ärver: {what}. Välj för att sätta det här och för allt under.",
  "adm.loc.palletCapacity": "Max antal pallar",
  "adm.loc.palletCapacity.none": "obegränsat",
  "adm.loc.ed.capHint": "0 = obegränsat. Gäller platsen och allt under den.",
  "adm.loc.ed.capInherits": "Ärver: {what}. Ange ett tal för att sätta det här och för allt under.",
  "adm.loc.ed.top": "Ny zon eller yta",
  "adm.loc.ed.top.sub": "på högsta nivån; under en befintlig plats lägger du till från platsen",
  "adm.loc.ed.inactive": "Avaktiverade ({n})",
  "adm.loc.ed.activate": "Aktivera",
  "adm.set.loc.classes": "Lagringsklasser",
  "adm.set.loc.classes.hint": "Temperaturen en plats har. Sätts på zon, gång eller plats under Lagerplatser och ärvs nedåt; artikelns krav jämförs med den.",
  "adm.set.loc.classes.name": "Namn",
  "adm.set.loc.classes.key": "Nyckel",
  "adm.set.loc.classes.min": "Lägst",
  "adm.set.loc.classes.max": "Högst",
  "adm.set.loc.classes.add": "Ny klass",
  "adm.set.loc.classes.new": "Ny klass",
  "adm.set.loc.check": "Fel lagringsklass vid inlagring",
  "adm.set.loc.check.hint": "När en artikel läggs på en plats med annan klass än den kräver. Gäller telefonens inlagring och flytt; inlagringsförslagen föredrar rätt klass.",
  "adm.set.loc.check.off": "Tillåt",
  "adm.set.loc.check.warn": "Varna",
  "adm.set.loc.check.refuse": "Neka",
  "adm.lay.report.newAisles": "Nya gångar skapas i trädet: {codes}",
  "adm.lay.report.extra": "{aisle}: {n} platser i trädet som komponenten inte beskriver (lämnas): {codes}",
  "adm.lay.empty": "Läs in ritningen som SVG, eller välj ett verktyg och rita direkt.",
  "adm.lay.canvasHint": "Markera: klicka på ett element. Ställage/Yta/Port: dra upp en rektangel. Bakgrunden är ritningen i millimeter.",
  "adm.lay.pick": "Klicka på ett element i kartan för att redigera det.",
  "adm.lay.counts": "{racks} ställage, {bound} bundna · {areas} ytor",
  "adm.lay.rack": "Ställage",
  "adm.lay.unbound": "ej bundet",
  "adm.lay.aisle": "Gång/rad i trädet",
  "adm.lay.binsWord": "platser",
  "adm.lay.bays": "Sektioner",
  "adm.lay.levels": "Hyllor",
  "adm.lay.orientation": "Orientering",
  "adm.lay.shortOut": "Kortsida ut",
  "adm.lay.longOut": "Långsida ut",
  "adm.lay.perBay": "Fack per sektion",
  "adm.lay.suggest": "Förslag: {n}",
  "adm.lay.generates": "Genererar {n} platser",
  "adm.lay.inTree": "{n} finns i trädet",
  "adm.lay.overrides": "Avvikande sektioner (fack per sektion)",
  "adm.lay.unsaved": "osparade ändringar",
  "adm.lay.map": "Karta",
  "adm.lay.canvasHint.select": "Klicka på ett element för att redigera det, dra det för att flytta. Hjul eller nyp zoomar, dra på tom yta panorerar. Verktygen Ställage, Yta och Port ritar nya genom att dra upp en rektangel.",
  "adm.lay.zoomIn": "Zooma in",
  "adm.lay.zoomOut": "Zooma ut",
  "adm.lay.zoomFit": "Anpassa",
  "adm.lay.canvasHint.draw": "Ställage: dra från där sektion 1 börjar längs raden; längden ger antalet sektioner, storleken följer sedan inställningen. Yta och port: dra upp rektangeln.",
  "adm.lay.pick.empty": "Läs in ritningen med knappen uppe till höger, eller rita direkt med verktygen ovanför kartan.",
  "adm.lay.scale": "Skala",
  "adm.lay.scale.hint": "Vad en enhet i ritningen motsvarar i verkligheten. En ritning i modellmillimeter har 1 = 1.",
  "adm.lay.unit": "enhet",
  "adm.lay.planSize": "Ritningens storlek",
  "adm.lay.pallet": "Pallplats",
  "adm.lay.marginWord": "marginal",
  "adm.lay.long": "lång",
  "adm.lay.deep": "djup",
  "adm.lay.aisle.hint": "Vid bindning fylls sektioner, hyllor och fack från det trädet redan vet om gången; justera sedan.",
  "adm.lay.boundElsewhere": "bunden till ett annat ställage",
  "adm.lay.alsoOn": "även på {n} annat ställage",
  "adm.lay.bayStart": "första sektion",
  "adm.lay.bayStartLabel": "Första sektionens nummer",
  "adm.lay.grp.place": "Placering",
  "adm.lay.grp.size": "Mått",
  "adm.lay.grp.result": "Resultat",
  "adm.lay.continues": "{code} fortsätter här från sektion {from}.",
  "adm.lay.sharedAisle": "{code} är delad på flera ställage: sektionerna {ranges}.",
  "adm.lay.inferred": "{code}: trädet säger {bays} sektioner, {levels} hyllor och {per} fack per sektion, {diff} sektioner avviker. Kontrollera i bilden.",
  "adm.lay.bays.hint": "Med balkarna blir ställaget {len} m långt.",
  "adm.lay.levels.hint": "Räknat från golvet; sektioner med annat antal sätts i bilden.",
  "adm.lay.orientation.hint": "Ställaget är {depth} mm djupt i ritningen: 1 200 betyder kortsida ut, 800 långsida ut.",
  "adm.lay.perBay.hint": "Med {face} mm mot gången och marginalen ryms {n} på balken.",
  "adm.lay.bindFirst": "Bind ställaget till en gång för att se koderna.",
  "adm.lay.differing": "Avvikande sektioner: {bays}",
  "adm.lay.illustration": "Så här blir ställaget",
  "adm.lay.view3d": "3D",
  "adm.lay.viewFront": "Framifrån",
  "adm.lay.illustrationHint": "Sektioner från vänster, hyllor från golvet, fack från vänster. I 3D: dra för att vrida, hjul zoomar, högerklick-dra flyttar. Klicka på en sektion för att ge den egna hyllor eller fack.",
  "adm.lay.type": "Ställagetyp",
  "adm.lay.type.hint": "Typen ger sektionens bredd, djup, stolpe, höjd och hyllor; byte sätter typens värden. Typerna ställs in under Inställningar → Anläggning → Lagerlayout.",
  "adm.lay.levelHeights": "Hyllhöjder nerifrån (mm)",
  "adm.lay.levelHeights.hint": "Kommaseparerat, en per hylla. Tomt = typens eller jämnt fördelat. Summa {sum} av {h} mm.",
  "adm.lay.levelHeights.bad": "Ange {n} höjder i mm, kommaseparerat, eller lämna tomt.",
  "adm.set.layout.types": "Ställagetyper",
  "adm.set.layout.types.hint": "Mallar som ställagen i Lagerlayout pekar ut. Fast bredd = hyllställ; uträknad = pallställ (pallar + marginal).",
  "adm.set.layout.types.add": "Ny typ",
  "adm.set.layout.types.holds.pallet": "Pall",
  "adm.set.layout.types.holds.carton": "Kartong",
  "adm.set.layout.types.width.computed": "Uträknad",
  "adm.set.layout.types.width.fixed": "Fast",
  "adm.set.layout.types.cols": "Namn|Rymmer|Bredd|mm|Fack|Djup|Stolpe|Höjd|Hyllor|Hyllhöjder|Pallar/fack",
  "adm.set.layout.types.pallets.hint": "Hur många pallar ett fack tar. Tomt = 1 för pallställ, obegränsat för hyllställ. 0 = obegränsat. Skrivs på platserna vid publicering.",
  "adm.lay.bayEdit": "Sektion {n} — avvikelser",
  "adm.lay.aisleSide": "gången är här · {face} mm pallsida mot gången",
  "adm.lay.aisleSide.plain": "gången är här",
  "adm.lay.clearOverride": "Ta bort avvikelsen",
  "adm.lay.bay": "Sektion {n}",
  "adm.lay.remove": "Ta bort element",
  "adm.lay.split": "Dela i två ställage",
  "adm.lay.split.hint": "En dubbelrad är två ställage rygg mot rygg som vetter mot var sin gång; de binds var för sig.",
  "adm.lay.split.done": "Delat. Bind varje halva till sin gång.",
  "adm.lay.split.warn": "Det här är {depth} mm djupt — troligen en dubbelrad. Dela i två och bind halvorna till var sin gång.",
  "adm.lay.role": "Roll",
  "adm.lay.role.receiving": "Godsmottagning",
  "adm.lay.role.staging": "Uppställning",
  "adm.lay.role.packing": "Packning",
  "adm.lay.role.other": "Annan yta",
  "adm.lay.areaLocation": "Lagerplats i trädet",
  "adm.lay.label": "Etikett",
  "adm.lay.storageClass": "Lagringsklass",
  "adm.lay.report.areaClass": "Ytan {code} får lagringsklass {cls}",
  "adm.lay.report.unchanged": "oförändrad",
  "adm.lay.storageClass.hint": "Skrivs på den bundna platsen när layouten publiceras; allt under ärver (Kylrum, Livsmedelslokal).",
  "adm.counting": "Inventering",
  "adm.cnt.sub": "omgångar planeras här, räknas på telefonen och godkänns här innan saldot ändras",
  "adm.cnt.new": "Ny omgång",
  "adm.cnt.plan": "Planera en omgång",
  "adm.cnt.plan.sub": "välj i lagerplatsträdet: en gång, en hylla, flera gångar eller en zon",
  "adm.cnt.plan.hint": "Platserna låses var för sig när någon öppnar dem på telefonen; flera kan räkna i samma gång. Godkännande här innan något justeras.",
  "adm.cnt.selected": "Valt",
  "adm.cnt.bins": "{n} platser",
  "adm.cnt.name": "Namn",
  "adm.cnt.defaultName": "Inventering {date}",
  "adm.cnt.rule": "Mängd räknas",
  "adm.cnt.rule.site": "Anläggningens inställning",
  "adm.cnt.start": "Starta omgången",
  "adm.cnt.round": "Omgång",
  "adm.cnt.progress": "Platser klara",
  "adm.cnt.missingN": "{n} saknas",
  "adm.cnt.none": "Ingen omgång ännu.",
  "adm.cnt.locks": "Platser under räkning just nu",
  "adm.cnt.pick": "Välj en omgång till vänster, eller planera en ny.",
  "adm.cnt.detail.sub": "{done} av {total} platser klara · startad av {by}",
  "adm.cnt.k.done": "Platser klara",
  "adm.cnt.k.present": "Kolli bekräftade",
  "adm.cnt.k.missing": "Saknas",
  "adm.cnt.k.found": "Hittade",
  "adm.cnt.dev": "Avvikelse",
  "adm.cnt.container": "Kolli",
  "adm.cnt.means": "Innebär",
  "adm.cnt.dev.missing": "saknas",
  "adm.cnt.dev.quantity": "annan mängd",
  "adm.cnt.noneYet": "Inget räknat ännu.",
  "adm.cnt.noDev": "Inga avvikelser.",
  "adm.cnt.counts": "Resultat",
  "adm.cnt.who": "Vem · när",
  "adm.cnt.loc.counted": "Räknad",
  "adm.cnt.loc.counting": "Pågår",
  "adm.cnt.loc.pending": "Väntar",
  "adm.cnt.loc.counts": "{present} bekräftade · {missing} saknas · {found} hittade",
  "adm.cnt.approve": "Godkänn · {n} justeringar",
  "adm.cnt.approve.hint": "Saknade kolli justeras ut och räknade mängder sätts; affärssystemet får justeringarna per batch.",
  "adm.cnt.approve.partial": "Alla platser är inte räknade. Godkänner du nu justeras bara det som är räknat; resten lämnas.",
  "adm.cnt.approveConfirm": "Godkänn omgången och gör {n} justeringar i lagersaldot?",
  "adm.cnt.approved": "Godkänd. {n} justeringar gjorda.",
  "adm.cnt.cancel": "Avbryt omgången",
  "adm.cnt.cancelConfirm": "Avbryta omgången? Räknade platser behålls som observationer, inget justeras.",
  "adm.cnt.status.open": "Pågår",
  "adm.cnt.status.review": "Att granska",
  "adm.cnt.status.approved": "Godkänd",
  "adm.cnt.status.cancelled": "Avbruten",
  "adm.set.counting.quantity": "Mängd räknas",
  "adm.set.counting.quantity.hint": "Inget: skanning räcker. Brutna kolli: mängd frågas för kolli som delats. Allt: mängd frågas för varje kolli.",
  "adm.set.counting.quantity.none": "Inget",
  "adm.set.counting.quantity.split": "Brutna kolli",
  "adm.set.counting.quantity.all": "Allt",
  "adm.set.counting.adHoc": "Räkna enskild plats från klienten",
  "adm.set.counting.adHoc.hint": "Utan omgång: platsen framför en.",
  "adm.set.counting.zeroPoint": "Nollpunkt vid plock",
  "adm.set.counting.zeroPoint.hint": "När det sista kända kollit lämnar en plats bekräftar plockaren att den är tom.",
  "adm.set.counting.zeroPoint.off": "Av",
  "adm.set.counting.zeroPoint.on": "På",
  "adm.set.counting.zeroPoint.storage": "Endast lagerplatser",
  "adm.set.counting.lock": "Låsning under räkning",
  "adm.set.counting.lock.text": "Alltid: platsen som räknas tar inte emot inlagring och plockas inte från, tills den är klar.",
  "adm.set.counting.erpCountDate": "Inventeringsdatum till affärssystemet",
  "adm.set.counting.erpCountDate.hint": "Adaptern skriver räknad mängd, datum och vem per batchrad när affärssystemet har fält för det (Visma: per batchrad).",
  "adm.set.sec.layout": "Lagerlayout",
  "adm.set.lead.layout": "måtten ritverktyget räknar med och hur platser namnges",
  "adm.set.layout.binCode": "Platskod",
  "adm.set.layout.binCode.hint": "Mönstret en ställagekomponent namnger sina platser med. {aisle} gång, {bay} sektion, {level} hylla, {compartment} fack.",
  "adm.set.layout.pallet": "Pallplats",
  "adm.set.layout.pallet.hint": "Långsida × kortsida och marginalen mellan platser; avgör hur många fack en sektion rymmer.",
  "adm.set.layout.beam": "Balklängd",
  "adm.set.layout.beam.hint": "Längden mellan två stolpar. Tomt = räknas ut per sektion: pallarna sida vid sida plus marginalen på varje sida (EN 15620: minst 75 mm under 3 m, 100 mm över). Ange ett värde bara om alla balkar är lika långa.",
  "adm.set.layout.beam.auto": "uträknas",
  "adm.lay.beam": "Balklängd",
  "adm.lay.beam.hint": "Anläggningens balk är {site} mm; tomt = den. Avvikande sektioner sätts i bilden.",
  "adm.lay.beam.hint.auto": "Tomt = uträknad: {per} pallar + marginal {margin} mm på varje sida = {beam} mm. Ange ett värde om balken är längre.",
  "adm.lay.beam.bad": "Ange 500–10 000 mm, eller lämna tomt för anläggningens balklängd.",
  "adm.lay.mismatch": "Ritningen säger {plan} m, sektionerna ger {cfg} m.",
  "adm.lay.fitBays": "Anpassa sektioner till ritningen",
  "adm.lay.fitRect": "Anpassa rektangeln efter inställningen",
  "adm.lay.reverse": "Vänd sektionsordningen",
  "adm.lay.reverse.hint": "Sektion 1 i andra änden (punkten i kartan visar var sektion 1 börjar).",
  "adm.lay.rotate": "Vrid 90°",
  "adm.lay.sizedByConfig": "storleken följer sektionerna",
  "adm.set.layout.rackHeight": "Ställagehöjd",
  "adm.set.layout.rackHeight.hint": "Alla ställage är lika höga om inget annat sägs på ställaget; hyllorna fördelas jämnt på höjden.",
  "adm.lay.height": "Höjd",
  "adm.lay.height.hint": "Anläggningens höjd är {site} mm; tomt = den. Med den här indelningen blir varje hylla {pitch} mm.",
  "adm.lay.height.site": "Anläggningens",
  "adm.lay.height.bad": "Ange 500–20 000 mm, eller lämna tomt för anläggningens höjd.",
  "adm.lay.rackHeightWord": "höjd",
  "adm.lay.siteSettingsHint": "Måtten ändras under Inställningar → Anläggning → Lagerlayout.",
  "adm.set.sec.counting": "Inventering",
  "adm.set.sec.reasons": "Orsakskoder",
  "adm.set.lead.general": "anläggningen, godsmottagningen och vem som får flytta",
  "adm.set.lead.identity": "hur kollin känns igen och vad som krävs av etiketten, för alla flöden",
  "adm.set.lead.receiving": "flöden på telefonen, pallar och palletiketter",
  "adm.set.lead.putaway": "vad inlagringen föreslår och hur hårt det gäller",
  "adm.set.lead.pickList": "hur telefonen ordnar kundorderna och vilka transportörer som hämtar när",
  "adm.set.lead.outPallet": "hur utleveranspallarna byggs och märks medan plockaren går",
  "adm.set.lead.counting": "rundor, godkännande och toleranser",
  "adm.set.pickList": "Plocklistan",
  "adm.set.outPallet": "Utleveranspallen",
  "adm.set.counting.soon": "Kommer med inventeringen: inventeringsrundor, godkännande av skillnader och toleranser.",
  "adm.set.receivingLocation.hint": "Platsen där mottaget gods står tills det lagras in.",
  "adm.set.defaultProfile.hint": "Gäller artiklar som ingen tilldelning pekar ut. Profilerna och tilldelningen finns under Register → Hanteringsprofiler.",
  "adm.set.sites": "Anläggningar",
  "adm.set.sites.hint": "En anläggning per lager. Namn, adress och GLN redigeras här när anläggningssidan är byggd.",
  "adm.set.companyRules": "Regler för alla anläggningar",
  "adm.set.companyRules.soon": "Kommer med profiler i nivåer: bolagets standardprofil, vilken indelning som pekar ut profiler, och låset mot lägre nivåer.",
  "adm.prof.assignLead": "Artiklar utan tilldelning får anläggningens standardprofil {profile}. Indelningen är i dag varukategori; vilket fält som styr blir ett bolagsval.",
  "adm.prof.byDimension": "{dimension} → profil · nivåerna under kan avvika där det är öppet",
  "adm.prof.assignLead2": "Kedjan: bolagets standard ({company}) → anläggningens standard ({site}) → {dimension} → artikel. Varje nivå kan låsa nivåerna under sig. Indelningarna och deras ordning väljs under Inställningar → Bolag.",
  "adm.prof.chainStep": "Steg {n} i kedjan: gäller bara artiklar som {prev} lämnade vidare (värde utan regel, eller regel som tillåter lägre nivåer).",
  "adm.prof.passOn": "Lämna vidare till {next}",
  "adm.prof.reach": "{reach} av {n}",
  "adm.prof.reachHint": "{n} artiklar är redan låsta av ett tidigare steg i kedjan och nås inte av den här regeln.",
  "adm.prof.articlesMay": "Artiklar får avvika",
  "adm.prof.locked": "låst",
  "adm.prof.lockedByCompany": "Bolagets standardprofil är låst för lägre nivåer. Öppna den under Inställningar → Bolag för att peka ut profiler här.",
  "adm.prof.lockedBySite": "Anläggningens standardprofil är låst för lägre nivåer. Öppna den under Inställningar → Anläggning → Identitet och batch.",
  "adm.set.lead.companyRules": "profilen är det enda som sätts; nivåerna pekar ut den",
  "adm.set.companyDefault.hint": "Gäller i hela bolaget där ingen lägre nivå pekar ut en annan profil.",
  "adm.set.allowBelow": "Lägre nivåer får ändra",
  "adm.set.allowBelow.company.hint": "Nej: anläggning, indelning och artikel får inte peka ut någon annan profil. Standard är Nej.",
  "adm.set.allowBelow.site.hint": "Nej: indelningens regler och artiklarna får inte avvika från anläggningens standardprofil.",
  "adm.set.dimension": "Indelningar som pekar ut profil, i ordning",
  "adm.set.dimension.hint": "Artikelfält från registret nedan, provade i tur och ordning: ett värde utan regel lämnar beslutet vidare, en regel kan låsa det som följer. Tilldelningen per värde görs under Register → Hanteringsprofiler.",
  "adm.set.dimension.add": "Lägg till indelning …",
  "adm.set.dimension.up": "Flytta upp",
  "adm.set.dimension.down": "Flytta ned",
  "adm.set.dimension.none": "Ingen, bara per artikel",
  "adm.set.dimension.values": "värden",
  "adm.set.dimension.key": "Nyckel",
  "adm.set.dimension.source": "Källa",
  "erp.refreshing": "Hämtar ändringar från affärssystemet …",
  "erp.readingOrder": "Läser order {ref} från affärssystemet …",
  "erp.fetchingOrder": "Order {ref} finns inte här ännu. Hämtar från affärssystemet …",
  "erp.fetchingRow": "Finns inte här ännu · hämtar från affärssystemet …",
  "erp.orderNotInErp": "Ingen öppen inköpsorder {ref} i affärssystemet.",
  "erp.orderNotInErp.sales": "Ingen order {ref} bland dagens order i affärssystemet.",
  "erp.orderOutsideRule": "Order {ref} finns i affärssystemet men är inte bekräftad för i dag.",
  "erp.orderChanged": "Ordern ändrades i affärssystemet",
  "erp.locked": "Ordern är öppen i affärssystemet",
  "erp.lockedTag": "Låst i affärssystemet",
  "erp.lockedMsg": "Order {ref} är öppen i affärssystemet (process {process} {by}). Inget kan plockas eller tas emot förrän den som har den öppen stänger den.",
  "erp.orderChanged.msg": "Raderna är omlästa. Kontrollera det du håller på med.",
  "erp.notReached": "Affärssystemet svarade inte",
  "erp.notReached.msg": "Visar ordern som den senast lästes.",
  "adm.set.erp.returnsWh": "Returer: lagerval per rad",
  "adm.set.erp.returnsWh.hint": "På: den som tar emot väljer lager i affärssystemet när Trail skapar en rad på returordern, orderhuvudets lager förvalt; kontorets rader behåller sitt. Av: allt går till huvudets lager.",
  "adm.set.erp.lineGtin": "GTIN på orderrader hämtas från",
  "adm.set.erp.lineGtin.hint": "Artikelregistret: artikelns egna GTIN i Trail gäller, orderradens värde används inte. Orderraden: affärssystemets värde på raden när det finns, annars registret.",
  "adm.set.erp.lineGtin.register": "Artikelregistret",
  "adm.set.erp.lineGtin.line": "Orderraden",
  "adm.set.erp.refreshBeforeWork": "Läs om ordern före arbete",
  "adm.set.erp.refreshBeforeWork.hint": "Innan en inleverans eller plockning börjar läses ordern från affärssystemet igen; operatören väntar några sekunder och ordern är aktuell.",
  "erp.updated": "Affärssystemet läst {time}",
  "adm.set.erp": "Affärssystem",
  "adm.set.lead.erp": "speglingen körs i platsagenten på bolagets uppdrag; här slås den på och här syns varje körning",
  "adm.set.erp.bundle": "Adapter",
  "adm.set.erp.every": "Var",
  "adm.set.erp.minutes": "{n} min",
  "adm.set.erp.lastRun": "Senaste körning",
  "adm.set.erp.result": "{docs} dokument · {created} nya, {updated} ändrade, {unchanged} oförändrade, {errors} fel",
  "adm.set.erp.took": "{s} s",
  "adm.set.erp.ok": "Kör",
  "adm.set.erp.partial": "Delvis fel",
  "adm.set.erp.failed": "Misslyckades",
  "adm.set.erp.waiting": "Väntar på första körningen",
  "adm.set.erpReport": "Rapportering till affärssystemet",
  "adm.set.lead.erpReport": "vad Trail skickar tillbaka: plock, inleveranser, inventeringar",
  "adm.set.erpReport.mode": "Läge",
  "adm.set.erpReport.mode.shadow": "Skugga",
  "adm.set.erpReport.mode.live": "Skarpt",
  "adm.set.erpReport.mode.shadow.hint": "Anropen byggs och visas i loggen men skickas inte. Byt till skarpt först när anropen är granskade och adaptern är upplåst.",
  "adm.set.erpReport.mode.live.hint": "Anropen skickas till affärssystemet. Adapterns egen spärr (writes.enabled) måste också vara av för att något ska gå.",
  "adm.set.erpReport.salesOrders": "Plockade ordrar",
  "adm.set.erpReport.salesOrders.hint": "Ordern avslutas i affärssystemet med plockad mängd och batcher per rad.",
  "adm.set.erpReport.receipts": "Inleveranser",
  "adm.set.erpReport.receipts.hint": "Varje mottagen pall rapporteras direkt som delleverans på inköpsordern: per rad mängden och de batcher som skapas i Visma med bäst före. Batchspårade artiklar kan inte tas emot utan batch, det stoppar hanteringsprofilen redan vid skanningen; bara artiklar utan batchspårning rapporteras med enbart mängd. När leveransen stängs skrivs inget till affärssystemet: det som inte kom noteras i loggen med orsak, och kontoret avgör i Visma vad som ska hända med resten.",
  "adm.set.erpReport.adjustments": "Godkända inventeringar",
  "adm.set.erpReport.adjustments.hint": "Varje justering per batch rapporteras när rundan godkänns.",
  "adm.set.erpReport.col.kind": "Rapport",
  "adm.set.erpReport.col.ref": "Referens",
  "adm.set.erpReport.col.result": "Resultat",
  "adm.set.erpReport.none": "Inga rapporter ännu. De skapas när en order plockas, en pall tas emot mot en inleverans eller en inventering godkänns.",
  "adm.set.erpReport.kind.sales-order.picked": "Order plockad",
  "adm.set.erpReport.kind.receipt.received": "Pall mottagen",
  "adm.set.erpReport.kind.receipt.closed": "Inleverans stängd",
  "adm.set.erpReport.kind.stock.adjusted": "Inventering godkänd",
  "adm.set.erpReport.st.pending": "väntar på agenten",
  "adm.set.erpReport.st.claimed": "hos agenten",
  "adm.set.erpReport.st.shadow": "skugga – inte skickad",
  "adm.set.erpReport.st.sent": "skickad",
  "adm.set.erpReport.st.failed": "misslyckades",
  "adm.set.erpReport.st.skipped": "avstängd",
  "adm.set.erpReport.attempts": "{n} försök",
  "adm.set.erpReport.showCall": "Visa anropet ({n} operationer)",
  "adm.set.erpReport.retry": "Skicka igen",
  "adm.set.erpReport.sum.sent": "{n} skickade",
  "adm.set.erpReport.sum.failed": "{n} misslyckade",
  "adm.set.erpReport.sum.pending": "{n} väntar",
  "adm.set.erpReport.sum.shadow": "{n} skugga",
  "adm.set.erpReport.sum.latest": "senaste: {kind} {ref} · {at}",
  "adm.set.erpReport.openLog": "Öppna loggen →",
  "adm.set.csec.company": "Företagsuppgifter",
  "adm.set.csec.rules": "Regler & indelningar",
  "adm.set.csec.erp": "Affärssystem",
  "adm.set.csec.reporting": "Rapportering",
  "adm.erpReports": "Affärssystem",
  "adm.erpReports.title": "Rapporter till affärssystemet",
  "adm.erpReports.sub": "allt Trail har skickat eller tänkt skicka: plock, inleveranser, inventeringar",
  "adm.erpReports.search": "Sök ordernr, inleverans, runda, kund…",
  "adm.erpReports.all": "Alla",
  "adm.erpReports.allKinds": "Alla rapporttyper",
  "adm.erpReports.period.30": "Senaste 30 dagarna",
  "adm.erpReports.period.90": "Senaste 90 dagarna",
  "adm.erpReports.period.all": "Hela loggen",
  "adm.erpReports.more": "Visa {n} till",
  "adm.erpReports.of": "{a} av {b}",
  "adm.erpReports.col.agent": "Agent",
  "adm.erpReports.erpSaid": "Affärssystemet svarade",
  "adm.erpReports.ops": "{n} operationer",
  "adm.erpReports.created": "Skapad",
  "adm.erpReports.answer": "Affärssystemets svar",
  "adm.erpReports.notes": "Noteringar",
  "adm.erpReports.call": "Anropet",
  "adm.erpReports.payload": "Underlaget",
  "adm.erpReports.payload.sub": "det Trail rapporterade, oberoende av affärssystem",
  "adm.erpReports.retried": "{ref} läggs i kön igen; agenten tar den inom en minut.",
  "adm.erpReports.dismiss": "Avfärda",
  "adm.erpReports.dismissed": "{ref} avfärdad; inget skickas, raden står kvar som historik.",
  "dev.erpPickReverted": "Plock backat i affärssystemet",
  "dev.erpPickLineReverted": "Rad backad i affärssystemet",
  "common.show": "Visa",
  "common.hide": "Dölj",
  "adm.set.erp.off": "Pausad",
  "adm.set.erp.pause": "Pausa",
  "adm.set.erp.resume": "Återuppta",
  "adm.set.erp.removeConfirm": "Ta bort uppdraget? Agenten slutar spegla för det här bolaget.",
  "adm.set.erp.add": "Slå på spegling",
  "adm.set.erp.addMore": "Lägg till en spegling till",
  "adm.set.erp.readAll": "Läs om allt nu",
  "adm.set.erp.readAll.hint": "Begär en fullständig läsning av register, ordrar och saldon vid nästa körning, utöver den dagliga.",
  "adm.set.erp.readAll.requested": "Fullständig läsning begärd. Agenten tar den inom en minut; resultatet syns på raden.",
  "adm.set.erp.readAll.pending": "En begäran väntar redan.",
  "adm.set.erp.readAll.fresh": "Agenten körde alldeles nyss; försök om en stund.",
  "adm.set.erp.start": "Starta",
  "adm.set.erp.saved": "Sparat.",
  "adm.set.erp.rules": "Regler",
  "adm.set.erp.rulesTitle": "Regler för {bundle} på {host}",
  "adm.set.erp.rulesHint": "Adapterns standardvärden visas grått. Redigera ett block för att ge bolagets egna värden (JSON); de tar över blocket vid nästa körning. Blocket company bär affärssystemets bolagsnummer och agerande användare för just den här körningen; anslutningen till affärssystemet ställs på agentdatorn.",
  "adm.set.erp.rules.own": "egna värden",
  "adm.set.erp.held": "Hölls: {n} makuleringar väntar på beslut under Avvikelser.",
  "adm.scope.title": "Vilka ordrar Trail läser från affärssystemet",
  "adm.scope.sub": "regeln avgör vad som är plockbart och mottagbart · golvet hur långt bakåt den fullständiga läsningen tittar",
  "adm.scope.salesOrders": "Kundordrar",
  "adm.scope.purchaseOrders": "Inköpsordrar",
  "adm.scope.rule": "Regel",
  "adm.scope.kind.confirmed-today": "Bekräftade i dag",
  "adm.scope.kind.confirmed-by-today": "Bekräftade t.o.m. i dag",
  "adm.scope.kind.flag": "Flagga i affärssystemet",
  "adm.scope.kind.open": "Alla med något kvar",
  "adm.scope.ruleHint.salesOrders": "Öppen = raderna har något kvar att plocka. Affärssystemets avslutsdatum används inte: det fylls i vid delleverans.",
  "adm.scope.ruleHint.purchaseOrders": "Öppen = raderna har något kvar att ta emot.",
  "adm.scope.floor": "Läs ordrar daterade från",
  "adm.scope.floor.days": "Dagar bakåt",
  "adm.scope.floor.date": "Fast datum",
  "adm.scope.floor.none": "Inget golv",
  "adm.scope.floor.notForToday": "Gäller inte här: regeln läser bara ordrar med dagens bekräftade leveransdatum.",
  "adm.scope.daysBack": "dagar",
  "adm.scope.own": "bolagets eget värde",
  "adm.scope.default": "paketets standard",
  "adm.scope.floorHint": "Jämförs mot {col}. Skapat- och ändratdatum används inte; ändringsstämpeln styr bara deltaläsningarna. Utan golv läser den fullständiga läsningen hela orderregistret.",
  "adm.scope.col.orderDate": "orderdatum",
  "adm.scope.col.deliveryDate": "bekräftat leveransdatum",
  "adm.scope.now": "Just nu",
  "adm.scope.now.bad": "Golvet utesluter {n} öppna ordrar",
  "adm.scope.now.loading": "Räknar mot spegeln …",
  "adm.scope.now.noFloor": "Inget golv. Trail har {open} öppna; alla läses.",
  "adm.scope.now.ok": "Ordrar daterade från {from}. Trail har {open} öppna, alla inom golvet.",
  "adm.scope.now.badText": "Golvet {from} ligger efter {col} på öppna ordrar ({min} – {max}). Nästa fullständiga läsning skulle vilja makulera dem; makuleringsspärren håller det för beslut. Sätt ett fast datum före {min}, eller välj Inget golv.",
  "adm.scope.now.missing": "{n} öppna ordrar saknar orderdatum i spegeln ännu (fylls i vid nästa körning).",
  "adm.set.cancelGuard": "Makuleringsspärr · ordrar per körning",
  "adm.set.cancelGuard.hint": "Säger en läsning att så många öppna ordrar inte längre finns i affärssystemet makuleras de inte. De hålls, ordrarna fortsätter som öppna, och beslutet ligger under Avvikelser. Under gränsen makuleras som vanligt: en order som stängts i affärssystemet försvinner från listan.",
  "adm.set.cancelGuard.moreThan": "fler än",
  "adm.set.cancelGuard.orShare": "ordrar, eller mer än",
  "adm.set.cancelGuard.ofOpen": "% av de öppna",
  "dev.erpCancelHeld": "Makulering hålls av spärren",
  "adm.dev.hold.changeFloor": "Ändra golvet",
  "adm.dev.hold.changeFloor.hint": "Inställningar → Bolag → Affärssystem → Regler",
  "adm.dev.hold.reread": "Läs om",
  "adm.dev.hold.rereadRequested": "En fullständig läsning är begärd. Listar den ordrarna igen stängs avvikelsen av sig själv.",
  "adm.dev.hold.dismiss": "Behåll öppna",
  "adm.dev.hold.apply": "Makulera {n} ordrar",
  "adm.dev.hold.applyConfirm": "Makulera {n} ordrar i Trail? De återöppnas om affärssystemet listar dem igen.",
  "adm.set.erp.rules.default": "standard",
  "adm.set.erp.rules.reset": "Tillbaka till standard",
  "adm.set.erp.rules.edit": "Redigera",
  "adm.set.erp.none": "Ingen spegling påslagen. Agenten läser affärssystemet och skickar hit register, order och saldon på schema.",
  "adm.set.erp.noBundles": "Servern har ingen adapter att dela ut.",
  "adm.set.erp.noAgent": "Registrera en platsagent i det här bolaget först (System → Platsagenter).",
  "adm.set.erp.hint": "Agenten hämtar adaptern signerad från servern, kör den med sin egen inloggning för bolaget och rapporterar hit.",
  "adm.set.dimensions": "Indelningar",
  "adm.set.lead.dimensions": "artikelfält som affärssystemet eller Trail fyller; adaptern mappar sina fält hit · namnet går att ändra",
  "adm.set.dimensions.none": "Inga indelningar ännu. De skapas av artikelimporten.",
  "adm.set.notSet": "Ej satt",
  "adm.set.applies": "Gäller",
  "adm.set.applies.company": "{profile}, satt på bolaget · {lock}",
  "adm.set.applies.open": "lägre nivåer får avvika",
  "adm.set.applies.locked": "låst för anläggning, indelning och artikel",
  "adm.set.applies.none": "Ingen bolagsprofil; anläggningens standardprofil gäller.",
  "adm.set.uniqueLot": "Batchnummer unikt per artikel",
  "adm.set.uniqueLot.hint": "Ja: ett batchnummer är ett kolli. Inleveransen vägrar samma nummer igen, och dubbletter i affärssystemet blir en avvikelse vid speglingen.",
  "adm.set.collision": "Samma identitet igen",
  "adm.set.collision.block": "Avvisa, kontakta arbetsledare",
  "adm.set.collision.count": "Räkna som nytt kolli",
  "adm.set.collision.askSerial": "Fråga efter serienummer",
  "adm.set.collisionSameDay": "Samma identitet igen, när",
  "adm.set.anyDay": "Vilken dag som helst",
  "adm.set.sameDay": "Bara samma dag",
  "adm.set.collisionEscape": "Om serienummer inte kan anges",
  "adm.set.escape.reject": "Avvisa kollit",
  "adm.set.escape.count": "Räkna ändå",
  "adm.set.missingRequired": "Obligatorisk uppgift saknas på etiketten",
  "adm.set.mustEnter": "Måste anges",
  "adm.set.allowWithout": "Får tas emot utan",
  "adm.set.directToStorage": "Inlagring direkt vid mottagning",
  "adm.set.directToStorage.hint": "Pallens sista skanning får vara en lagerplats i stället för mottagningsytan: godset tas emot och lagras in i ett moment. Reglerna för vad platsen tar emot, antal pallar och lagringsklass gäller.",
  "adm.set.directToStorage.on": "Tillåtet",
  "adm.set.directToStorage.off": "Bara mottagningsytan",
  "adm.set.erpReport.shipOnRealised": "Fakturerad = utlevererad",
  "adm.set.erpReport.shipOnRealised.hint": "När affärssystemet realiserar (fakturerar) en order räknas godset som att det lämnat byggnaden: orderns plockade kollin och pallar försvinner ur lagret utan att läsas ut. Av: godset står kvar tills ett utleveranssteg säger annat.",
  "adm.set.erpReport.shipOnRealised.on": "På",
  "adm.set.erpReport.shipOnRealised.off": "Av",
  "adm.set.retireWhenEmpty": "Tom pall",
  "adm.set.retireWhenEmpty.hint": "När sista kollit lämnar en pall avslutas den i Trail: den försvinner ur lagret och platsen, och den som försöker lägga något på den får veta att den är avslutad. Av: pallen står kvar tills någon avslutar den.",
  "adm.set.retireWhenEmpty.on": "Avslutas automatiskt",
  "adm.set.retireWhenEmpty.off": "Står kvar",
  "adm.set.erpReport.maxPerRun": "Skrivspärr · max väntande rapporter",
  "adm.set.erpReport.maxPerRun.hint": "Fler väntande rapporter än så här och inget skickas till affärssystemet förrän någon släpper dem under Drift → Affärssystem. Skyddet mot att Trail plötsligt skriver en massa efter ett fel.",
  "adm.erpReports.held": "{n} rapporter väntar, fler än spärren ({max}) tillåter.",
  "adm.erpReports.held.msg": "Inget skickas till affärssystemet förrän du släpper dem. Kontrollera först att det är rätt att allt går iväg.",
  "adm.erpReports.release": "Släpp alla i 15 minuter",
  "adm.erpReports.released": "Släppta till {until}; agenten tar dem i tur och ordning.",
  "adm.erpReports.releasedUntil": "Spärren är öppen till {until}.",
  "adm.set.outboundLocation": "Utlastningsyta",
  "adm.set.outboundLocation.hint": "Dit flyttas orderpallen med sitt innehåll vid Pall klar, så att lagerplatsen blir ledig direkt. En plats med rollen Utlastning, Pack eller en yta. Tomt = pallen står kvar där den plockades.",
  "adm.set.outboundLocation.none": "Ingen · pallen står kvar",
  "adm.set.outsideOrder": "Artikel som inte finns på inköpsordern",
  "adm.set.outsideOrder.hint": "Skannas ett kolli av en artikel som ordern inte har någon rad för.",
  "adm.set.outsideOrder.refuse": "Nekas",
  "adm.set.outsideOrder.warn": "Tas emot med avvikelse",
  "adm.set.outsideOrder.allow": "Tas emot",
  "msg.notOnOrder": "{what} finns inte på inköpsorder {ref}. Kollit tas inte emot.",
  "adm.set.reasons.dateSources": "Källor för inmatat datum",
  "adm.set.defaultProfile": "Standardprofil",
  "adm.set.reasons": "Orsakskoder",
  "adm.set.reasons.sub": "visas som knappar på telefonen · klicka för att ta bort",
  "adm.set.reasons.short": "Underleverans",
  "adm.set.reasons.extra": "Ej på ordern",
  "adm.set.reasons.add": "Ny orsak + Enter",
  "adm.set.rules": "Tilldelning av profiler",
  "adm.set.rules.sub": "kategori → profil · artikel kan avvika",
  "adm.set.category": "Gäller",
  "adm.set.categoryLvl": "Kategori",
  "adm.set.site": "Plats",
  "adm.set.profile": "Profil",
  "adm.set.inherit": "Platsens ({name})",
  "adm.set.saveRules": "Spara regler",
  "adm.set.profiles": "Hanteringsprofiler",
  "adm.set.profiles.sub": "klicka för ny version",
  "adm.set.identity": "Identitet",
  "adm.set.unit": "Hanteras som",
  "adm.set.unit.container": "Kolli med identitet",
  "adm.set.unit.bulk": "Mängd utan identitet",
  "adm.set.unit.bulkHint": "Artiklar utan batchhantering: streckkoden säger vilken artikel, antalet skrivs alltid av den som tar emot, plockar eller räknar. En rad per artikel och plats, ingen etikett, inget batchnummer; rapporteras till affärssystemet per orderrad. Batch, bäst före och utgångsdatum stängs av.",
  "adm.set.capture": "Krävs",
  "adm.set.newProfile": "Ny profil",
  "adm.set.newVersion": "ändringar blir en ny version",
  "adm.set.partial": "Delad etikett",
  "adm.set.partial.hold": "Vänta på resten",
  "adm.set.partial.accept": "Ta emot ensam kod",
  "adm.set.partial.reject": "Avvisa",
  "adm.set.storageClass": "Lagerklass",
  "adm.set.note": "Anteckning",
  "adm.set.publish": "Publicera",
  "adm.set.versionNote": "En publicerad version ändras aldrig; uppgifter som startat på en version fortsätter på den.",
  "settings.scanSetup": "Skanna inställningskod",
  "settings.setupDone": "API-nyckel och tenant hämtade från koden. Fyll i ditt namn och spara.",
  "resume.title": "En pall är halvskannad ({n} skanningar)",
  "resume.resume": "Fortsätt",
  "resume.discard": "Släng",
  "queue.discard": "Släng den avvisade pallen",
  "queue.discardConfirm": "Den avvisade pallens skanningar går förlorade. Släng?",
} as const;

export type Key = keyof typeof sv;

const en: Record<Key, string> = {
  ...sv,
  "adm.set.afterOrder": "After an order is done",
  "adm.set.afterOrder.menu": "Back to the Utleverans menu",
  "adm.set.afterOrder.next": "Next order",
  "adm.set.afterOrder.hint": "Where the picker lands when the order is done. Both buttons stay; the setting picks the big one.",
  "pick.toOutbound": "To outbound",
  "menu.area.receiving": "Receiving",
  "menu.area.receiving.desc": "Receiving, put-away",
  "menu.area.receiving.waiting": "{n} to put away",
  "menu.area.receiving.deliveries": "{n} deliveries waiting",
  "menu.pallet.deliveries": "{n} open purchase orders to receive",
  "menu.count.rounds": "{n} round open",
  "menu.scanHint": "Scan anything here to look it up.",
  "menu.release": "Release picked orders",
  "menu.ship": "Loading",
  "menu.ship.desc": "Picked orders on the floor · ship when the truck leaves",
  "ship.title": "Loading",
  "ship.listTitle": "Picked orders on the floor",
  "ship.listSub": "Scan the pallet's SSCC or the order number, or choose in the list. Loaded = the goods have left the building.",
  "ship.waiting": "{n} waiting",
  "ship.none": "No picked orders wait for loading.",
  "ship.row": "picked {at} by {by} · {pallets} pallet(s) · {carrier}",
  "ship.notFound": "No picked order waits with {code}.",
  "ship.confirmTitle": "Loaded?",
  "ship.confirmSub": "Picked {at} by {by} · {pallets} pallet(s)",
  "ship.hint": "The pallet and its containers leave stock in Trail. The ERP is not touched; the invoice is its business.",
  "ship.do": "Loaded",
  "ship.done": "Loaded",
  "ship.doneMsg": "{n} order(s) have left the building.",
  "ship.partly": "Partly",
  "ship.partlyMsg": "{ok} of {n} orders loaded; the rest stay in the list.",
  "ship.all": "Load all {carrier} ({n})",
  "ship.allConfirm": "Load all {n} orders for {carrier}?",
  "menu.release.desc": "Picked orders waiting for release",
  "release.title": "Release",
  "release.listTitle": "Picked orders",
  "release.listSub": "Scan the pallet's SSCC or the order number, or choose in the list. Released = stock leaves the ERP.",
  "release.scan": "scan pallet or order …",
  "release.waiting": "{n} waiting",
  "release.none": "No picked orders wait for release.",
  "release.row": "picked {at} by {by} · {pallets} pallets · {carrier}",
  "release.pickup": "collected",
  "release.notFound": "No picked order waits with {code}.",
  "release.confirmTitle": "Release the order?",
  "release.confirmSub": "Picked {at} by {by} · {pallets} pallets",
  "release.line": "Line {n}",
  "release.hint": "Stock leaves the ERP and the order can be invoiced. The delivery note can be printed already.",
  "release.do": "Release",
  "release.done": "Released",
  "release.doneMsg": "{n} order released.",
  "release.partly": "Partly",
  "release.partlyMsg": "{ok} of {n} released; the rest stay in the list.",
  "release.all": "Release all for {carrier}",
  "release.allConfirm": "Release {n} orders for {carrier}?",
  "pick.manual": "Without scan",
  "pick.takeHere": "Take here",
  "pick.manualTitle": "Which batch did you take? · {product}",
  "pick.manualSub": "Every carton of the article in stock, first-expiry first. Search by batch or location. The comment is required.",
  "pick.manualTooShort": "too short shelf life for the customer",
  "pick.manualNone": "No cartons of the article in stock.",
  "pick.manualSearch": "search batch number",
  "pick.manualWhy": "Why without a scan?",
  "pick.manualNeedsWhy": "Say first why the carton was not scanned.",
  "pick.manualReason": "manual: {note}",
  "common.required": "required",
  "recv.manual": "Without scan",
  "recv.manualWhich": "Which carton?",
  "recv.manualWhichSub": "The order's lines first. A carton not on the order is searched for below.",
  "recv.line": "line {n}",
  "recv.manualNoGtin": "no GTIN – give the article one in the GTIN register",
  "recv.manualOther": "other article: search name or number",
  "recv.manualFacts": "The label's facts · {name}",
  "recv.manualLot": "Batch",
  "recv.manualBestBefore": "Best before (YYYY-MM-DD)",
  "recv.manualQty": "Quantity ({uom})",
  "recv.manualWhy": "Why without a scan?",
  "recv.manualHint": "The carton gets the identity GTIN + batch and is treated as a scanned one, marked manual with your comment. The label prints per the automations.",
  "recv.manualAdd": "Put on the pallet",
  "recv.manualBadQty": "The quantity must be a number above zero.",
  "recv.manualDone": "Batch {lot} registered without a scan.",
  "recv.manualDoneBulk": "{q} registered without a scan.",
  "recv.manualBulkHint": "Bulk article: the quantity is enough, no batch number. The row is marked manual with your comment.",
  "adm.set.erpReport.twoStep": "Customer picks",
  "adm.set.erpReport.twoStep.one": "Together",
  "adm.set.erpReport.twoStep.two": "Two steps",
  "adm.set.erpReport.twoStep.off.hint": "The order is released the moment it is reported picked: the ERP gets the pick and the finish right after each other. Today's way. Customer orders only.",
  "adm.set.erpReport.twoStep.on.hint": "The pick reserves the goods in the ERP. The release is its own step on the phone or under Utleverans; only then does stock leave and invoicing follow.",
  "adm.set.erpReport.kind.sales-order.released": "Order released",
  "adm.out.release": "Release",
  "adm.out.releaseConfirm": "Release order {ref}? Stock leaves the ERP and the order can be invoiced.",
  "adm.out.released": "released {at} by {by}",
  "adm.out.unreported": "Picked, not reported",
  "adm.out.reportPending": "Report on its way",
  "adm.out.unpick": "Take the pick back",
  "adm.out.unpickWhy": "Take back the pick of order {ref}? The cartons become stock again where they stand, the pallet is to be taken apart, the order opens for picking again. Reason:",
  "adm.out.erp": "The ERP",
  "adm.out.erp.sub": "read {at} · pick, release and realisation per batch",
  "adm.out.erp.line": "Line",
  "adm.out.erp.batch": "Batch · Visma no",
  "adm.out.erp.lineTotal": "line total",
  "adm.out.erp.picked": "Picked",
  "adm.out.erp.finished": "Released",
  "adm.out.erp.realised": "Realised",
  "adm.out.erp.none": "Nothing read from the ERP yet.",
  "adm.out.realised": "Invoiced · locked",
  "adm.out.realised.hint": "The reservation is realised in the ERP. The pick and release can no longer be undone, there or here.",
  "adm.set.erpReport": "Reports to the ERP",
  "adm.set.lead.erpReport": "what Trail sends back: picks, receipts, counts",
  "adm.set.erpReport.mode": "Mode",
  "adm.set.erpReport.mode.shadow": "Shadow",
  "adm.set.erpReport.mode.live": "Live",
  "adm.set.erpReport.mode.shadow.hint": "Calls are built and shown in the log but not sent. Switch to live once the calls are reviewed and the adapter is unlocked.",
  "adm.set.erpReport.mode.live.hint": "Calls are sent to the ERP. The adapter's own lock (writes.enabled) must also be released before anything goes.",
  "adm.set.erpReport.salesOrders": "Picked orders",
  "adm.set.erpReport.salesOrders.hint": "The order is finished in the ERP with the picked quantity and lots per line.",
  "adm.set.erpReport.receipts": "Receipts",
  "adm.set.erpReport.receipts.hint": "Every received pallet is reported at once as a partial delivery on the purchase order: per line the quantity and the batches created in Visma with their best-before. Lot-tracked articles cannot be received without a lot — the handling profile stops that at the scan; only articles without lot tracking are reported by quantity alone. Closing the receipt writes nothing to the ERP: what did not come is noted in the log with its reason, and the office decides in Visma what happens to the rest.",
  "adm.set.erpReport.adjustments": "Approved counts",
  "adm.set.erpReport.adjustments.hint": "Each adjustment per lot is reported when the round is approved.",
  "adm.set.erpReport.col.kind": "Report",
  "adm.set.erpReport.col.ref": "Reference",
  "adm.set.erpReport.col.result": "Result",
  "adm.set.erpReport.none": "No reports yet. They appear when an order is picked, a pallet is received against a receipt or a count approved.",
  "adm.set.erpReport.kind.sales-order.picked": "Order picked",
  "adm.set.erpReport.kind.receipt.received": "Pallet received",
  "adm.set.erpReport.kind.receipt.closed": "Receipt closed",
  "adm.set.erpReport.kind.stock.adjusted": "Count approved",
  "adm.set.erpReport.st.pending": "waiting for the agent",
  "adm.set.erpReport.st.claimed": "with the agent",
  "adm.set.erpReport.st.shadow": "shadow – not sent",
  "adm.set.erpReport.st.sent": "sent",
  "adm.set.erpReport.st.failed": "failed",
  "adm.set.erpReport.st.skipped": "switched off",
  "adm.set.erpReport.attempts": "{n} attempts",
  "adm.set.erpReport.showCall": "Show the call ({n} operations)",
  "adm.set.erpReport.retry": "Send again",
  "adm.set.erpReport.sum.sent": "{n} sent",
  "adm.set.erpReport.sum.failed": "{n} failed",
  "adm.set.erpReport.sum.pending": "{n} waiting",
  "adm.set.erpReport.sum.shadow": "{n} shadow",
  "adm.set.erpReport.sum.latest": "latest: {kind} {ref} · {at}",
  "adm.set.erpReport.openLog": "Open the log →",
  "adm.set.csec.company": "Company details",
  "adm.set.csec.rules": "Rules & divisions",
  "adm.set.csec.erp": "ERP",
  "adm.set.csec.reporting": "Reporting",
  "adm.erpReports": "ERP",
  "adm.erpReports.title": "Reports to the ERP",
  "adm.erpReports.sub": "everything Trail has sent or meant to send: picks, receipts, counts",
  "adm.erpReports.search": "Search order no, receipt, round, customer…",
  "adm.erpReports.all": "All",
  "adm.erpReports.allKinds": "All report kinds",
  "adm.erpReports.period.30": "Last 30 days",
  "adm.erpReports.period.90": "Last 90 days",
  "adm.erpReports.period.all": "The whole log",
  "adm.erpReports.more": "Show {n} more",
  "adm.erpReports.of": "{a} of {b}",
  "adm.erpReports.col.agent": "Agent",
  "adm.erpReports.erpSaid": "The ERP answered",
  "adm.erpReports.ops": "{n} operations",
  "adm.erpReports.created": "Created",
  "adm.erpReports.answer": "The ERP's answer",
  "adm.erpReports.notes": "Notes",
  "adm.erpReports.call": "The call",
  "adm.erpReports.payload": "The payload",
  "adm.erpReports.payload.sub": "what Trail reported, independent of the ERP",
  "adm.erpReports.retried": "{ref} is queued again; the agent takes it within a minute.",
  "adm.erpReports.dismiss": "Dismiss",
  "adm.erpReports.dismissed": "{ref} dismissed; nothing is sent, the row stays as history.",
  "dev.erpPickReverted": "Pick taken back in the ERP",
  "dev.erpPickLineReverted": "Line taken back in the ERP",
  "common.show": "Show",
  "common.hide": "Hide",
  "pick.zeroTitle": "Is {code} empty now?",
  "pick.zeroMsg": "The last container Trail knew of left the location. Is anything still there?",
  "pick.zeroYes": "Yes, empty",
  "pick.zeroNo": "No, something is still here",
  "pick.zeroDone": "{code} noted as empty.",
  "pick.zeroQueued": "{code} is noted as empty once the phone is online again.",
  "pick.zeroNoDone": "{code} is now in round {name}. Count it when the pallet is done.",
  "count.reportUnknown": "Report to the office",
  "count.skipUnknown": "Skip",
  "count.reported": "Reported to the office: {key}",
  "count.unknownReason": "Count of {code}",
  "dev.unknownContainer": "Unknown container at a count",
  "adm.cnt.last": "counted {at}",
  "adm.cnt.never": "never counted",
  "adm.cnt.neverN": "{n} never counted",
  "adm.cnt.oldest": "oldest {at}",
  "adm.automations": "Automations",
  "adm.templates": "Labels & documents",
  "adm.set.labelsInTemplates": "Designed under Labels & documents",
  "adm.prn.col.dpi": "Resolution",
  "adm.prn.col.kind": "Type",
  "adm.prn.kind.label": "Label printer (ZPL)",
  "adm.prn.kind.document": "Document printer (PDF)",
  "adm.auto.sub": "{n} active · run on the server after the moment",
  "adm.auto.new": "New automation",
  "adm.auto.saved": "Saved {name}",
  "adm.auto.removeConfirm": "Remove the automation {name}? Its run log goes too.",
  "adm.auto.guardBad": "The condition cannot be read",
  "adm.auto.name": "Name",
  "adm.auto.namePh": "e.g. Delivery note when the order is picked",
  "adm.auto.where": "Where",
  "adm.auto.when": "When",
  "adm.auto.if": "If",
  "adm.auto.ifShort": "if",
  "adm.auto.do": "Do",
  "adm.auto.allFlows": "All flows",
  "adm.auto.allCustomers": "All customers",
  "adm.auto.flow.receiving": "Receiving",
  "adm.auto.flow.picking": "Picking",
  "adm.auto.flow.move": "Move",
  "adm.auto.oneCustomer": "one customer",
  "adm.auto.everywhere": "everywhere",
  "adm.auto.whereHint": "The customer comes from the order. Zone, goods owner and profile will follow as more limits.",
  "adm.auto.trig.pallet.started": "Pallet started",
  "adm.auto.trig.pallet.closed": "Pallet done",
  "adm.auto.trig.piece.split": "Piece cut",
  "adm.auto.trig.order.picked": "Order picked",
  "adm.auto.trig.order.released": "Order released",
  "adm.auto.trig.carton.picked": "Carton picked (customer with own label)",
  "adm.auto.trigHint.carton.picked": "When a carton is confirmed in picking for an article where the customer wants its own carton label (from the ERP's information fields).",
  "pick.customerLabel": "customer label prints",
  "adm.auto.trigHint.pallet.started": "When the phone gives the pallet a new SSCC (\"New pallet\"). Only the SSCC is known then.",
  "adm.auto.trigHint.pallet.closed": "When the pallet is saved with its content (\"Pallet done\").",
  "adm.auto.trigHint.piece.split": "When a carton is cut at picking and the piece gets its own lot.",
  "adm.auto.trigHint.order.picked": "When the picker reports the order picked. The delivery note can then be made.",
  "adm.auto.trigHint.order.released": "When the order is released: together with the pick when the company reports in one step, else when someone releases it on the phone or under Utleverans.",
  "adm.auto.guardPh": "optional, e.g. short == false",
  "adm.auto.guardHint": "Optional condition in Trail's expression language over the moment's data: flow, reference, pallets, short, sscc, reused (the pallet existed already) …",
  "adm.auto.print": "Print",
  "adm.auto.on": "on",
  "adm.auto.role": "place {role}",
  "adm.auto.copies": "copies",
  "adm.auto.pdfLater": "The delivery note prints through the site agent once its printer is chosen. Until then the run shows as failed in the log.",
  "adm.auto.mailTo": "E-mail to",
  "adm.auto.subjectPh": "Subject, e.g. Order {reference} is picked",
  "adm.auto.bodyPh": "Text. {reference}, {pallets} and other fields of the moment are filled in.",
  "adm.auto.attachNote": "Attach the delivery note as PDF",
  "adm.auto.webhook": "Webhook",
  "adm.auto.secretPh": "signing secret",
  "adm.auto.webhookHint": "Only https to an outside address. With a secret the call is signed (x-trail-signature, HMAC-SHA256).",
  "adm.auto.removeAction": "Remove",
  "adm.auto.addAction": "+ action:",
  "adm.auto.email": "E-mail",
  "adm.auto.mailHidden": "E-mail shows once a mail service is set up and tested below.",
  "adm.auto.active": "On",
  "adm.auto.activeHint": "The automation runs",
  "adm.auto.save": "Save",
  "adm.auto.rehearse": "Rehearse on the last week",
  "adm.auto.rehearsal": "Rehearsal",
  "adm.auto.rehearsal.sub": "{fires} of {total} moments in the last week would have fired the rule · nothing was done",
  "adm.auto.rehearsal.when": "When",
  "adm.auto.rehearsal.what": "What",
  "adm.auto.rehearsal.fires": "Fires",
  "adm.auto.rehearsal.actions": "Would do",
  "adm.auto.rehearsal.none": "No moments of this kind in the last week.",
  "adm.auto.rehearsal.outOfScope": "outside Where",
  "adm.auto.rehearsal.guardNo": "If = no",
  "adm.auto.cancel": "Cancel",
  "adm.auto.col.name": "Automation",
  "adm.auto.col.last": "Last run",
  "adm.auto.col.at": "Time",
  "adm.auto.col.event": "Moment",
  "adm.auto.col.result": "Result",
  "adm.auto.none": "No automations yet.",
  "adm.auto.seeded": "from today's settings",
  "adm.auto.on.yes": "On",
  "adm.auto.on.no": "Off",
  "adm.auto.meta": "version {v} · changed by {by} {at}",
  "adm.auto.log": "Run log",
  "adm.auto.logSub": "each automation and moment, with what happened",
  "adm.auto.noRuns": "No runs yet.",
  "adm.auto.true": "true",
  "adm.auto.false": "false",
  "adm.auto.st.ok": "done",
  "adm.auto.st.failed": "failed",
  "adm.auto.st.skipped": "skipped",
  "adm.auto.order": "order {ref}",
  "adm.auto.do.print": "Print {doc} · {on} · {n} copies",
  "adm.auto.do.email": "E-mail to {to}",
  "adm.auto.do.webhook": "Webhook to {host}",
  "adm.auto.doc.sscc-label": "SSCC label",
  "adm.auto.doc.pallet-label": "Pallet label",
  "adm.auto.doc.piece-label": "Piece label",
  "adm.auto.doc.customer-label": "Customer label",
  "adm.auto.doc.delivery-note": "Delivery note",
  "adm.mail.title": "Mail service",
  "adm.mail.verified": "tested {at}",
  "adm.mail.notVerified": "not tested · e-mail cannot be chosen in automations",
  "adm.mail.kind": "Send through",
  "adm.mail.none": "None",
  "adm.mail.from": "Sender",
  "adm.mail.host": "SMTP server",
  "adm.mail.port": "Port",
  "adm.mail.user": "User",
  "adm.mail.password": "Password",
  "adm.mail.passwordSet": "saved · type a new one to change it",
  "adm.mail.passwordHint": "Stored encrypted on the server and never shown again. TLS is required.",
  "adm.mail.graphHint": "Sends as the sender through Trail's Entra app (Mail.Send). Limit the app to this mailbox in Exchange.",
  "adm.mail.graphMissing": "The server lacks the Entra app's details. Microsoft 365 cannot be used until they are in place.",
  "adm.mail.save": "Save",
  "adm.mail.saved": "Saved. Send a test message to be able to use e-mail.",
  "adm.mail.testTo": "test to address",
  "adm.mail.test": "Send test",
  "adm.mail.sent": "The test message went to {to}.",
  "adm.mail.changeHint": "If sender, server, port or user changes, a new test must pass before automations send again.",
  "adm.set.pickPalletLabel": "Outbound pallet label",
  "adm.set.labelsInAutomations": "Set under Automations →",
  "adm.col.time": "Time",
  "adm.prn.fetch": "Fetch from the LAN",
  "adm.prn.fetch.sub": "The agent fetches the address from its machine on your network and leaves the content here – for service descriptions only visible from inside, e.g. Visma Business Services (…?wsdl).",
  "adm.prn.fetch.url": "http://server:port/…",
  "adm.prn.fetch.go": "Fetch",
  "adm.prn.fetch.anyHost": "any agent",
  "adm.prn.fetch.waiting": "waiting for the agent",
  "adm.prn.fetch.failed": "failed",
  "adm.prn.fetch.show": "Show",
  "adm.prn.fetch.download": "Download",
  "pick.shortStep": "Shortages",
  "pick.shortTitle": "{n} lines are short",
  "pick.shortTitleOne": "1 line is short",
  "pick.shortSub": "Give a reason per line; the order is then reported picked with the shortages.",
  "pick.report": "Report",
  "pick.doneShort": "Order picked with shortages",
  "pick.doneShortMsg": "{n} lines short.",
  "pick.doneShortMsgOne": "1 line short.",
  "pick.noCarrier": "No carrier",
  "pick.pickupAt": "collected {time}",
  "adm.set.pickQueue": "Pick list",
  "adm.set.pickQueue.flat": "One list in pick order",
  "adm.set.pickQueue.carrier": "Grouped per carrier",
  "adm.set.carriers": "Carriers",
  "adm.set.carriers.name": "Name as on the order",
  "adm.set.carriers.add": "Add carrier",
  "adm.set.carriers.hint": "normal pickup time; the earliest collector is picked first. The name must be what the ERP puts on the order.",
  "common.remove": "Remove",
  "adm.set.splitIdentity": "A split carton is marked with",
  "adm.set.splitIdentity.lotSuffix": "Lot with a suffix (-1, -2 …)",
  "adm.set.splitIdentity.serial": "Serial number",
  "adm.set.combinedPallets": "Several orders on one outbound pallet",
  "adm.set.bottomFirst": "Picked first (bottom of the pallet)",
  "adm.set.bottomFirst.placeholder": "e.g. Spices, Netting",
  "adm.set.bottomFirst.hint": "categories, handling profiles or words in the product name, comma separated; order lines with such products come first",
  "common.yes": "Yes",
  "common.no": "No",
  "menu.receiving": "Receiving",
  "menu.pallet": "To pallet",
  "menu.pallet.desc": "Scan containers onto a pallet, against a purchase order",
  "menu.toBin": "Straight to a location",
  "menu.toBin.desc": "Scan containers, then the location they go to",
  "menu.supplierPallet": "Supplier pallet",
  "menu.supplierPallet.desc": "Accept the pallet on its own SSCC, contents from the advice",
  "menu.notEnabled": "not enabled",
  "menu.soon": "coming",
  "menu.stock": "Stock",
  "menu.count": "Count",
  "menu.count.desc": "count a location or a round",
  "count.step1": "Step 1 of 3",
  "count.step2": "Step 2 of 3",
  "count.step3": "Step 3 of 3",
  "count.pickRound": "Choose a round or a location",
  "count.pickLocation": "Choose a location",
  "count.sub1": "or scan the location in front of you",
  "count.sub1.roundOnly": "scan a location that is part of the round",
  "count.scanLocation": "Scan location…",
  "count.noRounds": "No round is running. Scan a location to count it.",
  "count.roundDesc": "{done} of {total} locations done · {counting} in progress",
  "count.roundAllCounted": "Every location in the round is counted.",
  "count.locBusy": "being counted by {who}",
  "count.locPending": "not counted",
  "count.allRounds": "All rounds",
  "count.locked": "The location is taken",
  "count.lockedBy": "{who} is counting it right now.",
  "count.notLocation": "{code} is not a location.",
  "count.noAdHoc": "Only locations in a round are counted here.",
  "count.scanAll": "Scan everything standing here",
  "count.scanContainer": "Scan container or pallet…",
  "count.expected": "{n} containers per Trail",
  "count.nothingExpected": "Trail has nothing here. If something stands here, scan it.",
  "count.progress": "{done} of {total} scanned",
  "count.notContainer": "That was neither a container nor a pallet.",
  "count.already": "Already scanned",
  "count.unknown": "Unknown container",
  "count.unknownMsg": "Not in stock: {key}.",
  "count.foundHere": "Found here",
  "count.foundHereMsg": "{what} is at {where} according to Trail. Move it here, or leave it where you found it?",
  "count.moveHere": "Move here",
  "count.leaveThere": "Stays there",
  "count.wrongItem": "Wrong item, set aside",
  "count.wrongItemMsg": "Noted. The container is not counted here.",
  "count.movedHere": "Moved here",
  "count.leftThere": "Left",
  "count.movedReason": "stock count",
  "count.qtyTitle": "How much is left?",
  "count.qtyNow": "Trail: {q}",
  "count.qtySkip": "Skip",
  "count.locationDone": "Location done",
  "count.missingOne": "One container is missing",
  "count.missingN": "{n} containers are missing",
  "count.missingSub": "Trail had them at {code}; they were not scanned.",
  "count.missingTag": "missing",
  "count.missingHint": "Missing containers go to review before stock changes.",
  "count.forgotScan": "Forgot to scan, back",
  "count.reportMissing": "Missing, report",
  "count.doneTitle": "Location counted",
  "count.doneMsg": "{present} confirmed, {found} moved here, {missing} missing.",
  "count.doneReview": "Missing containers go to review before stock changes.",
  "count.queued": "Saved on the device, sent when the network is back.",
  "count.nextLocation": "Next location",
  "count.destinationLocked": "{code} is being counted by {who}. Wait until the location is done.",
  "menu.putaway": "Put-away",
  "menu.returns": "Returns",
  "menu.returns.desc": "Customer returns against return orders in the ERP",
  "ret.title": "Choose return",
  "ret.sub": "Return orders from the ERP waiting for goods, or type the order number",
  "ret.warehouse": "warehouse {n}",
  "entry.warehouseTitle": "Which warehouse gets the line?",
  "entry.warehouseSub": "The article is not on the return order. The order proposes warehouse {wh}. Further cartons of the article follow.",
  "entry.warehouse": "Warehouse {n}",
  "entry.continue": "Continue",
  "msg.lineNeeded": "{what} is not on the return order. Choose a warehouse and Trail creates the line.",
  "msg.lineCreated": "Line created",
  "msg.lineCreatedMsg": "{what} got a line on the return order, warehouse {wh}.",
  "close.returnDiff": "return: the difference stays open in the ERP",
  "menu.move": "Move",
  "menu.move.desc": "Scan a pallet or container, then the new location",
  "move.title2": "Scan the new location",
  "move.newPlace": "new place",
  "move.printLabel": "Print label",
  "move.printCustomerLabel": "Print customer label",
  "move.printed": "Label sent",
  "move.printedMsg": "Printing on {printer}.",
  "move.noPrinter": "No active label printer with the Receiving role. Check under Printers.",
  "move.hint": "Scan what stands in the wrong place, or what should get a new one.",
  "move.onPallet": "The container is on pallet {sscc}",
  "move.onPallet.msg": "Moving only the container takes it off the pallet. Press Whole pallet to move everything.",
  "move.wholePallet": "Whole pallet",
  "move.oneOf": "container · 1 of {n} on the pallet",
  "move.samePlace": "Already at {code}.",
  "move.notAllowed": "{code} is not a storage location, staging area or receiving area.",
  "move.whatMoves": "What moves?",
  "move.hereSub": "{code} · {cartons} containers, {loose} loose. Scan the container, or pick loose stock in the list.",
  "move.hereEmpty": "{code} · nothing stands here according to Trail.",
  "move.qty": "Quantity to move",
  "move.qtyHint": "Everything on the location is preselected. Less leaves the rest.",
  "move.toPlace": "To a place",
  "move.qtyBad": "Enter a quantity between 0 and {have}.",
  "move.looseOf": "loose · {qty} of {have} {uom}",
  "move.looseAll": "loose · the whole quantity",
  "move.done": "Moved",
  "move.merged": "Joined the {q} already standing at {code}.",
  "move.doneQueued": "Move saved on the device",
  "move.detached": "Taken off pallet {sscc} ({n} left).",
  "move.onto.title": "Where on {code}?",
  "move.onto.palletsOnly": "{code} takes pallets only. The container must go onto a pallet.",
  "move.onto.hasPallets": "{n} pallet(s) already stand here. Put the container on one of them, build a new pallet, or set it down loose.",
  "move.onto.current": "the container's own pallet",
  "move.onto.samePallet": "Already on pallet {sscc}.",
  "move.onto.loose": "Loose on the place",
  "move.newPallet": "New pallet",
  "move.newPalletHere": "New pallet here",
  "move.onto": "pallet {sscc} at {code}",
  "move.ontoNew": "new pallet {sscc} at {code}",
  "move.noPalletsHere": "{code} takes no pallets, only loose goods and containers.",
  "move.issueFailed": "Could not create the pallet: {err}",
  "move.palletRetired": "Pallet {sscc} is empty and retired in Trail. Issue a new pallet (new label) to use it again.",
  "move.retireEmpty": "Retire empty pallet",
  "move.retired": "Pallet retired",
  "putaway.ontoPallet": "Put on pallet {sscc} · {code}",
  "move.full": "{code} is full: {n} pallet(s) stand there and the place takes {cap}.",
  "move.onto.room": "Room for {cap} pallet(s), {n} stand there.",
  "putaway.needsPallet": "{code} takes pallets only. Put the container on a pallet first, via Move → New pallet.",
  "move.palletOnPallet": "A pallet cannot go onto a pallet. Scan a location.",
  "move.palletUnknown": "Pallet {sscc} is not in Trail. Scan a location, or a pallet that exists.",
  "move.destUnknown": "The code {raw} is neither a location nor a pallet Trail knows.",
  "adm.set.directToStorage": "Put away straight at receiving",
  "adm.set.directToStorage.hint": "The pallet's last scan may be a storage location instead of the receiving area: received and put away in one go. The rules for what the place takes, pallet capacity and storage class apply.",
  "adm.set.directToStorage.on": "Allowed",
  "adm.set.directToStorage.off": "Receiving area only",
  "adm.set.erpReport.shipOnRealised": "Invoiced = shipped",
  "adm.set.erpReport.shipOnRealised.hint": "When the ERP realises (invoices) an order the goods count as gone: the order's picked cartons and pallets leave stock without being scanned out. Off: the goods stay until a ship step says otherwise.",
  "adm.set.erpReport.shipOnRealised.on": "On",
  "adm.set.erpReport.shipOnRealised.off": "Off",
  "adm.set.retireWhenEmpty": "Empty pallet",
  "adm.set.retireWhenEmpty.hint": "When the last container leaves a pallet it is retired in Trail: gone from stock and its place, and whoever tries to put something on it is told so. Off: the pallet stays until someone retires it.",
  "adm.set.retireWhenEmpty.on": "Retired automatically",
  "adm.set.retireWhenEmpty.off": "Stays",
  "adm.set.erpReport.maxPerRun": "Write guard · max pending reports",
  "adm.set.erpReport.maxPerRun.hint": "More pending reports than this and nothing is sent to the ERP until someone releases them under Operations → ERP. The protection against Trail suddenly writing a lot after a fault.",
  "adm.erpReports.held": "{n} reports are waiting, more than the guard ({max}) allows.",
  "adm.erpReports.held.msg": "Nothing is sent to the ERP until you release them. Check first that everything should go.",
  "adm.erpReports.release": "Release all for 15 minutes",
  "adm.erpReports.released": "Released until {until}; the agent takes them in turn.",
  "adm.erpReports.releasedUntil": "The guard is open until {until}.",
  "adm.set.outboundLocation": "Outbound area",
  "adm.set.outboundLocation.hint": "Where the order pallet goes with its contents at Pallet done, so the storage place is free at once. A location with the ship or pack role, or a staging area. Blank = the pallet stays where it was picked.",
  "adm.set.outboundLocation.none": "None · the pallet stays",
  "pick.palletWhole": "Whole pallet {sscc}: {n} containers picked for the order. Add more containers or press Pallet done.",
  "pick.palletForeign": "Pallet {sscc} carries {n} container(s) not on the order ({what}). Pick containers off it instead, or issue a new pallet.",
  "pick.isOrderPallet": "That is the order's pallet",
  "pick.isOrderPallet.msg": "Scan the containers that go on it, or press Pallet done.",
  "pick.palletOver": "Pallet {sscc} carries more than the order needs: {n} container(s) of {what} at {have} against {need} left on the line. Pick containers off it instead; the last one is split.",
  "adm.loc.rack": "The whole rack from the aisle",
  "adm.loc.rack.sub": "bays from the left, levels from the top · click a bin to see what stands there",
  "adm.set.outsideOrder": "Article not on the purchase order",
  "adm.set.outsideOrder.hint": "A container of an article the order has no line for is scanned.",
  "adm.set.outsideOrder.refuse": "Refused",
  "adm.set.outsideOrder.warn": "Received with a deviation",
  "adm.set.outsideOrder.allow": "Received",
  "msg.notOnOrder": "{what} is not on purchase order {ref}. The container is not received.",
  "adm.set.moveRoles": "Move is shown to",
  "adm.set.printPlaces": "Print places",
  "adm.set.printPlaces.hint": "Where printers stand. A printer has one or more places; automations and buttons choose a printer by place. The three built-in ones can be renamed but not removed, since the flows point at them.",
  "adm.set.printPlaces.add": "New place…",
  "adm.set.printPlaces.builtin": "built in",
  "adm.set.manualRoles": "Registering without a scan is shown to",
  "adm.set.manualRoles.hint": "Applies to the With comment mode. Leads only applies regardless of the list.",
  "adm.set.manual.receive": "Receiving without a scan",
  "adm.set.manual.pick": "Picking without a scan",
  "adm.set.manual.hint": "Barcodes are always the normal way. Without a scan always needs a comment, and every such registration is a deviation for the lead with the comment beside the event.",
  "adm.set.manual.off": "Off",
  "adm.set.manual.comment": "With comment",
  "adm.set.manual.lead": "Leads only",
  "dev.manualEntry": "Registered without a scan: {what}",
  "menu.putaway.desc": "Scan the pallet, walk to the proposed place, scan it",
  "menu.settings": "Settings",
  "menu.settings.desc": "Device, theme, language, scan test",
  "menu.needSettings": "Enter the API token, tenant and your name under Settings first.",
  "strip.online": "Online",
  "strip.offline": "Offline",
  "strip.queue": "{n} queued",
  "strip.queueStuck": "{n} rejected by server",
  "common.back": "Back",
  "common.menu": "Menu",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.loading": "Loading…",
  "common.more": "More…",
  "pick.step": "Step 1 of 3",
  "pick.title": "Choose purchase order",
  "pick.sub": "or scan the order number on the delivery note",
  "pick.scan": "Scan order number…",
  "pick.lines": "{n} lines",
  "pick.line": "1 line",
  "pick.expected": "expected {date}",
  "pick.unmapped": "{n} unmapped",
  "pick.proposed": "proposed",
  "pick.none": "No open purchase orders. Import one first.",
  "pick.noMatch": "No open purchase order with number {ref}. Pick the order in the list or scan the order number on the delivery note.",
  "pick.notOrder.item": "This is a product label ({what}). Pick the purchase order in the list first, then the pallet, and scan the containers in step 3.",
  "pick.notOrder.pallet": "This is a pallet. Pick the purchase order in the list first.",
  "pick.notOrder.location": "This is the location {code}. Pick the purchase order in the list first.",
  "pick.location": "Receiving at",
  "pick.chooseLocation": "Choose receiving location",
  "pick.noLocation": "No location has the receiving role. Import one before receiving.",
  "pick.registryOld": "Using the registry copy from {date} (refresh failed: {err})",
  "pick.registryMissing": "Could not load the registry: {err}",
  "pallet.step": "Step 2 of 3 · Pallet",
  "pallet.title": "Scan the pallet's SSCC",
  "pallet.sub": "No label on the pallet? Create a new one.",
  "pallet.none": "No pallet started.",
  "pallet.new": "New pallet",
  "pallet.issuing": "Creating…",
  "pallet.issued": "New pallet {sscc}",
  "many.step": "Step 3 of 3 · Containers",
  "many.title": "Scan the next container",
  "many.onPallet": "containers on the pallet",
  "many.onPalletOne": "container on the pallet",
  "many.end": "End pallet",
  "many.saving": "Saving pallet…",
  "scan.ready": "Ready to scan",
  "scan.type": "Scan or type…",
  "banner.accepted": "Received",
  "banner.acceptedDeviation": "Received with deviation",
  "banner.rejected": "Rejected",
  "banner.rejectedDuplicate": "Rejected · already scanned",
  "banner.collision": "Rejected · already in stock",
  "banner.collisionHold": "Already in stock",
  "msg.collisionHold": "{what} is already in stock{at}.",
  "msg.collisionOtherDay": "{what} was received {date}{at}. The same identity may only be received again the same day.",
  "msg.serialTaken": "Serial {serial} is already in stock.",
  "banner.bestBeforeMissing": "Best-before missing on the label",
  "banner.quantityMissing": "No quantity in the barcode",
  "banner.bulkQty": "Enter the quantity",
  "msg.bulkQty": "{what} is handled as a quantity without carton numbers. Type how much is received.",
  "msg.quantityMissingStd": "The product register proposes {q} {uom}. Confirm it, or type another.",
  "msg.quantityMissing": "Type the quantity. Nothing is received until you confirm.",
  "banner.quantityConfirmed": "Received · quantity confirmed",
  "msg.quantityStd": "{q} {uom} from the product register, confirmed.",
  "msg.quantityEntered": "{q} {uom} entered by hand (standard {std}). Noted on the event.",
  "entry.qtyTitle": "How much is it?",
  "entry.qtySub": "The barcode says no quantity. Type it.",
  "entry.qtySubStd": "The barcode says no quantity. The proposal comes from the product register.",
  "entry.qtySubBulk": "The article is handled as a quantity without carton numbers. Type how much it is.",
  "entry.receiveQty": "Receive {q} {uom}",
  "msg.bestBeforeMissing": "Profile {profile} requires a best-before. Read the date off the package or the delivery note.",
  "banner.enteredDate": "Received · date entered by hand",
  "msg.enteredDate": "Best before {date} from {source}. Noted for the office.",
  "banner.enteredSerial": "Received · serial entered",
  "msg.enteredSerial": "{what} · serial {serial}. Noted for the office.",
  "entry.serialTitle": "Enter serial",
  "entry.serialSub": "Scan or type the number that tells this container from the one already in stock.",
  "entry.serialPlaceholder": "Serial",
  "entry.dateTitle": "Enter best-before",
  "entry.dateSub": "YYYY-MM-DD",
  "entry.dateFrom": "Date read from",
  "entry.rejectItem": "Reject container",
  "entry.cancel": "Cancel",
  "entry.cancelled": "Not received",
  "entry.cancelledMsg": "{what} was not added. Scan it again when you want to receive it.",
  "entry.withoutDate": "Receive without date",
  "entry.receive": "Receive",
  "label.manual": "manual",
  "label.this": "this container",
  "msg.collision": "{what} is already in stock{at}. Probable duplicate receipt – call the supervisor.",
  "msg.collisionAt": " ({code})",
  "banner.waitingLot": "Waiting for lot",
  "banner.saved": "Pallet saved",
  "banner.savedQueued": "Pallet saved on this device",
  "banner.tally": "Count differs",
  "banner.newPallet": "New pallet",
  "msg.saved": "{n} containers on pallet {sscc}",
  "msg.directStored": "put straight on {code}",
  "recv.notDock": "End the pallet with the receiving area, or a storage location when the site allows direct put-away. {code} is not possible.",
  "msg.savedQueued": "{n} containers · uploads when the server is reachable",
  "msg.duplicate": "{what} is already on the pallet. Scan the next container.",
  "msg.wrongKind.location": "This is a location ({code}), not a container.",
  "msg.wrongKind.pallet": "This is a pallet, not a container.",
  "msg.wrongKind.item": "This is a container ({what}). Scan the pallet's SSCC label first, or press Ny pall to print one.",
  "msg.unknownCode": "The code {raw} is neither a location, a pallet nor a product label Trail knows.",
  "msg.parseError": "Could not read the code: {err}",
  "msg.emptyPallet": "Nothing scanned on this pallet yet.",
  "msg.notRunning": "The flow is not running.",
  "msg.waitingLot": "GTIN {gtin} read without a lot. Scan the label's other code – or receive without lot.",
  "msg.tally": "{scanned} of {expected} scanned. Scan the missing ones, or confirm the difference with a reason.",
  "dev.unknownProduct": "unknown product – GTIN not in the registry",
  "dev.missingLot": "no lot number",
  "dev.missingBestBefore": "best-before missing",
  "msg.partialRejected": "The code lacks a lot number and the profile does not allow receiving without one.",
  "dev.quantityUnknown": "content not on the label",
  "dev.counted": "Counted; the deviation goes to the office.",
  "label.last": "last container",
  "label.pallet": "pallet",
  "label.unknownProduct": "Unknown product",
  "label.held": "The code is held a few seconds waiting for the rest of the label.",
  "label.missing": "missing",
  "unit.kolli": "Container",
  "unit.case": "Case",
  "unit.inner": "Inner pack",
  "unit.each": "Each",
  "unit.pallet": "Pallet",
  "rows.ordered": "ordered",
  "rows.received": "received so far",
  "rows.left": "{q} left",
  "rows.lineDone": "done",
  "rows.notOnOrder": "not on the order",
  "rows.more": "… {n} more",
  "rows.kolli": "{n} containers",
  "side.onPallet": "On the pallet",
  "side.order": "Purchase order {ref}",
  "side.lastPallets": "Last pallets",
  "more.title": "More",
  "more.camera": "Camera",
  "more.acceptWithoutLot": "Receive without lot",
  "more.orderStatus": "Order status",
  "more.closeDelivery": "Close delivery",
  "more.abandon": "Abandon pallet",
  "more.abandonConfirm": "The pallet's {n} scans will not be saved. Abandon?",
  "more.abandonYes": "Yes, abandon the pallet",
  "many.back": "Back to the pallet step",
  "many.backConfirm": "The pallet's {n} scans are not saved. Back to the pallet step?",
  "many.backYes": "Yes, go back",
  "tally.keep": "Keep scanning",
  "tally.confirm": "Confirm with reason",
  "close.title": "{n} differences need a reason",
  "close.titleOne": "1 difference needs a reason",
  "close.sub": "Delivery close · {pallets} pallets · {containers} containers",
  "close.none": "Everything ordered was received, nothing extra.",
  "close.ordered": "ordered {q}",
  "close.received": "received {q}",
  "close.notOnOrder": "{q} received, not on the order",
  "close.note": "Note (optional)",
  "close.notePlaceholder": "Delivery note number, carrier, remarks",
  "close.submit": "Close delivery",
  "close.closing": "Closing…",
  "close.waitingUpload": "Waiting for {n} pallets to upload before the delivery can close.",
  "close.closed": "Delivery closed",
  "close.alreadyClosed": "Delivery was already closed",
  "close.progressFailed": "Order status unavailable: {err}",
  "close.other": "Other…",
  "close.otherPlaceholder": "Reason",
  "reason.backorder": "Back-ordered",
  "reason.shortNoted": "Short per delivery note",
  "reason.damaged": "Damaged – refused",
  "reason.wrongItem": "Wrong item",
  "reason.substitute": "Substitute",
  "reason.over": "Over-delivery",
  "done.next": "Next pallet",
  "done.closeDelivery": "Close delivery",
  "done.receipts": "Purchase orders",
  "done.pallets": "{n} pallets",
  "done.containers": "{n} containers",
  "settings.title": "Settings",
  "settings.token": "API token",
  "settings.tenant": "Tenant id",
  "settings.actor": "Your name or badge",
  "settings.device": "Device {id}",
  "settings.layout": "Screen {layout}",
  "settings.sound": "Scan sound",
  "settings.sound.hint": "accepted, rejected and attention sound different; the iPhone's silent switch mutes this too",
  "settings.sound.off": "Off",
  "settings.sound.normal": "Normal",
  "settings.sound.loud": "Loud",
  "camera.done": "Done",
  "camera.accepted": "{n} accepted",
  "camera.zoom2": "Zoom 2×",
  "camera.zoom1": "Zoom 1×",
  "camera.torchOn": "Torch on",
  "camera.torchOff": "Torch off",
  "settings.theme": "Theme",
  "settings.theme.dark": "Dark",
  "settings.theme.light": "Light",
  "settings.theme.auto": "Follow device",
  "settings.theme.device": "As the device",
  "msg.labelQueued": "label printing",
  "msg.labelNotPrinted": "no label (no printer)",
  "settings.mine": "My settings",
  "settings.onAccount": "saved on your account",
  "settings.mounted": "Mounted device (larger text and buttons)",
  "settings.keyboard": "Open the keyboard in the scan field automatically (otherwise via the button)",
  "scan.keyboard": "Keyboard",
  "settings.gsSubs": "Scanner's substitute for the GS character",
  "settings.gsSubs.hint": "the characters the scanner sends instead of GS (ASCII 29); usually ~ or |",
  "scanner.waiting": "Scanner: waiting for the shell",
  "scanner.noKey": "Scanner link has no key – the shell was built without a Socket Mobile key",
  "scanner.error": "Scanner error: {e}",
  "scanner.none": "No scanner connected",
  "scanner.connected": "{name} connected",
  "scanner.connectedBattery": "{name} connected · battery {battery} %",
  "settings.autoNext": "Go straight to the next pallet when one is ended",
  "settings.lang": "Language",
  "settings.diag": "Diagnostics key (field phase)",
  "settings.scantest": "Scan test",
  "settings.save": "Save",
  "putaway.step1": "Step 1 of 2",
  "putaway.title1": "Scan pallet or container",
  "putaway.waiting": "Waiting at receiving: {n}",
  "putaway.contents": "On the pallet · {n} containers",
  "putaway.waitingNone": "Nothing waiting at receiving.",
  "putaway.step2": "Step 2 of 2",
  "putaway.title2": "Scan the location",
  "putaway.proposed": "Proposed location",
  "goto.replay": "Play again",
  "putaway.reason.nearest": "nearest empty storage bin",
  "putaway.reason.class": "nearest empty bin in the right storage class",
  "putaway.noProposal": "No empty storage bin found – choose one.",
  "putaway.notFound": "No pallet or container with that identity is in stock.",
  "putaway.several": "Several containers share that identity ({n}). Scan the pallet instead.",
  "putaway.notStorage": "{code} is not a storage location.",
  "putaway.overrideAsk": "Other place: {code}",
  "putaway.overrideWhy": "The proposal was {proposed}. Why another?",
  "putaway.overrideConfirm": "Move here",
  "putaway.moved": "Moved to {code}",
  "putaway.movedQueued": "Move saved on this device · {code}",
  "putaway.override": "Not the proposed place ({proposed}) – recorded.",
  "putaway.lookupFailed": "Could not look up the container: {err}",
  "putaway.other": "Other location",
  "menu.putaway.waiting": "{n} waiting at receiving",
  "login.title": "Sign in",
  "login.email": "E-mail",
  "login.continue": "Continue",
  "login.password": "Password",
  "login.code": "One-time code",
  "login.codeHint": "The code from your authenticator app",
  "login.microsoft": "Sign in with Microsoft",
  "login.withPassword": "Sign in with a password instead",
  "login.or": "or",
  "login.footDesk": "The administrator sets the method per user: Microsoft Entra ID or a Trail password. On an enrolled handheld you sign in with a code or a badge.",
  "login.passwordOnly": "Your account signs in with a password. Ask the administrator to switch it to Microsoft.",
  "login.unknown": "No user with that e-mail.",
  "unit.loose": "Loose",
  "adm.agents": "Site agents",
  "adm.sites": "Sites",
  "adm.sites.sub": "The selected site drives the site settings and what the phones get by default.",
  "adm.sites.new": "New site",
  "adm.sites.col.site": "Site",
  "adm.sites.col.gln": "GLN",
  "adm.sites.col.locations": "Locations",
  "adm.sites.col.printers": "Printers · agents",
  "adm.sites.col.people": "Works here",
  "adm.sites.own": "own warehouse",
  "adm.sites.external": "external",
  "adm.sites.selected": "selected",
  "adm.sites.select": "Select",
  "adm.sites.showInactive": "Show deactivated",
  "adm.sites.inactive": "deactivated",
  "adm.sites.name": "Name",
  "adm.sites.kind": "Kind",
  "adm.sites.kind.own": "Own warehouse",
  "adm.sites.kind.external": "External",
  "adm.sites.street": "Street",
  "adm.sites.postcode": "Postcode",
  "adm.sites.city": "City",
  "adm.sites.country": "Country",
  "adm.sites.status": "Status",
  "adm.sites.status.active": "Active",
  "adm.sites.status.inactive": "Deactivated",
  "adm.sites.hint": "An own warehouse gets its locations from the location list or the layout; an external site holds stock without locations until someone draws it. A site is deactivated, never deleted.",
  "adm.sites.lastActive": "The last active site cannot be deactivated.",
  "adm.sites.toSettings": "Settings for the site →",
  "adm.sites.devices": "devices",
  "adm.du.homeSite": "Home site",
  "adm.du.queues": "Work queues",
  "adm.du.queuesHint": "None selected = sees every order.",
  "adm.set.queues": "Work queues",
  "adm.set.queues.lead": "Who picks what at the site: one rule per queue over the order's fields, first match wins, the default queue takes the rest. Users and devices subscribe under Devices & users.",
  "adm.set.queues.name": "Queue",
  "adm.set.queues.rule": "Rule",
  "adm.set.queues.default": "Default",
  "adm.set.queues.add": "New queue",
  "adm.set.queues.fields": "Fields: source, reference, carrier, deliveryDate, customer.key, customer.name, lineCount, lines.sku, external.<source>.<field> — Visma: external.visma.transGroup2 (transaction group 2), transGroup1/3/4, orderType, warehouseNo. E.g. external.visma.transGroup2 == 5 or source == \"webshop\".",
  "adm.set.queues.requeued": "Rules re-run: {n} orders changed queue.",
  "adm.out.queue": "Queue",
  "adm.out.noQueue": "no queue",
  "adm.out.byUser": "set by hand",
  "pick.allQueues": "All queues",
  "pick.myQueues": "My queues",
  "adm.du.noHomeSite": "None",
  "adm.nav.site": "Site",
  "adm.agents.sub": "the site's arm into the LAN: printers, fetches, the ERP",
  "adm.agents.noneLive": "no agent reporting right now",
  "adm.du.keys": "Integration keys",
  "adm.du.keys.sub": "one key per integration or script, with roles · shown once",
  "adm.du.keys.none": "No keys. The adapter and scripts should have keys of their own instead of the server's integrator token.",
  "adm.du.key.new": "New key",
  "adm.du.key.namePlaceholder": "Name, e.g. visma-adapter",
  "adm.du.key.create": "Create",
  "adm.du.device.noSite": "No site – choose",
  "adm.du.key.validDays": "Valid for days",
  "adm.du.key.expires": "expires {at}",
  "adm.du.key.expired": "expired {at}",
  "adm.du.key.noExpiry": "never expires",
  "adm.me.logoutAll": "Sign out everywhere",
  "adm.me.logoutAllConfirm": "Sign out of every computer and phone where you are signed in, this one too?",
  "adm.set.security.idle": "Lock after inactivity",
  "adm.set.security.idle.hint": "Minutes without a key press or click before the administration signs out. 0 = never. Shift sessions on the phones last 10 hours regardless.",
  "adm.du.key.issued": "Key {name} created. Copy it now, it is not shown again:",
  "adm.du.key.lastUsed": "Last used",
  "adm.du.key.created": "created by {by} · {at}",
  "adm.du.key.active": "Active",
  "adm.du.key.revoked": "Revoked",
  "adm.du.key.revoke": "Revoke",
  "adm.du.key.revokeConfirm": "Revoke key {name}? Whatever uses it stops working at once.",
  "adm.prn.agent.enrol": "Enrol agent",
  "adm.prn.agent.newCode": "New code",
  "adm.prn.agent.hostPlaceholder": "The machine's name, e.g. WSW10-PL",
  "adm.prn.agent.makeCode": "Make code",
  "adm.prn.agent.code": "Code for {host} in company {tenant}, valid until {until}. Run on the machine:",
  "adm.prn.agent.codeReenrol": "New code for {host} in company {tenant}, valid until {until}; the old credential for this company stops working. Run on the machine:",
  "adm.prn.col.login": "Login",
  "adm.prn.login.own": "Own, for this company",
  "adm.prn.login.serverKey": "The server's key",
  "adm.pr.articleProfile": "Profile on the article",
  "adm.pr.articleProfile.none": "None of its own · follows the levels above",
  "adm.pr.articleProfile.hint": "Applies when the levels above allow a difference.",
  "adm.pr.profileSaved": "Saved.",
  "adm.pr.profileFrom.company": "company default",
  "adm.pr.profileFrom.dimension": "via the division",
  "adm.pr.lockedBy.company": "locked by the company",
  "adm.pr.lockedBy.site": "locked by the site",
  "adm.pr.lockedBy.dimension": "locked by the division",
  "adm.set.scope.company": "Company",
  "adm.set.scope.site": "Site",
  "adm.set.companyScope": "applies to every site in the company",
  "adm.set.search": "Search setting …",
  "adm.set.sec.general": "General",
  "adm.set.sec.identity": "Identity and lots",
  "adm.set.sec.receiving": "Receiving",
  "adm.set.sec.putaway": "Put-away and moves",
  "adm.set.sec.picking": "Picking and dispatch",
  "adm.layout": "Layout",
  "adm.loc.map.layout": "from published layout version {v} · the tint is how full · click a row",
  "adm.lay.sub": "{file} · version {v} ({status}) · published version {pub} drives the maps",
  "adm.lay.sub.none": "no layout yet — load the plan",
  "adm.lay.draft": "draft",
  "adm.lay.publishedWord": "published",
  "adm.lay.tool.select": "Select",
  "adm.lay.tool.rack": "Rack",
  "adm.lay.tool.area": "Area",
  "adm.lay.tool.gate": "Gate",
  "adm.lay.load": "Load plan (SVG)",
  "adm.lay.save": "Save draft",
  "adm.lay.preview": "Preview publish",
  "adm.lay.publish": "Publish",
  "adm.lay.badSvg": "The file is not an SVG.",
  "adm.lay.loaded": "{name} loaded: {w} × {h} m, {n} dashed rectangles found → {racks} racks (double rows split in two).",
  "adm.lay.importOffer": "The plan has {n} dashed rectangles. Take them in as rack components?",
  "adm.lay.importYes": "Take in as racks",
  "adm.lay.importNo": "No, I will draw",
  "adm.lay.saved": "Draft version {v} saved.",
  "adm.lay.publishConfirm": "Publish the layout and create {created} new bins in the tree?",
  "adm.lay.published": "Published. {created} bins created.",
  "adm.lay.report.title": "Preview:",
  "adm.lay.report": "{racks} racks ({unbound} unbound) · {created} new bins · {existing} exist",
  "adm.lay.report.missing": "Aisles missing in the tree: {codes}",
  "adm.out.deliveryNote": "Delivery note (PDF)",
  "adm.out.sharedWith": "combined with {refs}",
  "adm.out.docDeliveryNote": "Delivery note",
  "adm.out.docPickList": "Pick list",
  "adm.out.viewPdf": "View copy (PDF)",
  "adm.out.print": "Print",
  "pick.combineTitle": "Pick together?",
  "pick.combineSub": "More orders for {customer} go with {carrier}. Pick them together onto the same pallets?",
  "pick.combineOnly": "Only {ref}",
  "pick.combinePick": "Pick {n} orders",
  "pick.combineSummary": "Together: {lines} lines",
  "pick.combineOtherDate": "other delivery date",
  "pick.sameCustomer": "+{n} for the same customer",
  "pick.doneOrders": "{refs} reported.",
  "pick.orderTag": "order {ref}",
  "adm.out.printDeliveryNote": "Print delivery note",
  "adm.out.printPickList": "Print pick list",
  "adm.ev.printContent": "Print pallet contents",
  "adm.ev.printCustomerLabel": "Print customer label",
  "adm.ev.printSscc": "Print SSCC label",
  "adm.cnt.printSheet": "Print count sheet",
  "adm.print.viaAgent": "Printed through the site agent on the printer with the role",
  "adm.print.queued": "Sent to {printer}: {title}.",
  "adm.print.noDocPrinter": "No active document printer. Add one under Printers with the kind Document printer (PDF).",
  "adm.print.noLabelPrinter": "No active label printer with that role. Check under Printers.",
  "adm.out.deliveryNoteDraft": "Preview",
  "adm.out.notPickedYet": "The note is printed once the order is picked",
  "adm.set.company": "Company details",
  "adm.set.company.sub": "as they appear on delivery notes and other documents",
  "adm.set.company.name": "Company name",
  "adm.set.company.street": "Street",
  "adm.set.company.city": "Postcode and city",
  "adm.set.company.orgNo": "Company reg. no",
  "adm.set.company.phone": "Phone",
  "adm.set.company.email": "E-mail",
  "adm.set.company.seat": "Registered office",
  "adm.set.company.fTax": "Approved for F-tax",
  "adm.set.company.logo": "Logo",
  "adm.set.company.logo.hint": "PNG or JPEG, at most 280 kB; printed top left.",
  "adm.set.company.logo.choose": "Choose image",
  "adm.set.company.logo.big": "The image is too large (at most 280 kB).",
  "adm.set.dn.number": "Delivery note number",
  "adm.set.dn.number.hint": "Prefix and next number. Trail continues from the higher of this and the last one used; set it after the old system's last number.",
  "adm.set.dn.prefix": "prefix",
  "adm.pr.storage": "Storage requirement",
  "adm.pr.storage.none": "No requirement",
  "adm.pr.storage.hint": "The location's storage class is compared with this at put-away and move. A value set here is not overwritten by the import.",
  "adm.pr.storageSaved": "Storage requirement saved.",
  "adm.pr.stock": "Stock",
  "adm.pr.stock.sub": "{units} containers · {places} places",
  "adm.pr.stock.none": "Nothing in stock.",
  "adm.pr.stock.picked": "picked",
  "adm.pr.stock.unplaced": "not put away",
  "adm.pr.stock.loose": "loose",
  "storage.wrong": "Wrong temperature",
  "storage.wrongMsg": "The product needs {need}, {code} is {has}.",
  "adm.loc.ed.title": "Edit",
  "adm.loc.ed.open": "Change settings",
  "adm.loc.ed.sub": "changes apply at once; imports do not overwrite a location changed here",
  "adm.loc.ed.code": "Code",
  "adm.loc.ed.role.storage": "Storage",
  "adm.loc.ed.role.receiving": "Receiving",
  "adm.loc.ed.role.pick_face": "Pick face",
  "adm.loc.ed.role.pack": "Pack",
  "adm.loc.ed.role.ship": "Shipping",
  "adm.loc.ed.inherit": "Inherited",
  "adm.loc.ed.inheritsFrom": "Inherits {cls}. Choose a class to set it here and for everything below.",
  "adm.loc.ed.classHint": "Applies to this location and everything below, unless something below sets its own.",
  "adm.loc.ed.seq": "Walking order",
  "adm.loc.ed.seqHint": "Lower first in picking and put-away.",
  "adm.loc.ed.parent": "Under",
  "adm.loc.ed.parentHint": "Everything below moves along.",
  "adm.loc.ed.noParent": "Top level",
  "adm.loc.ed.save": "Save",
  "adm.loc.ed.saved": "Saved.",
  "adm.loc.ed.savedMoved": "Saved. {n} locations below moved along.",
  "adm.loc.ed.deactivate": "Deactivate",
  "adm.loc.ed.deactivateConfirm": "Deactivate {code}? It leaves the tree and takes nothing, but its history stays and it can be activated again.",
  "adm.loc.ed.addUnder": "Add under {code}",
  "adm.loc.ed.add": "Add",
  "adm.loc.ed.added": "{code} added.",
  "adm.loc.holds": "Takes",
  "adm.loc.erpWarehouse": "ERP warehouse",
  "adm.loc.erpWarehouse.none": "none",
  "adm.loc.ed.erpWarehouseHint": "Which ERP warehouse the goods in this zone belong to. Everything below inherits. Only warehouses some zone points at are mirrored and picked in Trail.",
  "adm.set.erpWarehouses": "ERP warehouses",
  "adm.set.erpWarehouses.sub": "filled by the adapter every run · zones are bound under Locations",
  "adm.set.erpWarehouses.no": "No",
  "adm.set.erpWarehouses.name": "Name",
  "adm.set.erpWarehouses.zones": "Zones in Trail",
  "adm.set.erpWarehouses.handled": "handled in Trail",
  "adm.set.erpWarehouses.unbound": "no zone · not mirrored",
  "adm.set.erpWarehouses.none": "No warehouses read yet. They arrive with the mirror's next run.",
  "adm.set.erpWarehouses.hint": "An ERP warehouse is a balance bucket, a Trail site a place. Several warehouses may belong to one site: point a zone at the warehouse under Locations and mirroring, picking and receiving follow. Warehouses without a zone, such as your goods held at suppliers, are left alone. Until the first zone is bound nothing is filtered.",
  "adm.loc.holds.any": "Pallets and loose goods",
  "adm.loc.holds.pallets": "Pallets only",
  "adm.loc.holds.loose": "Loose goods and containers only",
  "adm.loc.ed.holdsHint": "Pallet racking has beams only: a container there must sit on a pallet. Applies to this place and everything below it.",
  "adm.loc.ed.holdsInherits": "Inherits: {what}. Choose to set it here and for everything below.",
  "adm.loc.palletCapacity": "Max pallets",
  "adm.loc.palletCapacity.none": "no limit",
  "adm.loc.ed.capHint": "0 = no limit. Applies to this place and everything below it.",
  "adm.loc.ed.capInherits": "Inherits: {what}. Enter a number to set it here and for everything below.",
  "adm.loc.ed.top": "New zone or area",
  "adm.loc.ed.top.sub": "at the top level; under an existing location, add from that location",
  "adm.loc.ed.inactive": "Deactivated ({n})",
  "adm.loc.ed.activate": "Activate",
  "adm.set.loc.classes": "Storage classes",
  "adm.set.loc.classes.hint": "A location's temperature. Set on a zone, aisle or bin under Lagerplatser and inherited downwards; the product's requirement is compared with it.",
  "adm.set.loc.classes.name": "Name",
  "adm.set.loc.classes.key": "Key",
  "adm.set.loc.classes.min": "Min",
  "adm.set.loc.classes.max": "Max",
  "adm.set.loc.classes.add": "New class",
  "adm.set.loc.classes.new": "New class",
  "adm.set.loc.check": "Wrong storage class at put-away",
  "adm.set.loc.check.hint": "When a product goes onto a location of another class than it requires. Applies to put-away and move on the phone; put-away proposals prefer the right class.",
  "adm.set.loc.check.off": "Allow",
  "adm.set.loc.check.warn": "Warn",
  "adm.set.loc.check.refuse": "Refuse",
  "adm.lay.report.newAisles": "New aisles are created in the tree: {codes}",
  "adm.lay.report.extra": "{aisle}: {n} bins in the tree the component does not describe (left): {codes}",
  "adm.lay.empty": "Load the plan as SVG, or pick a tool and draw.",
  "adm.lay.canvasHint": "Select: click an element. Rack/Area/Gate: drag a rectangle. The background is the plan in millimetres.",
  "adm.lay.pick": "Click an element on the map to edit it.",
  "adm.lay.counts": "{racks} racks, {bound} bound · {areas} areas",
  "adm.lay.rack": "Rack",
  "adm.lay.unbound": "unbound",
  "adm.lay.aisle": "Aisle/row in the tree",
  "adm.lay.binsWord": "bins",
  "adm.lay.bays": "Bays",
  "adm.lay.levels": "Levels",
  "adm.lay.orientation": "Orientation",
  "adm.lay.shortOut": "Short side out",
  "adm.lay.longOut": "Long side out",
  "adm.lay.perBay": "Compartments per bay",
  "adm.lay.suggest": "Suggest: {n}",
  "adm.lay.generates": "Generates {n} bins",
  "adm.lay.inTree": "{n} in the tree",
  "adm.lay.overrides": "Bay exceptions (compartments per bay)",
  "adm.lay.unsaved": "unsaved changes",
  "adm.lay.map": "Map",
  "adm.lay.canvasHint.select": "Click an element to edit it, drag it to move. Wheel or pinch zooms, dragging empty canvas pans. The Rack, Area and Gate tools draw new ones by dragging a rectangle.",
  "adm.lay.zoomIn": "Zoom in",
  "adm.lay.zoomOut": "Zoom out",
  "adm.lay.zoomFit": "Fit",
  "adm.lay.canvasHint.draw": "Rack: drag from where bay 1 starts along the row; the length gives the bays, the size then follows the settings. Area and gate: drag the rectangle.",
  "adm.lay.pick.empty": "Load the plan with the button top right, or draw with the tools above the map.",
  "adm.lay.scale": "Scale",
  "adm.lay.scale.hint": "What one plan unit is in reality. A plan in model millimetres has 1 = 1.",
  "adm.lay.unit": "unit",
  "adm.lay.planSize": "Plan size",
  "adm.lay.pallet": "Pallet place",
  "adm.lay.marginWord": "margin",
  "adm.lay.long": "long",
  "adm.lay.deep": "deep",
  "adm.lay.aisle.hint": "Binding fills bays, levels and compartments from what the tree already knows about the aisle; adjust from there.",
  "adm.lay.boundElsewhere": "bound to another rack",
  "adm.lay.alsoOn": "also on {n} other rack",
  "adm.lay.bayStart": "first bay",
  "adm.lay.bayStartLabel": "First bay number",
  "adm.lay.grp.place": "Placement",
  "adm.lay.grp.size": "Measures",
  "adm.lay.grp.result": "Result",
  "adm.lay.continues": "{code} continues here from bay {from}.",
  "adm.lay.sharedAisle": "{code} is spread over several racks: bays {ranges}.",
  "adm.lay.inferred": "{code}: the tree says {bays} bays, {levels} levels and {per} compartments per bay, {diff} bays differ. Check the picture.",
  "adm.lay.bays.hint": "With the beams the rack becomes {len} m long.",
  "adm.lay.levels.hint": "Counted from the floor; bays with another count are set in the picture.",
  "adm.lay.orientation.hint": "The rack is {depth} mm deep in the plan: 1,200 means short side out, 800 long side out.",
  "adm.lay.perBay.hint": "With {face} mm facing the aisle and the margin, {n} fit on the beam.",
  "adm.lay.bindFirst": "Bind the rack to an aisle to see the codes.",
  "adm.lay.differing": "Differing bays: {bays}",
  "adm.lay.illustration": "How the rack will look",
  "adm.lay.view3d": "3D",
  "adm.lay.viewFront": "Front",
  "adm.lay.illustrationHint": "Bays from the left, levels from the floor, compartments from the left. In 3D: drag to turn, wheel zooms, right-drag pans. Click a bay to give it its own levels or compartments.",
  "adm.lay.type": "Rack type",
  "adm.lay.type.hint": "The type gives bay width, depth, post, height and levels; changing it sets the type's values. Types are set under Inställningar → Anläggning → Lagerlayout.",
  "adm.lay.levelHeights": "Level heights from the floor (mm)",
  "adm.lay.levelHeights.hint": "Comma-separated, one per level. Empty = the type's or even. Sum {sum} of {h} mm.",
  "adm.lay.levelHeights.bad": "Give {n} heights in mm, comma-separated, or leave empty.",
  "adm.set.layout.types": "Rack types",
  "adm.set.layout.types.hint": "Templates the racks in Layout point out. Fixed width = shelving; computed = pallet racks (pallets + margin).",
  "adm.set.layout.types.add": "New type",
  "adm.set.layout.types.holds.pallet": "Pallet",
  "adm.set.layout.types.holds.carton": "Carton",
  "adm.set.layout.types.width.computed": "Computed",
  "adm.set.layout.types.width.fixed": "Fixed",
  "adm.set.layout.types.cols": "Name|Holds|Width|mm|Comp.|Depth|Post|Height|Levels|Level heights|Pallets/bay",
  "adm.set.layout.types.pallets.hint": "How many pallets a compartment takes. Blank = 1 for pallet racks, no limit for shelving. 0 = no limit. Written on the places at publish.",
  "adm.lay.bayEdit": "Bay {n} — exceptions",
  "adm.lay.aisleSide": "the aisle is here · {face} mm of the pallet faces it",
  "adm.lay.aisleSide.plain": "the aisle is here",
  "adm.lay.clearOverride": "Remove the exception",
  "adm.lay.bay": "Bay {n}",
  "adm.lay.remove": "Remove element",
  "adm.lay.split": "Split into two racks",
  "adm.lay.split.hint": "A double row is two racks back to back facing their own aisles; each is bound on its own.",
  "adm.lay.split.done": "Split. Bind each half to its aisle.",
  "adm.lay.split.warn": "This is {depth} mm deep — probably a double row. Split it and bind the halves to their aisles.",
  "adm.lay.role": "Role",
  "adm.lay.role.receiving": "Receiving",
  "adm.lay.role.staging": "Staging",
  "adm.lay.role.packing": "Packing",
  "adm.lay.role.other": "Other area",
  "adm.lay.areaLocation": "Location in the tree",
  "adm.lay.label": "Label",
  "adm.lay.storageClass": "Storage class",
  "adm.lay.report.areaClass": "Area {code} gets storage class {cls}",
  "adm.lay.report.unchanged": "unchanged",
  "adm.lay.storageClass.hint": "Written on the bound location when the layout is published; everything below inherits it (cold room, food room).",
  "adm.counting": "Counting",
  "adm.cnt.sub": "rounds are planned here, counted on the phone and approved here before stock changes",
  "adm.cnt.new": "New round",
  "adm.cnt.plan": "Plan a round",
  "adm.cnt.plan.sub": "pick in the location tree: an aisle, a shelf, several aisles or a zone",
  "adm.cnt.plan.hint": "Locations lock one by one when someone opens them on the phone; several can count in one aisle. Approval here before anything is adjusted.",
  "adm.cnt.selected": "Selected",
  "adm.cnt.bins": "{n} locations",
  "adm.cnt.name": "Name",
  "adm.cnt.defaultName": "Count {date}",
  "adm.cnt.rule": "Quantity counted",
  "adm.cnt.rule.site": "The site's setting",
  "adm.cnt.start": "Start the round",
  "adm.cnt.round": "Round",
  "adm.cnt.progress": "Locations done",
  "adm.cnt.missingN": "{n} missing",
  "adm.cnt.none": "No round yet.",
  "adm.cnt.locks": "Locations under count right now",
  "adm.cnt.pick": "Choose a round on the left, or plan a new one.",
  "adm.cnt.detail.sub": "{done} of {total} locations done · started by {by}",
  "adm.cnt.k.done": "Locations done",
  "adm.cnt.k.present": "Containers confirmed",
  "adm.cnt.k.missing": "Missing",
  "adm.cnt.k.found": "Found",
  "adm.cnt.dev": "Deviation",
  "adm.cnt.container": "Container",
  "adm.cnt.means": "Means",
  "adm.cnt.dev.missing": "missing",
  "adm.cnt.dev.quantity": "other quantity",
  "adm.cnt.noneYet": "Nothing counted yet.",
  "adm.cnt.noDev": "No deviations.",
  "adm.cnt.counts": "Result",
  "adm.cnt.who": "Who · when",
  "adm.cnt.loc.counted": "Counted",
  "adm.cnt.loc.counting": "In progress",
  "adm.cnt.loc.pending": "Waiting",
  "adm.cnt.loc.counts": "{present} confirmed · {missing} missing · {found} found",
  "adm.cnt.approve": "Approve · {n} adjustments",
  "adm.cnt.approve.hint": "Missing containers are adjusted out and counted quantities set; the ERP gets the adjustments per lot.",
  "adm.cnt.approve.partial": "Not every location is counted. Approving now adjusts only what is counted; the rest is left.",
  "adm.cnt.approveConfirm": "Approve the round and make {n} stock adjustments?",
  "adm.cnt.approved": "Approved. {n} adjustments made.",
  "adm.cnt.cancel": "Cancel the round",
  "adm.cnt.cancelConfirm": "Cancel the round? Counted locations stay as observations; nothing is adjusted.",
  "adm.cnt.status.open": "Running",
  "adm.cnt.status.review": "To review",
  "adm.cnt.status.approved": "Approved",
  "adm.cnt.status.cancelled": "Cancelled",
  "adm.set.counting.quantity": "Quantity counted",
  "adm.set.counting.quantity.hint": "None: scanning suffices. Split containers: the quantity is asked for containers that were split. All: for every container.",
  "adm.set.counting.quantity.none": "None",
  "adm.set.counting.quantity.split": "Split containers",
  "adm.set.counting.quantity.all": "All",
  "adm.set.counting.adHoc": "Count a single location from the client",
  "adm.set.counting.adHoc.hint": "Without a round: the location in front of you.",
  "adm.set.counting.zeroPoint": "Zero point at pick",
  "adm.set.counting.zeroPoint.hint": "When the last known container leaves a location the picker confirms it is empty.",
  "adm.set.counting.zeroPoint.off": "Off",
  "adm.set.counting.zeroPoint.on": "On",
  "adm.set.counting.zeroPoint.storage": "Storage locations only",
  "adm.set.counting.lock": "Lock while counting",
  "adm.set.counting.lock.text": "Always: the location being counted takes no put-away and is not picked from until it is done.",
  "adm.set.counting.erpCountDate": "Count date to the ERP",
  "adm.set.counting.erpCountDate.hint": "The adapter writes counted quantity, date and who per batch row where the ERP has fields for it (Visma: per batch row).",
  "adm.set.sec.layout": "Layout",
  "adm.set.lead.layout": "the measures the layout tool counts with and how bins are named",
  "adm.set.layout.binCode": "Bin code",
  "adm.set.layout.binCode.hint": "The pattern a rack component names its bins with. {aisle}, {bay}, {level}, {compartment}.",
  "adm.set.layout.pallet": "Pallet place",
  "adm.set.layout.pallet.hint": "Long × short side and the margin between places; decides how many compartments a bay holds.",
  "adm.set.layout.beam": "Beam length",
  "adm.set.layout.beam.hint": "The length between two uprights. Empty = computed per bay: the pallets side by side plus the margin on each side (EN 15620: at least 75 mm below 3 m, 100 mm above). Give a value only if every beam is the same length.",
  "adm.set.layout.beam.auto": "computed",
  "adm.lay.beam": "Beam length",
  "adm.lay.beam.hint": "The site's beam is {site} mm; empty = that. Differing bays are set in the picture.",
  "adm.lay.beam.hint.auto": "Empty = computed: {per} pallets + {margin} mm margin each side = {beam} mm. Give a value if the beam is longer.",
  "adm.lay.beam.bad": "Enter 500–10,000 mm, or leave empty for the site's beam length.",
  "adm.lay.mismatch": "The plan says {plan} m, the bays give {cfg} m.",
  "adm.lay.fitBays": "Fit the bays to the plan",
  "adm.lay.fitRect": "Size the rectangle from the settings",
  "adm.lay.reverse": "Reverse the bay order",
  "adm.lay.reverse.hint": "Bay 1 at the other end (the dot on the map shows where bay 1 starts).",
  "adm.lay.rotate": "Rotate 90°",
  "adm.lay.sizedByConfig": "size follows the bays",
  "adm.set.layout.rackHeight": "Rack height",
  "adm.set.layout.rackHeight.hint": "Every rack is this tall unless the rack says otherwise; levels are spread evenly over it.",
  "adm.lay.height": "Height",
  "adm.lay.height.hint": "The site's height is {site} mm; empty = that. With this division each level is {pitch} mm.",
  "adm.lay.height.site": "Site's",
  "adm.lay.height.bad": "Enter 500–20,000 mm, or leave empty for the site's height.",
  "adm.lay.rackHeightWord": "height",
  "adm.lay.siteSettingsHint": "The measures are changed under Inställningar → Anläggning → Lagerlayout.",
  "adm.set.sec.counting": "Counting",
  "adm.set.sec.reasons": "Reason codes",
  "adm.set.lead.general": "the site, the receiving area and who may move goods",
  "adm.set.lead.identity": "how containers are recognised and what the label must carry, for every flow",
  "adm.set.lead.receiving": "flows on the phone, pallets and pallet labels",
  "adm.set.lead.putaway": "what put-away proposes and how strictly it applies",
  "adm.set.lead.pickList": "how the phone orders customer orders and which carriers collect when",
  "adm.set.lead.outPallet": "how outbound pallets are built and labelled while the picker walks",
  "adm.set.lead.counting": "rounds, approval and tolerances",
  "adm.set.pickList": "The pick list",
  "adm.set.outPallet": "The outbound pallet",
  "adm.set.counting.soon": "Comes with stock counting: count rounds, approval of differences and tolerances.",
  "adm.set.receivingLocation.hint": "Where received goods stand until put away.",
  "adm.set.defaultProfile.hint": "Applies to articles no assignment points out. Profiles and assignment are under Register → Handling profiles.",
  "adm.set.sites": "Sites",
  "adm.set.sites.hint": "One site per warehouse. Name, address and GLN are edited here once the sites page is built.",
  "adm.set.companyRules": "Rules for every site",
  "adm.set.companyRules.soon": "Comes with profiles in levels: the company's default profile, which division points out profiles, and the lock towards lower levels.",
  "adm.prof.assignLead": "Articles without an assignment get the site's default profile {profile}. The division is the product category today; which field drives it becomes a company choice.",
  "adm.prof.byDimension": "{dimension} → profile · the levels below may differ where it is open",
  "adm.prof.assignLead2": "The chain: company default ({company}) → site default ({site}) → {dimension} → article. Every level can lock the levels below. The divisions and their order are chosen under Settings → Company.",
  "adm.prof.chainStep": "Step {n} of the chain: applies only to articles {prev} passed on (a value without a rule, or a rule that allows lower levels).",
  "adm.prof.passOn": "Pass on to {next}",
  "adm.prof.reach": "{reach} of {n}",
  "adm.prof.reachHint": "{n} articles are already locked by an earlier step of the chain and are not reached by this rule.",
  "adm.prof.articlesMay": "Articles may differ",
  "adm.prof.locked": "locked",
  "adm.prof.lockedByCompany": "The company's default profile is locked for lower levels. Open it under Settings → Company to point out profiles here.",
  "adm.prof.lockedBySite": "The site's default profile is locked for lower levels. Open it under Settings → Site → Identity and lots.",
  "adm.set.lead.companyRules": "the profile is the only thing set; the levels point it out",
  "adm.set.companyDefault.hint": "Applies across the company where no lower level points out another profile.",
  "adm.set.allowBelow": "Lower levels may change",
  "adm.set.allowBelow.company.hint": "No: site, division and article may not point out another profile. Default is No.",
  "adm.set.allowBelow.site.hint": "No: the division's rules and the articles may not differ from the site's default profile.",
  "adm.set.dimension": "Divisions that point out profiles, in order",
  "adm.set.dimension.hint": "Article fields from the registry below, tried in turn: a value without a rule passes the decision on, a rule may lock what follows. The assignment per value is made under Register → Handling profiles.",
  "adm.set.dimension.add": "Add a division …",
  "adm.set.dimension.up": "Move up",
  "adm.set.dimension.down": "Move down",
  "adm.set.dimension.none": "None, per article only",
  "adm.set.dimension.values": "values",
  "adm.set.dimension.key": "Key",
  "adm.set.dimension.source": "Source",
  "erp.refreshing": "Fetching changes from the ERP …",
  "erp.readingOrder": "Reading order {ref} from the ERP …",
  "erp.fetchingOrder": "Order {ref} is not here yet. Fetching from the ERP …",
  "erp.fetchingRow": "Not here yet · fetching from the ERP …",
  "erp.orderNotInErp": "No open purchase order {ref} in the ERP.",
  "erp.orderNotInErp.sales": "No order {ref} among today's orders in the ERP.",
  "erp.orderOutsideRule": "Order {ref} exists in the ERP but is not confirmed for today.",
  "erp.orderChanged": "The ERP changed the order",
  "erp.locked": "The order is open in the ERP",
  "erp.lockedTag": "Locked in the ERP",
  "erp.lockedMsg": "Order {ref} is open in the ERP (process {process} {by}). Nothing can be picked or received until whoever has it open closes it.",
  "erp.orderChanged.msg": "The lines were re-read. Check what you are working on.",
  "erp.notReached": "The ERP did not answer",
  "erp.notReached.msg": "Showing the order as last read.",
  "adm.set.erp.lineGtin": "GTIN on order lines comes from",
  "adm.set.erp.lineGtin.hint": "The article register: the article's own GTIN in Trail applies, the line's value is ignored. The order line: the ERP's value on the line when it has one, else the register.",
  "adm.set.erp.lineGtin.register": "The article register",
  "adm.set.erp.lineGtin.line": "The order line",
  "adm.set.erp.refreshBeforeWork": "Re-read the order before work",
  "adm.set.erp.refreshBeforeWork.hint": "Before receiving or picking starts, the order is read from the ERP again; the operator waits a few seconds and the order is current.",
  "erp.updated": "ERP read at {time}",
  "adm.set.erp": "ERP",
  "adm.set.lead.erp": "the mirror runs in the site agent on the company's order; switch it on here and see every run",
  "adm.set.erp.bundle": "Adapter",
  "adm.set.erp.every": "Every",
  "adm.set.erp.minutes": "{n} min",
  "adm.set.erp.lastRun": "Last run",
  "adm.set.erp.result": "{docs} documents · {created} new, {updated} changed, {unchanged} unchanged, {errors} errors",
  "adm.set.erp.took": "{s} s",
  "adm.set.erp.ok": "Running",
  "adm.set.erp.partial": "Partly failed",
  "adm.set.erp.failed": "Failed",
  "adm.set.erp.waiting": "Waiting for the first run",
  "adm.set.erp.off": "Paused",
  "adm.set.erp.pause": "Pause",
  "adm.set.erp.resume": "Resume",
  "adm.set.erp.removeConfirm": "Remove the duty? The agent stops mirroring for this company.",
  "adm.set.erp.add": "Switch mirroring on",
  "adm.set.erp.addMore": "Add another mirror",
  "adm.set.erp.readAll": "Re-read everything now",
  "adm.set.erp.readAll.hint": "Requests a complete read of registers, orders and balances at the next run, besides the daily one.",
  "adm.set.erp.readAll.requested": "Complete read requested. The agent takes it within a minute; the result shows on the row.",
  "adm.set.erp.readAll.pending": "A request is already waiting.",
  "adm.set.erp.readAll.fresh": "The agent ran just now; try again in a moment.",
  "adm.set.erp.start": "Start",
  "adm.set.erp.saved": "Saved.",
  "adm.set.erp.rules": "Rules",
  "adm.set.erp.rulesTitle": "Rules for {bundle} on {host}",
  "adm.set.erp.rulesHint": "The adapter's defaults are shown greyed. Edit a block to give the company's own values (JSON); they replace the block at the next run. The company block carries the ERP's company number and acting user for this duty; the connection is set on the agent machine.",
  "adm.set.erp.rules.own": "own values",
  "adm.set.erp.held": "Held: {n} cancellations wait for a decision under Deviations.",
  "adm.scope.title": "Which orders Trail reads from the ERP",
  "adm.scope.sub": "the rule decides what is pickable and receivable · the floor how far back the full read looks",
  "adm.scope.salesOrders": "Sales orders",
  "adm.scope.purchaseOrders": "Purchase orders",
  "adm.scope.rule": "Rule",
  "adm.scope.kind.confirmed-today": "Confirmed for today",
  "adm.scope.kind.confirmed-by-today": "Confirmed up to today",
  "adm.scope.kind.flag": "Flag in the ERP",
  "adm.scope.kind.open": "All with something left",
  "adm.scope.ruleHint.salesOrders": "Open = the lines have something left to pick. The ERP's finish date is not used: it is filled at a partial delivery.",
  "adm.scope.ruleHint.purchaseOrders": "Open = the lines have something left to receive.",
  "adm.scope.floor": "Read orders dated from",
  "adm.scope.floor.days": "Days back",
  "adm.scope.floor.date": "Fixed date",
  "adm.scope.floor.none": "No floor",
  "adm.scope.floor.notForToday": "Not used here: the rule reads only orders confirmed for today.",
  "adm.scope.daysBack": "days",
  "adm.scope.own": "the company's own value",
  "adm.scope.default": "package default",
  "adm.scope.floorHint": "Compared against {col}. Created and changed dates are not used; the change stamp only drives the delta reads. Without a floor the full read covers the whole order register.",
  "adm.scope.col.orderDate": "order date",
  "adm.scope.col.deliveryDate": "confirmed delivery date",
  "adm.scope.now": "Right now",
  "adm.scope.now.bad": "The floor excludes {n} open orders",
  "adm.scope.now.loading": "Counting against the mirror …",
  "adm.scope.now.noFloor": "No floor. Trail has {open} open; all are read.",
  "adm.scope.now.ok": "Orders dated from {from}. Trail has {open} open, all within the floor.",
  "adm.scope.now.badText": "The floor {from} is after the {col} of open orders ({min} – {max}). The next full read would want to cancel them; the cancellation guard holds that for a decision. Set a fixed date before {min}, or choose No floor.",
  "adm.scope.now.missing": "{n} open orders have no order date in the mirror yet (filled at the next run).",
  "adm.set.cancelGuard": "Cancellation guard · orders per run",
  "adm.set.cancelGuard.hint": "When a read says that many open orders are no longer in the ERP, they are not cancelled: they are held, the orders stay open, and the decision sits under Deviations. Below the limit they are cancelled as usual.",
  "adm.set.cancelGuard.moreThan": "more than",
  "adm.set.cancelGuard.orShare": "orders, or more than",
  "adm.set.cancelGuard.ofOpen": "% of the open ones",
  "dev.erpCancelHeld": "Cancellation held by the guard",
  "adm.dev.hold.changeFloor": "Change the floor",
  "adm.dev.hold.changeFloor.hint": "Settings → Company → ERP → Rules",
  "adm.dev.hold.reread": "Re-read",
  "adm.dev.hold.rereadRequested": "A full read is requested. If it lists the orders again the deviation closes by itself.",
  "adm.dev.hold.dismiss": "Keep open",
  "adm.dev.hold.apply": "Cancel {n} orders",
  "adm.dev.hold.applyConfirm": "Cancel {n} orders in Trail? They re-open if the ERP lists them again.",
  "adm.set.erp.rules.default": "default",
  "adm.set.erp.rules.reset": "Back to default",
  "adm.set.erp.rules.edit": "Edit",
  "adm.set.erp.none": "No mirroring switched on. The agent reads the ERP and sends registers, orders and balances here on a schedule.",
  "adm.set.erp.noBundles": "The server ships no adapter.",
  "adm.set.erp.noAgent": "Register a site agent in this company first (System → Platsagenter).",
  "adm.set.erp.hint": "The agent fetches the adapter signed from the server, runs it with its own credential for the company and reports here.",
  "adm.set.dimensions": "Divisions",
  "adm.set.lead.dimensions": "article fields the ERP or Trail fills; the adapter maps its fields onto them",
  "adm.set.dimensions.none": "No divisions yet. The product import creates them.",
  "adm.set.notSet": "Not set",
  "adm.set.applies": "Applies",
  "adm.set.applies.company": "{profile}, set on the company · {lock}",
  "adm.set.applies.open": "lower levels may differ",
  "adm.set.applies.locked": "locked for site, division and article",
  "adm.set.applies.none": "No company profile; the site's default profile applies.",
  "adm.set.uniqueLot": "Lot number unique per product",
  "adm.set.uniqueLot.hint": "Yes: a lot number is one carton. Receiving refuses the same number again, and duplicates in the ERP become a deviation when mirrored.",
  "settings.health": "Page open {min} min · {n} stalls over 2 s in the last hour, longest {worst} s · memory {mem}. If the app gets slow, read this before restarting.",
  "adm.gt.noPrefix": "No GS1 company prefix is set for the goods owner. The prefix is on the GS1 licence (4–12 digits) and decides which GTINs and SSCCs Trail may form.",
  "adm.gt.prefix": "GS1 company prefix",
  "adm.gt.prefix.save": "Save prefix",
  "adm.gt.prefix.change": "Change prefix",
  "adm.gt.prefix.saved": "Prefix {prefix} is set.",
  "adm.gt.prefix.warn": "Changing the prefix leaves assigned numbers as they are; new numbers are formed under the new prefix.",
  "login.chooseTenant": "Which company?",
  "login.chooseTenantSub": "You can switch company later from the menu.",
  "login.tenant": "Company",
  "login.switching": "Switching company …",
  "login.failed": "Wrong e-mail or password.",
  "login.badCode": "Wrong code. Try again.",
  "login.entraFailed": "Microsoft sign-in failed.",
  "login.devSettings": "Developer settings",
  "shift.title": "Start shift",
  "shift.sub": "{device} · enter your code or scan your badge",
  "shift.code": "Code",
  "shift.start": "Start",
  "shift.failed": "Unknown code or badge.",
  "shift.end": "End shift",
  "shift.loggedIn": "Signed in: {name}",
  "enrol.title": "Enrol device",
  "enrol.scan": "Scan enrolment code",
  "enrol.qrHint": "Point the camera at the QR code on the computer screen",
  "enrol.code": "Or type the enrolment code",
  "enrol.codePlaceholder": "the code from Devices & users",
  "enrol.enter": "Enrol",
  "enrol.done": "This device is enrolled as {name}.",
  "enrol.failed": "The code is invalid or has expired.",
  "enrol.device": "Device: {name} ({role})",
  "enrol.none": "This device is not enrolled. Ask the administrator for an enrolment code.",
  "settings.advanced": "Developer settings (API token)",
  "settings.scanSetup": "Scan setup code",
  "settings.setupDone": "API key and tenant taken from the code. Enter your name and save.",
  "resume.title": "A pallet is half scanned ({n} scans)",
  "resume.resume": "Resume",
  "resume.discard": "Discard",
  "queue.discard": "Discard the rejected pallet",
  "queue.discardConfirm": "The rejected pallet's scans are lost. Discard?",
};

const TABLES: Record<Lang, Record<Key, string>> = { sv, en };
const LANG_KEY = "trail.lang";

export function getLang(): Lang {
  try {
    const v = localStorage.getItem(LANG_KEY);
    return v === "en" ? "en" : "sv";
  } catch {
    return "sv";
  }
}

export function setLang(l: Lang): void {
  try {
    localStorage.setItem(LANG_KEY, l);
  } catch {
    /* ignore */
  }
}

export function t(key: Key, vars: Record<string, string | number> = {}): string {
  let s: string = TABLES[getLang()][key] ?? sv[key];
  for (const [k, v] of Object.entries(vars)) s = s.split(`{${k}}`).join(String(v));
  return s;
}

const nf = new Intl.NumberFormat("sv-SE", { maximumFractionDigits: 2 });

/** UN/ECE Rec 20 unit codes as an operator reads them. */
export function uomLabel(uom: string): string {
  switch (uom) {
    case "MTR":
      return "m";
    case "KGM":
      return "kg";
    case "EA":
      return "st";
    case "LTR":
      return "l";
    default:
      return uom;
  }
}

export function fmtQty(value: string | number, uom: string): string {
  return `${nf.format(Number(value))} ${uomLabel(uom)}`;
}

export function fmtNum(value: string | number): string {
  return nf.format(Number(value));
}
